<template>
<VUEModalCaricamentoDati v-if="CaricamentoDatiModuli"
                        :PathGif="require('@/assets/images/CaricamentoDatiGif.gif')"
                        :VisualizzaBottoneAnnulla="true"
                        :OggettoModalCaricamentoDati="OggettoModalCaricamentoDati"
                        @onClickAnnullaCaricamentoDati="OnClickAnnullaCaricamentoDati"/>

<VUEModal v-if="PopupConfigurazione" :Titolo="this.GetTraduzioneLabel('VUEAppContentGraficiStorici','TKN_APP_CON_GRAF_STO_IMP_LV',this.LinguaUtente)" Altezza="250px" Larghezza="400px" :PathLogo="require('@/assets/images/LogoDMS.png')" :Programma="'DMSEW'"
            @onClickChiudiModal="AnnullaPopupConfigurazione()">
  <template v-slot:Body> 
    <div style="margin-bottom: 20px; width: 100%; display: flex;">
        <div class="form-control ZMPopupSelectionTab" style="width:50%; height: 35px; vertical-align: middle" :style="ShowTabAmpiezza ? {'background-color' : ColoriSfondo.Arancione, 'color' : 'white'} : {}" @click="ShowTabAmpiezza = true">{{ this.GetTraduzioneLabel('Generic','TKN_AMPIEZZA',this.LinguaUtente) }}</div>
        <div class="form-control ZMPopupSelectionTab" style="width:50%; height: 35px; vertical-align: middle" :style="!ShowTabAmpiezza ? {'background-color' : ColoriSfondo.Arancione, 'color' : 'white'} : {}" @click="ShowTabAmpiezza = false">{{ this.GetTraduzioneLabel('Generic','TKN_FREQUENZA',this.LinguaUtente) }}</div>
      </div>
    <div style="font-size:14px; display: flex; width: 100%;justify-content: center;">
      <div style="margin: 10px; display:flex; width: 70%">
        <div v-if="ShowTabAmpiezza" style="width: 100%; display:flex; flex-flow: column wrap">
          <div class="ZMPopupColorsRow" style="justify-content: space-between; height: 34px">
            <label style="margin: 0px">{{ this.GetTraduzioneLabel('VUEAppContentGraficiStorici','TKN_APP_CON_GRAF_STO_LV0',this.LinguaUtente) }}</label>
            <span style="width: 25px; height: 25px" :style="{'background-color' : ColoriAllarme.Livello0}"></span>
          </div>
          <div class="ZMPopupColorsRow" style="justify-content: space-between;">
            <label style="margin: 0px; margin-right: 10px">{{ this.GetTraduzioneLabel('VUEAppContentGraficiStorici','TKN_APP_CON_GRAF_STO_LV1',this.LinguaUtente) }} [{{ this.GetTraduzioneLabel('UdmGenerali','TKN_MILLIGRAMMO',this.LinguaUtente) }}]</label>
            <input type="number" class="form-control" style="width:95px; margin-right: 10px" v-model="LivelliAllarme.TempAmpiezza.Primo"/>
            <span style="width: 25px; height: 25px" :style="{'background-color' : ColoriAllarme.Livello1}"></span>
          </div>
          <div class="ZMPopupColorsRow" style="justify-content: space-between;">
            <label style="margin: 0px; margin-right: 10px">{{ this.GetTraduzioneLabel('VUEAppContentGraficiStorici','TKN_APP_CON_GRAF_STO_LV2',this.LinguaUtente) }} [{{ this.GetTraduzioneLabel('UdmGenerali','TKN_MILLIGRAMMO',this.LinguaUtente) }}]</label>
            <input type="number" class="form-control" style="width:95px; margin-right: 10px" v-model="LivelliAllarme.TempAmpiezza.Secondo"/>
            <span style="width: 25px; height: 25px" :style="{'background-color' : ColoriAllarme.Livello2}"></span>
          </div>
          <div class="ZMPopupColorsRow" style="justify-content: space-between;">
            <label style="margin: 0px; margin-right: 10px">{{ this.GetTraduzioneLabel('VUEAppContentGraficiStorici','TKN_APP_CON_GRAF_STO_LV3',this.LinguaUtente) }} [{{ this.GetTraduzioneLabel('UdmGenerali','TKN_MILLIGRAMMO',this.LinguaUtente) }}]</label>
            <input type="number" class="form-control" style="width:95px; margin-right: 10px" v-model="LivelliAllarme.TempAmpiezza.Terzo"/>
            <span style="width: 25px; height: 25px" :style="{'background-color' : ColoriAllarme.Livello3}"></span>
          </div>
        </div>
        <div v-else style="width: 100%; display:flex; flex-flow: column wrap">
          <div class="ZMPopupColorsRow" style="justify-content: space-between; height: 34px">
            <label style="margin: 0px">{{ this.GetTraduzioneLabel('VUEAppContentGraficiStorici','TKN_APP_CON_GRAF_STO_LV0',this.LinguaUtente) }}</label>
            <span style="width: 25px; height: 25px" :style="{'background-color' : ColoriAllarme.Livello0}"></span>
          </div>
          <div class="ZMPopupColorsRow" style="justify-content: space-between;">
            <label style="margin: 0px; margin-right: 10px">{{ this.GetTraduzioneLabel('VUEAppContentGraficiStorici','TKN_APP_CON_GRAF_STO_LV1',this.LinguaUtente) }}</label>
            <input type="number" class="form-control" style="width:95px; margin-right: 10px" v-model="LivelliAllarme.TempFrequenza.Primo"/>
            <span style="width: 25px; height: 25px" :style="{'background-color' : ColoriAllarme.Livello1}"></span>
          </div>
          <div class="ZMPopupColorsRow" style="justify-content: space-between;">
            <label style="margin: 0px; margin-right: 10px">{{ this.GetTraduzioneLabel('VUEAppContentGraficiStorici','TKN_APP_CON_GRAF_STO_LV2',this.LinguaUtente) }}</label>
            <input type="number" class="form-control" style="width:95px; margin-right: 10px" v-model="LivelliAllarme.TempFrequenza.Secondo"/>
            <span style="width: 25px; height: 25px" :style="{'background-color' : ColoriAllarme.Livello2}"></span>
          </div>
          <div class="ZMPopupColorsRow" style="justify-content: space-between;">
            <label style="margin: 0px; margin-right: 10px">{{ this.GetTraduzioneLabel('VUEAppContentGraficiStorici','TKN_APP_CON_GRAF_STO_LV3',this.LinguaUtente) }}</label>
            <input type="number" class="form-control" style="width:95px; margin-right: 10px" v-model="LivelliAllarme.TempFrequenza.Terzo"/>
            <span style="width: 25px; height: 25px" :style="{'background-color' : ColoriAllarme.Livello3}"></span>
          </div>
        </div>
      </div>
    </div>
  </template>
  <template v-slot:Footer>
    <button type="button" class="btn btn-danger" style="float:right;margin-left:10px;font-weight:bold;width:25%" @click="AnnullaPopupConfigurazione()" data-dismiss="modal">{{ this.GetTraduzioneLabel('Generic','TKN_ANNULLA',this.LinguaUtente) }}</button>
    <button v-if="CheckValoreSoglie" type="button" class="btn btn-success" style="float:right;font-weight:bold;width:25%" @click="ConfermaPopupConfigurazione()" data-dismiss="modal">{{ this.GetTraduzioneLabel('Generic','TKN_CONFERMA',this.LinguaUtente) }}</button>
  </template>
</VUEModal>
<VUEModal v-if="PopupAsseY" :Titolo="this.GetTraduzioneLabel('Generic','TKN_IMP_ASSE_Y',this.LinguaUtente)" Altezza="150px" Larghezza="500px" :PathLogo="require('@/assets/images/LogoDMS.png')" :Programma="'DMSEW'"
            @onClickChiudiModal="AnnullaPopupAsseY()">
  <template v-slot:Body>
    <div style="display: flex; flex-flow: column wrap; padding-left: 50px; padding-right: 50px">
      <div style="font-size:14px; display: flex; flex-flow: row wrap; align-content: center; justify-content: center; align-items: center; margin-bottom: 5px;">
        <p style="width: 40%; margin: 0px; font-weight: bold">{{ this.GetTraduzioneLabel('Generic','TKN_MINIMO',this.LinguaUtente) }}</p>
        <input class="form-control" style="width:30%; text-align: right;" type="number" step="1" v-model="ObjPopupAsseY.Min">
      </div>
      <div style="font-size:14px; display: flex; flex-flow: row wrap; align-content: center; justify-content: center; align-items: center; margin-bottom: 5px;">
        <p style="width: 40%; margin: 0px; font-weight: bold">{{ this.GetTraduzioneLabel('Generic','TKN_MASSIMO',this.LinguaUtente) }}</p>
        <input class="form-control" style="width:30%; text-align: right;" type="number" step="1" v-model="ObjPopupAsseY.Max">
      </div>
      <div style="font-size:14px; display: flex; flex-flow: row wrap; align-content: center; justify-content: center; align-items: center;">
        <p style="width: 40%; margin: 0px; font-weight: bold">{{ this.GetTraduzioneLabel('Generic','TKN_UNITA_PRINCIPALE',this.LinguaUtente) }}</p>
        <input class="form-control" style="width:30%; text-align: right;" type="number" step="1" v-model="ObjPopupAsseY.Udm">
      </div>
    </div>
  </template>
  <template v-slot:Footer>
    <button type="button" class="btn btn-danger" style="float:right;margin-left:10px;font-weight:bold;width:25%" @click="AnnullaPopupAsseY()" data-dismiss="modal">{{ this.GetTraduzioneLabel('Generic','TKN_ANNULLA',this.LinguaUtente) }}</button>
    <button type="button" class="btn btn-success" style="float:right;font-weight:bold;width:25%" @click="ConfermaPopupAsseY()" data-dismiss="modal">{{ this.GetTraduzioneLabel('Generic','TKN_CONFERMA',this.LinguaUtente) }}</button>
  </template>
</VUEModal>

<VUEModal v-if="PopupAsseX" :Titolo="this.GetTraduzioneLabel('Generic','TKN_IMP_ASSE_X',this.LinguaUtente)" Altezza="150px" Larghezza="500px" :PathLogo="require('@/assets/images/LogoDMS.png')" :Programma="'DMSEW'"
            @onClickChiudiModal="AnnullaPopupAsseX()">
  <template v-slot:Body>
    <div style="display: flex; flex-flow: column wrap; padding-left: 50px; padding-right: 50px">
      <div style="font-size:14px; display: flex; flex-flow: row wrap; align-content: center; justify-content: center; align-items: center;">
        <p style="margin: 0 5px 0 0; font-weight: bold">{{ this.GetTraduzioneLabel('UdmGenerali','TKN_UDM',this.LinguaUtente) }}</p>
        <input class="form-control" style="width:30%; text-align: right;" type="number" step="1" v-model="UdmX">
        <p style="margin: 0 0 0 5px; font-weight: bold">{{ this.GetTraduzioneLabel('UdmGenerali','TKN_ORE',this.LinguaUtente) }}</p>
      </div>
    </div>
  </template>
  <template v-slot:Footer>
    <button type="button" class="btn btn-danger" style="float:right;margin-left:10px;font-weight:bold;width:25%" @click="AnnullaPopupAsseX()" data-dismiss="modal">{{ this.GetTraduzioneLabel('Generic','TKN_ANNULLA',this.LinguaUtente) }}</button>
    <button type="button" class="btn btn-success" style="float:right;font-weight:bold;width:25%" @click="ConfermaPopupAsseX()" data-dismiss="modal">{{ this.GetTraduzioneLabel('Generic','TKN_CONFERMA',this.LinguaUtente) }}</button>
  </template>
</VUEModal>

<VUEModal v-if="PopupAdattamentoAsseX" :Titolo="this.GetTraduzioneLabel('Generic','TKN_IMP_TEMP_ASSE_X',this.LinguaUtente)" :Altezza="'80px'" :Larghezza="'500px'" :PathLogo="require('@/assets/images/LogoDMS.png')" :Programma="'DMSEW'"
              @onClickChiudiModal="PopupAdattamentoAsseX = false">
  <template v-slot:Body>
    <div style="display: flex; flex-flow: row wrap; align-items: center; justify-content: space-between; height: 100%; padding-left: 30px; padding-right: 30px;">
      <div style="width: 25%">
        <input class="form-control" type="number" style="margin: 0px; width: 70%;" v-model="Allineamento.AxisX.UdmX"/>
      </div>
      <div style="">
        <label style="margin: 0px; font-weight: bold;">{{ this.GetTraduzioneLabel('UdmGenerali','TKN_GIORNI',this.LinguaUtente) }}</label>
        <input type="radio" id="RadioGiorni" name="RadioUdmX" style="margin: 0px; margin-left: 10px" :value="TipiUdmX.Giorni" v-model="Allineamento.AxisX.TipoUdmX"/>
      </div>
      <div style="">
        <label style="margin: 0px; font-weight: bold">{{ this.GetTraduzioneLabel('UdmGenerali','TKN_ORE',this.LinguaUtente) }}</label>
        <input type="radio" id="RadioOre" name="RadioUdmX" style="margin: 0px; margin-left: 10px" :value="TipiUdmX.Ore" v-model="Allineamento.AxisX.TipoUdmX"/>
      </div>
      <div style="">
        <label style="margin: 0px; font-weight: bold">{{ this.GetTraduzioneLabel('UdmGenerali','TKN_MINUTI',this.LinguaUtente) }}</label>
        <input type="radio" id="RadioMinuti" name="RadioUdmX" style="margin: 0px; margin-left: 10px" :value="TipiUdmX.Minuti" v-model="Allineamento.AxisX.TipoUdmX"/>
      </div>
    </div> 
  </template>
  <template v-slot:Footer>
    <button type="button" class="btn btn-danger" style="float:right;margin-left:10px;font-weight:bold;width:25%" @click="PopupAdattamentoAsseX = false" data-dismiss="modal">{{ this.GetTraduzioneLabel('Generic','TKN_ANNULLA',this.LinguaUtente) }}</button>
    <button type="button" class="btn btn-success" style="float:right;font-weight:bold;width:25%" @click="ChangeAdattamentoAsseX()" data-dismiss="modal">{{ this.GetTraduzioneLabel('Generic','TKN_CONFERMA',this.LinguaUtente) }}</button>
  </template>
</VUEModal>
<VUEModal v-if="PopupAdattamentoAsseY" :Titolo="this.GetTraduzioneLabel('Generic','TKN_IMP_ASSE_Y',this.LinguaUtente)" Altezza="150px" Larghezza="500px" :PathLogo="require('@/assets/images/LogoDMS.png')" :Programma="'DMSEW'"
            @onClickChiudiModal="PopupAdattamentoAsseY = false">
  <template v-slot:Body>      
    <div style="display: flex; flex-flow: column wrap; padding-left: 50px; padding-right: 50px">
      <div style="font-size:14px; display: flex; flex-flow: row wrap; align-content: center; justify-content: center; align-items: center; margin-bottom: 5px;">
        <p style="width: 30%; margin: 0px; font-weight: bold">{{ this.GetTraduzioneLabel('Generic','TKN_MINIMO',this.LinguaUtente) }}</p>
        <input class="form-control" style="width:30%; text-align: right;" type="number" step="1" v-model="Allineamento.AxisY.Min">
        <p style="width: 20%; margin: 0px; margin-left: 10px; font-weight: bold">{{ UdmAdattamento ? UdmAdattamento : '' }}</p>
      </div>
      <div style="font-size:14px; display: flex; flex-flow: row wrap; align-content: center; justify-content: center; align-items: center; margin-bottom: 5px;">
        <p style="width: 30%; margin: 0px; font-weight: bold">{{ this.GetTraduzioneLabel('Generic','TKN_MASSIMO',this.LinguaUtente) }}</p>
        <input class="form-control" style="width:30%; text-align: right;" type="number" step="1" v-model="Allineamento.AxisY.Max">
        <p style="width: 20%; margin: 0px; margin-left: 10px; font-weight: bold">{{ UdmAdattamento ? UdmAdattamento : ''  }}</p>
      </div>
      <div style="font-size:14px; display: flex; flex-flow: row wrap; align-content: center; justify-content: center; align-items: center;">
        <p style="width: 30%; margin: 0px; font-weight: bold">{{ this.GetTraduzioneLabel('Generic','TKN_UNITA_PRINCIPALE',this.LinguaUtente) }}</p>
        <input class="form-control" style="width:30%; text-align: right;" type="number" step="1" v-model="Allineamento.AxisY.Udm">
        <p style="width: 20%; margin: 0px; margin-left: 10px; font-weight: bold">{{ UdmAdattamento ? UdmAdattamento : ''  }}</p>
      </div>
    </div>
  </template>
  <template v-slot:Footer>
    <button type="button" class="btn btn-danger" style="float:right;margin-left:10px;font-weight:bold;width:25%" @click="PopupAdattamentoAsseY = false" data-dismiss="modal">{{ this.GetTraduzioneLabel('Generic','TKN_ANNULLA',this.LinguaUtente) }}</button>
    <button type="button" class="btn btn-success" style="float:right;font-weight:bold;width:25%" @click="ChangeAdattamentoAsseY()" data-dismiss="modal">{{ this.GetTraduzioneLabel('Generic','TKN_CONFERMA',this.LinguaUtente) }}</button>
  </template>
</VUEModal>
<VUEModal v-if="PopupAdattamentoAsseInclinazioni" :Titolo="this.GetTraduzioneLabel('Generic','TKN_IMP_ASSE_INCLINAZIONI',this.LinguaUtente)" Altezza="150px" Larghezza="500px" :PathLogo="require('@/assets/images/LogoDMS.png')" :Programma="'DMSEW'"
            @onClickChiudiModal="PopupAdattamentoAsseInclinazioni = false">
  <template v-slot:Body>      
    <div style="display: flex; flex-flow: column wrap; padding-left: 50px; padding-right: 50px">
      <div style="font-size:14px; display: flex; flex-flow: row wrap; align-content: center; justify-content: center; align-items: center; margin-bottom: 5px;">
        <p style="width: 40%; margin: 0px; font-weight: bold">{{ this.GetTraduzioneLabel('Generic','TKN_MINIMO',this.LinguaUtente) }}</p>
        <input class="form-control" style="width:30%; text-align: right;" type="number" step="1" v-model="Allineamento.AxisY.Min">
        <p style="width: 20%; margin: 0px; margin-left: 10px; font-weight: bold">{{ UdmAdattamento ? UdmAdattamento : '' }}</p>
      </div>
      <div style="font-size:14px; display: flex; flex-flow: row wrap; align-content: center; justify-content: center; align-items: center; margin-bottom: 5px;">
        <p style="width: 40%; margin: 0px; font-weight: bold">{{ this.GetTraduzioneLabel('Generic','TKN_MASSIMO',this.LinguaUtente) }}</p>
        <input class="form-control" style="width:30%; text-align: right;" type="number" step="1" v-model="Allineamento.AxisY.Max">
        <p style="width: 20%; margin: 0px; margin-left: 10px; font-weight: bold">{{ UdmAdattamento ? UdmAdattamento : ''  }}</p>
      </div>
      <div style="font-size:14px; display: flex; flex-flow: row wrap; align-content: center; justify-content: center; align-items: center;">
        <p style="width: 40%; margin: 0px; font-weight: bold">{{ this.GetTraduzioneLabel('Generic','TKN_UNITA_PRINCIPALE',this.LinguaUtente) }}</p>
        <input class="form-control" style="width:30%; text-align: right;" type="number" step="1" v-model="Allineamento.AxisY.Udm">
        <p style="width: 20%; margin: 0px; margin-left: 10px; font-weight: bold">{{ UdmAdattamento ? UdmAdattamento : ''  }}</p>
      </div>
    </div>
  </template>
  <template v-slot:Footer>
    <button type="button" class="btn btn-danger" style="float:right;margin-left:10px;font-weight:bold;width:25%" @click="PopupAdattamentoAsseInclinazioni = false" data-dismiss="modal">{{ this.GetTraduzioneLabel('Generic','TKN_ANNULLA',this.LinguaUtente) }}</button>
    <button type="button" class="btn btn-success" style="float:right;font-weight:bold;width:25%" @click="ChangeAdattamentoInclinometri()" data-dismiss="modal">{{ this.GetTraduzioneLabel('Generic','TKN_CONFERMA',this.LinguaUtente) }}</button>
  </template>
</VUEModal>
<VUEModal v-if="PopupChangeScalaXAccelerometri" :Titolo="this.GetTraduzioneLabel('Generic','TKN_IMP_ASSE_X',this.LinguaUtente)" Altezza="150px" Larghezza="500px" :PathLogo="require('@/assets/images/LogoDMS.png')" :Programma="'DMSEW'"
            @onClickChiudiModal="PopupChangeScalaXAccelerometri = false">
  <template v-slot:Body>
    <div style="display: flex; flex-flow: row wrap; align-items: center; justify-content: space-between; height: 100%; padding-left: 30px; padding-right: 30px;">
      <div style="width: 25%">
        <input class="form-control" type="number" style="margin: 0px; width: 70%;" v-model="Allineamento.AxisX.UdmX"/>
      </div>
      <div style="">
        <label style="margin: 0px; font-weight: bold;">{{ this.GetTraduzioneLabel('UdmGenerali','TKN_GIORNI',this.LinguaUtente) }}</label>
        <input type="radio" id="RadioGiorni" name="RadioUdmX" style="margin: 0px; margin-left: 10px" :value="TipiUdmX.Giorni" v-model="Allineamento.AxisX.TipoUdmX"/>
      </div>
      <div style="">
        <label style="margin: 0px; font-weight: bold">{{ this.GetTraduzioneLabel('UdmGenerali','TKN_ORE',this.LinguaUtente) }}</label>
        <input type="radio" id="RadioOre" name="RadioUdmX" style="margin: 0px; margin-left: 10px" :value="TipiUdmX.Ore" v-model="Allineamento.AxisX.TipoUdmX"/>
      </div>
      <div style="">
        <label style="margin: 0px; font-weight: bold">{{ this.GetTraduzioneLabel('UdmGenerali','TKN_MINUTI',this.LinguaUtente) }}</label>
        <input type="radio" id="RadioMinuti" name="RadioUdmX" style="margin: 0px; margin-left: 10px" :value="TipiUdmX.Minuti" v-model="Allineamento.AxisX.TipoUdmX"/>
      </div>
    </div> 
  </template>
  <template v-slot:Footer>
    <button type="button" class="btn btn-danger" style="float:right;margin-left:10px;font-weight:bold;width:25%" @click="PopupChangeScalaXAccelerometri = false" data-dismiss="modal">{{ this.GetTraduzioneLabel('Generic','TKN_ANNULLA',this.LinguaUtente) }}</button>
    <button type="button" class="btn btn-success" style="float:right;font-weight:bold;width:25%" @click="ChangeScalaXAccelerometri()" data-dismiss="modal">{{ this.GetTraduzioneLabel('Generic','TKN_CONFERMA',this.LinguaUtente) }}</button>
  </template>
</VUEModal>
<VUEModal v-if="PopupChangeScalaYAccelerometri" :Titolo="this.GetTraduzioneLabel('Generic','TKN_IMP_ASSE_Y',this.LinguaUtente)" Altezza="150px" Larghezza="500px" :PathLogo="require('@/assets/images/LogoDMS.png')" :Programma="'DMSEW'"
            @onClickChiudiModal="PopupChangeScalaYAccelerometri = false">
  <template v-slot:Body>      
    <div style="display: flex; flex-flow: column wrap; padding-left: 50px; padding-right: 50px">
      <div style="font-size:14px; display: flex; flex-flow: row wrap; align-content: center; justify-content: center; align-items: center; margin-bottom: 5px;">
        <p style="width: 40%; margin: 0px; font-weight: bold">{{ this.GetTraduzioneLabel('Generic','TKN_MINIMO',this.LinguaUtente) }}</p>
        <input class="form-control" style="width:30%; text-align: right;" type="number" step="1" v-model="Allineamento.AxisY.Min">
        <p style="width: 20%; margin: 0px; margin-left: 10px; font-weight: bold">{{ UdmAdattamento ? UdmAdattamento : '' }}</p>
      </div>
      <div style="font-size:14px; display: flex; flex-flow: row wrap; align-content: center; justify-content: center; align-items: center; margin-bottom: 5px;">
        <p style="width: 40%; margin: 0px; font-weight: bold">{{ this.GetTraduzioneLabel('Generic','TKN_MASSIMO',this.LinguaUtente) }}</p>
        <input class="form-control" style="width:30%; text-align: right;" type="number" step="1" v-model="Allineamento.AxisY.Max">
        <p style="width: 20%; margin: 0px; margin-left: 10px; font-weight: bold">{{ UdmAdattamento ? UdmAdattamento : ''  }}</p>
      </div>
      <div style="font-size:14px; display: flex; flex-flow: row wrap; align-content: center; justify-content: center; align-items: center;">
        <p style="width: 40%; margin: 0px; font-weight: bold">{{ this.GetTraduzioneLabel('Generic','TKN_UNITA_PRINCIPALE',this.LinguaUtente) }}</p>
        <input class="form-control" style="width:30%; text-align: right;" type="number" step="1" v-model="Allineamento.AxisY.Udm">
        <p style="width: 20%; margin: 0px; margin-left: 10px; font-weight: bold">{{ UdmAdattamento ? UdmAdattamento : ''  }}</p>
      </div>
    </div>
  </template>
  <template v-slot:Footer>
    <button type="button" class="btn btn-danger" style="float:right;margin-left:10px;font-weight:bold;width:25%" @click="PopupChangeScalaYAccelerometri = false" data-dismiss="modal">{{ this.GetTraduzioneLabel('Generic','TKN_ANNULLA',this.LinguaUtente) }}</button>
    <button type="button" class="btn btn-success" style="float:right;font-weight:bold;width:25%" @click="ChangeScalaYAccelerometri()" data-dismiss="modal">{{ this.GetTraduzioneLabel('Generic','TKN_CONFERMA',this.LinguaUtente) }}</button>
  </template>
</VUEModal>
<VUEModal v-if="PopupChangeScalaXGraphSupSoglie || PopupChangeScalaYGraphSupSoglie || PopupChangeScalaZGraphSupSoglie" :Titolo="this.GetTraduzioneLabel('Generic','TKN_IMP_ASSE_Y',this.LinguaUtente)" Altezza="150px" Larghezza="500px" :PathLogo="require('@/assets/images/LogoDMS.png')" :Programma="'DMSEW'"
            @onClickChiudiModal="AnnullaPopupGraphSupSoglie()">
  <template v-slot:Body> 
    <div v-if="PopupChangeScalaXGraphSupSoglie">
      <div style="display: flex; flex-flow: column wrap; padding-left: 50px; padding-right: 50px">
        <div style="font-size:14px; display: flex; flex-flow: row wrap; align-content: center; justify-content: center; align-items: center; margin-bottom: 5px;">
          <p style="width: 40%; margin: 0px; font-weight: bold">{{ this.GetTraduzioneLabel('Generic','TKN_MINIMO',this.LinguaUtente) }}</p>
          <input class="form-control" style="width:30%; text-align: right;" type="number" step="1" v-model="ObjAllineamentoAsseY.GraphX.Min">
          <p style="width: 20%; margin: 0px; margin-left: 10px; font-weight: bold">{{ UdmAdattamento ? UdmAdattamento : '' }}</p>
        </div>
        <div style="font-size:14px; display: flex; flex-flow: row wrap; align-content: center; justify-content: center; align-items: center; margin-bottom: 5px;">
          <p style="width: 40%; margin: 0px; font-weight: bold">{{ this.GetTraduzioneLabel('Generic','TKN_MASSIMO',this.LinguaUtente) }}</p>
          <input class="form-control" style="width:30%; text-align: right;" type="number" step="1" v-model="ObjAllineamentoAsseY.GraphX.Max">
          <p style="width: 20%; margin: 0px; margin-left: 10px; font-weight: bold">{{ UdmAdattamento ? UdmAdattamento : ''  }}</p>
        </div>
        <div style="font-size:14px; display: flex; flex-flow: row wrap; align-content: center; justify-content: center; align-items: center;">
          <p style="width: 40%; margin: 0px; font-weight: bold">{{ this.GetTraduzioneLabel('Generic','TKN_UNITA_PRINCIPALE',this.LinguaUtente) }}</p>
          <input class="form-control" style="width:30%; text-align: right;" type="number" step="1" v-model="ObjAllineamentoAsseY.GraphX.Udm">
          <p style="width: 20%; margin: 0px; margin-left: 10px; font-weight: bold">{{ UdmAdattamento ? UdmAdattamento : ''  }}</p>
        </div>
      </div>
    </div>
    
    <div v-if="PopupChangeScalaYGraphSupSoglie">
      <div style="display: flex; flex-flow: column wrap; padding-left: 50px; padding-right: 50px">
        <div style="font-size:14px; display: flex; flex-flow: row wrap; align-content: center; justify-content: center; align-items: center; margin-bottom: 5px;">
          <p style="width: 40%; margin: 0px; font-weight: bold">{{ this.GetTraduzioneLabel('Generic','TKN_MINIMO',this.LinguaUtente) }}</p>
          <input class="form-control" style="width:30%; text-align: right;" type="number" step="1" v-model="ObjAllineamentoAsseY.GraphY.Min">
          <p style="width: 20%; margin: 0px; margin-left: 10px; font-weight: bold">{{ UdmAdattamento ? UdmAdattamento : '' }}</p>
        </div>
        <div style="font-size:14px; display: flex; flex-flow: row wrap; align-content: center; justify-content: center; align-items: center; margin-bottom: 5px;">
          <p style="width: 40%; margin: 0px; font-weight: bold">{{ this.GetTraduzioneLabel('Generic','TKN_MASSIMO',this.LinguaUtente) }}</p>
          <input class="form-control" style="width:30%; text-align: right;" type="number" step="1" v-model="ObjAllineamentoAsseY.GraphY.Max">
          <p style="width: 20%; margin: 0px; margin-left: 10px; font-weight: bold">{{ UdmAdattamento ? UdmAdattamento : ''  }}</p>
        </div>
        <div style="font-size:14px; display: flex; flex-flow: row wrap; align-content: center; justify-content: center; align-items: center;">
          <p style="width: 40%; margin: 0px; font-weight: bold">{{ this.GetTraduzioneLabel('Generic','TKN_UNITA_PRINCIPALE',this.LinguaUtente) }}</p>
          <input class="form-control" style="width:30%; text-align: right;" type="number" step="1" v-model="ObjAllineamentoAsseY.GraphY.Udm">
          <p style="width: 20%; margin: 0px; margin-left: 10px; font-weight: bold">{{ UdmAdattamento ? UdmAdattamento : ''  }}</p>
        </div>
      </div>
    </div>
    
    <div v-if="PopupChangeScalaZGraphSupSoglie">
      <div style="display: flex; flex-flow: column wrap; padding-left: 50px; padding-right: 50px">
        <div style="font-size:14px; display: flex; flex-flow: row wrap; align-content: center; justify-content: center; align-items: center; margin-bottom: 5px;">
          <p style="width: 40%; margin: 0px; font-weight: bold">{{ this.GetTraduzioneLabel('Generic','TKN_MINIMO',this.LinguaUtente) }}</p>
          <input class="form-control" style="width:30%; text-align: right;" type="number" step="1" v-model="ObjAllineamentoAsseY.GraphZ.Min">
          <p style="width: 20%; margin: 0px; margin-left: 10px; font-weight: bold">{{ UdmAdattamento ? UdmAdattamento : '' }}</p>
        </div>
        <div style="font-size:14px; display: flex; flex-flow: row wrap; align-content: center; justify-content: center; align-items: center; margin-bottom: 5px;">
          <p style="width: 40%; margin: 0px; font-weight: bold">{{ this.GetTraduzioneLabel('Generic','TKN_MASSIMO',this.LinguaUtente) }}</p>
          <input class="form-control" style="width:30%; text-align: right;" type="number" step="1" v-model="ObjAllineamentoAsseY.GraphZ.Max">
          <p style="width: 20%; margin: 0px; margin-left: 10px; font-weight: bold">{{ UdmAdattamento ? UdmAdattamento : ''  }}</p>
        </div>
        <div style="font-size:14px; display: flex; flex-flow: row wrap; align-content: center; justify-content: center; align-items: center;">
          <p style="width: 40%; margin: 0px; font-weight: bold">{{ this.GetTraduzioneLabel('Generic','TKN_UNITA_PRINCIPALE',this.LinguaUtente) }}</p>
          <input class="form-control" style="width:30%; text-align: right;" type="number" step="1" v-model="ObjAllineamentoAsseY.GraphZ.Udm">
          <p style="width: 20%; margin: 0px; margin-left: 10px; font-weight: bold">{{ UdmAdattamento ? UdmAdattamento : ''  }}</p>
        </div>
      </div>
    </div>
  </template>
  <template v-slot:Footer>
    <button type="button" class="btn btn-danger" style="float:right;margin-left:10px;font-weight:bold;width:25%" @click="AnnullaPopupGraphSupSoglie()" data-dismiss="modal">{{ this.GetTraduzioneLabel('Generic','TKN_ANNULLA',this.LinguaUtente) }}</button>
    <button type="button" class="btn btn-success" style="float:right;font-weight:bold;width:25%" @click="ChangeScalaAccelerometriSupSoglie()" data-dismiss="modal">{{ this.GetTraduzioneLabel('Generic','TKN_CONFERMA',this.LinguaUtente) }}</button>
  </template>
</VUEModal>
<VUEModal v-if="PopupAggiungiRighelloAccelerometri && TipoGrafico != TipiStorici.EV_ACCELEROMETRICI_SUP_SOGLIE" :Titolo="this.GetTraduzioneLabel('Generic','TKN_DATI_RIGHELLO',this.LinguaUtente)" Altezza="140px" Larghezza="500px" :PathLogo="require('@/assets/images/LogoDMS.png')" :Programma="'DMSEW'"
            @onClickChiudiModal="PopupAggiungiRighelloAccelerometri = false">
  <template v-slot:Body>
    <div style="font-size:14px; display: flex; flex-flow: column nowrap; align-content: center; justify-content: center; align-items: center; margin-top: 15px; padding-left: 30px; padding-right: 30px;">
      <div style="width: 100%; display: flex; flex-flow: row wrap; justify-content: space-between;">
        <p style="width: 120px; margin: 0px; display: flex; align-items: center; font-weight: bold">{{ this.GetTraduzioneLabel('Generic','TKN_DATA_RIGHELLO',this.LinguaUtente) }}</p>
        <div style="width: 70%; display: flex; justify-content: space-between">
          <input class="form-control" style="width:55%; display: inline" type="date" v-model="ObjNewRighello.Data">
          <input class="form-control" style="width:40%; display: inline" type="time" v-model="ObjNewRighello.Ora">
        </div>
      </div>
      <div style="width: 100%; display: flex; flex-flow: row wrap; justify-content: space-between; margin-top: 10px">
        <p style="width: 150px; margin: 0px; display: flex; align-items: center; font-weight: bold">{{ this.GetTraduzioneLabel('Generic','TKN_COLORE_RIGHELLO',this.LinguaUtente) }}</p>
        <label class="form-control" style="width:20%; cursor: pointer; height: 25px; margin: 0px" :style="{'background' : ObjNewRighello.Colore}" @click="ApriPopupColorPicker(ObjNewRighello.Colore, 'background')">&nbsp;</label>
      </div>            
    </div>
  </template>
  <template v-slot:Footer>
    <button type="button" class="btn btn-danger" style="float:right;margin-left:10px;font-weight:bold;width:25%" @click="PopupAggiungiRighelloAccelerometri = false" data-dismiss="modal">{{ this.GetTraduzioneLabel('Generic','TKN_ANNULLA',this.LinguaUtente) }}</button>
    <button v-if="ObjNewRighello.Data != '' && ObjNewRighello.Ora != ''" type="button" class="btn btn-success" style="float:right;font-weight:bold;width:25%" @click="AggiungiRighelloAccelerometri()" data-dismiss="modal">{{ this.GetTraduzioneLabel('Generic','TKN_CONFERMA',this.LinguaUtente) }}</button>
  </template>
</VUEModal>
<VUEModal v-if="PopupEliminaRighelloAccelerometri && TipoGrafico != TipiStorici.EV_ACCELEROMETRICI_SUP_SOGLIE" :Titolo="this.GetTraduzioneLabel('Generic','TKN_DATI_RIGHELLO',this.LinguaUtente)" Altezza="140px" Larghezza="500px" :PathLogo="require('@/assets/images/LogoDMS.png')" :Programma="'DMSEW'"
            @onClickChiudiModal="PopupEliminaRighelloAccelerometri = false">
  <template v-slot:Body>
    <div style="font-size:14px; display: flex; flex-flow: row wrap; align-content: center; justify-content: center; align-items: center; margin-top: 15px; padding-left: 30px; padding-right: 30px;">
      <p style="width: 150px; margin: 0px; display: flex; align-items: center; font-weight: bold">{{ this.GetTraduzioneLabel('Generic','TKN_SELEZIONA_RIGHELLO',this.LinguaUtente) }}</p>
      <div style="width: 50%; display: flex; justify-content: space-between">
        <select class="form-control" v-model="RighelloToRemove">
          <option :value="''">-</option>
          <option v-for="Righello in ListaRighelliAccelerometri" :key="Righello.PrettyDateTime">{{ Righello.PrettyDateTime }}</option>
        </select>
      </div>
    </div>
  </template>
  <template v-slot:Footer>
    <button type="button" class="btn btn-danger" style="float:right;margin-left:10px;font-weight:bold;width:25%" @click="PopupEliminaRighelloAccelerometri = false" data-dismiss="modal">{{ this.GetTraduzioneLabel('Generic','TKN_ANNULLA',this.LinguaUtente) }}</button>
    <button v-if="RighelloToRemove != ''" type="button" class="btn btn-success" style="float:right;font-weight:bold;width:25%" @click="EliminaRighelloAccelerometri()" data-dismiss="modal">{{ this.GetTraduzioneLabel('Generic','TKN_CONFERMA',this.LinguaUtente) }}</button>
  </template>
</VUEModal>
<VUEModal v-if="PopupAggiungiRighelloAccelerometri && TipoGrafico == TipiStorici.EV_ACCELEROMETRICI_SUP_SOGLIE" :Titolo="this.GetTraduzioneLabel('Generic','TKN_DATI_RIGHELLO',this.LinguaUtente)" Altezza="140px" Larghezza="500px" :PathLogo="require('@/assets/images/LogoDMS.png')" :Programma="'DMSEW'"
            @onClickChiudiModal="PopupAggiungiRighelloAccelerometri = false">
  <template v-slot:Body>
    <div style="font-size:14px; display: flex; flex-flow: column nowrap; align-content: center; justify-content: center; align-items: center; margin-top: 15px; padding-left: 30px; padding-right: 30px;">
      <div style="width: 100%; display: flex; flex-flow: row wrap; justify-content: space-between;">
        <p style="width: 70%; margin: 0px; display: flex; align-items: center; font-weight: bold">{{ this.GetTraduzioneLabel('Generic','TKN_MILLISECONDI_RIGHELLO',this.LinguaUtente) }}</p>
        <div style="width: 30%; display: flex; justify-content: end">
          <input class="form-control" style="width:80%; display: inline" type="number" v-model="ObjNewRighelloSupSoglie.Millisecondi">
        </div>
      </div>
      <div style="width: 100%; display: flex; flex-flow: row wrap; justify-content: space-between; margin-top: 10px">
        <p style="width: 150px; margin: 0px; display: flex; align-items: center; font-weight: bold">{{ this.GetTraduzioneLabel('Generic','TKN_COLORE_RIGHELLO',this.LinguaUtente) }}</p>
        <label class="form-control" style="width:20%; cursor: pointer; height: 25px; margin: 0px" :style="{'background' : ObjNewRighelloSupSoglie.Colore}" @click="ApriPopupColorPicker(ObjNewRighelloSupSoglie.Colore, 'background')">&nbsp;</label>
      </div>            
    </div>
  </template>
  <template v-slot:Footer>
    <button type="button" class="btn btn-danger" style="float:right;margin-left:10px;font-weight:bold;width:25%" @click="PopupAggiungiRighelloAccelerometri = false" data-dismiss="modal">{{ this.GetTraduzioneLabel('Generic','TKN_ANNULLA',this.LinguaUtente) }}</button>
    <button v-if="ObjNewRighelloSupSoglie.Millisecondi != null" type="button" class="btn btn-success" style="float:right;font-weight:bold;width:25%" @click="AggiungiRighelloAccelerometriSupSoglie()" data-dismiss="modal">{{ this.GetTraduzioneLabel('Generic','TKN_CONFERMA',this.LinguaUtente) }}</button>
  </template>
</VUEModal>
<VUEModal v-if="PopupEliminaRighelloAccelerometri && TipoGrafico == TipiStorici.EV_ACCELEROMETRICI_SUP_SOGLIE" :Titolo="this.GetTraduzioneLabel('Generic','TKN_DATI_RIGHELLO',this.LinguaUtente)" Altezza="140px" Larghezza="500px" :PathLogo="require('@/assets/images/LogoDMS.png')" :Programma="'DMSEW'"
            @onClickChiudiModal="PopupEliminaRighelloAccelerometri = false">
  <template v-slot:Body>
    <div style="font-size:14px; display: flex; flex-flow: row wrap; align-content: center; justify-content: center; align-items: center; margin-top: 15px; padding-left: 30px; padding-right: 30px;">
      <p style="width: 150px; margin: 0px; display: flex; align-items: center; font-weight: bold">{{ this.GetTraduzioneLabel('Generic','TKN_SELEZIONA_RIGHELLO',this.LinguaUtente) }}</p>
      <div style="width: 50%; display: flex; justify-content: space-between">
        <select class="form-control" v-model="RighelloToRemove">
          <option :value="''">-</option>
          <option v-for="Righello in ListaRighelliAccelerometri" :key="Righello.Millisecondi">{{ Righello.Millisecondi }}</option>
        </select>
      </div>
    </div>
  </template>
  <template v-slot:Footer>
    <button type="button" class="btn btn-danger" style="float:right;margin-left:10px;font-weight:bold;width:25%" @click="PopupEliminaRighelloAccelerometri = false" data-dismiss="modal">{{ this.GetTraduzioneLabel('Generic','TKN_ANNULLA',this.LinguaUtente) }}</button>
    <button v-if="RighelloToRemove != ''" type="button" class="btn btn-success" style="float:right;font-weight:bold;width:25%" @click="EliminaRighelloAccelerometriSupSoglie()" data-dismiss="modal">{{ this.GetTraduzioneLabel('Generic','TKN_CONFERMA',this.LinguaUtente) }}</button>
  </template>
</VUEModal>
<VUEModal v-if="PopupChangeColoreAmpiezzaX" :Titolo="this.GetTraduzioneLabel('VUEAppContentGraficiStorici','TKN_AMPIEZZA_ASSE_X',this.LinguaUtente)" Altezza="140px" Larghezza="500px" :PathLogo="require('@/assets/images/LogoDMS.png')" :Programma="'DMSEW'"
            @onClickChiudiModal="PopupChangeColoreAmpiezzaX = false">
  <template v-slot:Body>
    <div style="font-size:14px; display: flex; flex-flow: column nowrap; align-content: center; justify-content: center; align-items: center; margin-top: 15px; padding-left: 30px; padding-right: 30px;">
      <div style="width: 100%; display: flex; flex-flow: row wrap; justify-content: space-between; margin-top: 10px">
        <p style="width: 150px; margin: 0px; display: flex; align-items: center; font-weight: bold">{{ this.GetTraduzioneLabel('VUEAppContentGraficiStorici','TKN_SCEGLI_COLORE',this.LinguaUtente) }}</p>
        <label class="form-control" style="width:20%; cursor: pointer; height: 25px; margin: 0px" :style="{'background' : NewColorAmpiezzaX.Colore}" @click="ApriPopupColorPicker(NewColorAmpiezzaX.Colore, 'background')">&nbsp;</label>
      </div>            
    </div>
  </template>
  <template v-slot:Footer>
    <button type="button" class="btn btn-danger" style="float:right;margin-left:10px;font-weight:bold;width:25%" @click="PopupChangeColoreAmpiezzaX = false" data-dismiss="modal">{{ this.GetTraduzioneLabel('Generic','TKN_ANNULLA',this.LinguaUtente) }}</button>
    <button type="button" class="btn btn-success" style="float:right;font-weight:bold;width:25%" @click="ChangeColoreAmpiezzaX()" data-dismiss="modal">{{ this.GetTraduzioneLabel('Generic','TKN_CONFERMA',this.LinguaUtente) }}</button>
  </template>
</VUEModal>
<VUEModal v-if="PopupChangeColoreAmpiezzaY" :Titolo="this.GetTraduzioneLabel('VUEAppContentGraficiStorici','TKN_AMPIEZZA_ASSE_Y',this.LinguaUtente)" Altezza="140px" Larghezza="500px" :PathLogo="require('@/assets/images/LogoDMS.png')" :Programma="'DMSEW'"
            @onClickChiudiModal="PopupChangeColoreAmpiezzaY = false">
  <template v-slot:Body>
    <div style="font-size:14px; display: flex; flex-flow: column nowrap; align-content: center; justify-content: center; align-items: center; margin-top: 15px; padding-left: 30px; padding-right: 30px;">
      <div style="width: 100%; display: flex; flex-flow: row wrap; justify-content: space-between; margin-top: 10px">
        <p style="width: 150px; margin: 0px; display: flex; align-items: center; font-weight: bold">{{ this.GetTraduzioneLabel('VUEAppContentGraficiStorici','TKN_SCEGLI_COLORE',this.LinguaUtente) }}</p>
        <label class="form-control" style="width:20%; cursor: pointer; height: 25px; margin: 0px" :style="{'background' : NewColorAmpiezzaY.Colore}" @click="ApriPopupColorPicker(NewColorAmpiezzaY.Colore, 'background')">&nbsp;</label>
      </div>            
    </div>
  </template>
  <template v-slot:Footer>
    <button type="button" class="btn btn-danger" style="float:right;margin-left:10px;font-weight:bold;width:25%" @click="PopupChangeColoreAmpiezzaY = false" data-dismiss="modal">{{ this.GetTraduzioneLabel('Generic','TKN_ANNULLA',this.LinguaUtente) }}</button>
    <button type="button" class="btn btn-success" style="float:right;font-weight:bold;width:25%" @click="ChangeColoreAmpiezzaY()" data-dismiss="modal">{{ this.GetTraduzioneLabel('Generic','TKN_CONFERMA',this.LinguaUtente) }}</button>
  </template>
</VUEModal>
<VUEModal v-if="PopupChangeColoreAmpiezzaZ" :Titolo="this.GetTraduzioneLabel('VUEAppContentGraficiStorici','TKN_AMPIEZZA_ASSE_Z',this.LinguaUtente)" Altezza="140px" Larghezza="500px" :PathLogo="require('@/assets/images/LogoDMS.png')" :Programma="'DMSEW'"
            @onClickChiudiModal="PopupChangeColoreAmpiezzaZ = false">
  <template v-slot:Body>
    <div style="font-size:14px; display: flex; flex-flow: column nowrap; align-content: center; justify-content: center; align-items: center; margin-top: 15px; padding-left: 30px; padding-right: 30px;">
      <div style="width: 100%; display: flex; flex-flow: row wrap; justify-content: space-between; margin-top: 10px">
        <p style="width: 150px; margin: 0px; display: flex; align-items: center; font-weight: bold">{{ this.GetTraduzioneLabel('VUEAppContentGraficiStorici','TKN_SCEGLI_COLORE',this.LinguaUtente) }}</p>
        <label class="form-control" style="width:20%; cursor: pointer; height: 25px; margin: 0px" :style="{'background' : NewColorAmpiezzaZ.Colore}" @click="ApriPopupColorPicker(NewColorAmpiezzaZ.Colore, 'background')">&nbsp;</label>
      </div>            
    </div>
  </template>
  <template v-slot:Footer>
    <button type="button" class="btn btn-danger" style="float:right;margin-left:10px;font-weight:bold;width:25%" @click="PopupChangeColoreAmpiezzaZ = false" data-dismiss="modal">{{ this.GetTraduzioneLabel('Generic','TKN_ANNULLA',this.LinguaUtente) }}</button>
    <button type="button" class="btn btn-success" style="float:right;font-weight:bold;width:25%" @click="ChangeColoreAmpiezzaZ()" data-dismiss="modal">{{ this.GetTraduzioneLabel('Generic','TKN_CONFERMA',this.LinguaUtente) }}</button>
  </template>
</VUEModal>
<VUEModal v-if="PopupChangeColoreFrequenza" :Titolo="this.GetTraduzioneLabel('VUEAppContentGraficiStorici','TKN_FREQUENZA',this.LinguaUtente)" Altezza="140px" Larghezza="500px" :PathLogo="require('@/assets/images/LogoDMS.png')" :Programma="'DMSEW'"
            @onClickChiudiModal="PopupChangeColoreFrequenza = false">
  <template v-slot:Body>
    <div style="font-size:14px; display: flex; flex-flow: column nowrap; align-content: center; justify-content: center; align-items: center; margin-top: 15px; padding-left: 30px; padding-right: 30px;">
      <div style="width: 100%; display: flex; flex-flow: row wrap; justify-content: space-between; margin-top: 10px">
        <p style="width: 150px; margin: 0px; display: flex; align-items: center; font-weight: bold">{{ this.GetTraduzioneLabel('VUEAppContentGraficiStorici','TKN_SCEGLI_COLORE',this.LinguaUtente) }}</p>
        <label class="form-control" style="width:20%; cursor: pointer; height: 25px; margin: 0px" :style="{'background' : NewColorFrequenza.Colore}" @click="ApriPopupColorPicker(NewColorFrequenza.Colore, 'background')">&nbsp;</label>
      </div>            
    </div>
  </template>
  <template v-slot:Footer>
    <button type="button" class="btn btn-danger" style="float:right;margin-left:10px;font-weight:bold;width:25%" @click="PopupChangeColoreFrequenza = false" data-dismiss="modal">{{ this.GetTraduzioneLabel('Generic','TKN_ANNULLA',this.LinguaUtente) }}</button>
    <button type="button" class="btn btn-success" style="float:right;font-weight:bold;width:25%" @click="ChangeColoreFrequenza()" data-dismiss="modal">{{ this.GetTraduzioneLabel('Generic','TKN_CONFERMA',this.LinguaUtente) }}</button>
  </template>
</VUEModal>
<VUEModal v-if="PopupIntervalloProfondita" :Titolo="this.GetTraduzioneLabel('VUEPopupDatiStorici','TKN_POPUP_DATI_STORICI_INT_TITOLO',this.LinguaUtente)" :PathLogo="require('@/assets/images/LogoDMS.png')" :Programma="'DMSEW'" :Altezza="'150px'" :Larghezza="'500px'"
          @onClickChiudiModal="AnnullaIntervalloProfondita">
  <template v-slot:Body>
    <div style="float: left;font-size:14px;text-align: center;">
      <label>{{ this.GetTraduzioneLabel('VUEPopupDatiStorici','TKN_POPUP_DATI_STORICI_INT_PROF_TESTO',this.LinguaUtente) }}:</label>
    </div>
    <div style="clear:both;height:4px"></div>
    <div style="clear:both;height:4px"></div>
    <div class="ZMDivPopupContent" style="width: 100%">
      <label class="ZMLabelDescriptionPopup">{{ this.GetTraduzioneLabel('VUEPopupDatiStorici','TKN_POPUP_DATI_STORICI_INT_PROF_MIN',this.LinguaUtente) }}</label>
      <div style="width:20px;float:left">&nbsp;</div> 
      <input class="form-control" type="number" style="float: left; width: calc(30% - 20px)" v-model="ObjIntervalloProfondita.TmpStart">
    </div>
    <div style="clear:both;height:4px"></div>
    <div class="ZMDivPopupContent" style="width: 100%">
      <label class="ZMLabelDescriptionPopup">{{ this.GetTraduzioneLabel('VUEPopupDatiStorici','TKN_POPUP_DATI_STORICI_INT_PROF_MAX',this.LinguaUtente) }}</label>
      <div style="width:20px;float:left">&nbsp;</div> 
      <input class="form-control" type="number" style="float: left; width: calc(30% - 20px)" v-model="ObjIntervalloProfondita.TmpEnd">
    </div>
  </template>
  <template v-slot:Footer>
    <button type="button" class="btn btn-danger" style="float:right;margin-left:10px;font-weight:bold;width:20%" @click="AnnullaIntervalloProfondita" data-dismiss="modal">{{ this.GetTraduzioneLabel('Generic','TKN_ANNULLA',this.LinguaUtente) }}</button>
    <button v-if="(ObjIntervalloProfondita.TmpStart != null) && (ObjIntervalloProfondita.TmpEnd != null)" type="button" class="btn btn-success" style="float:right;font-weight:bold;width:20%" @click="ConfermaIntervalloProfondita" data-dismiss="modal">{{ this.GetTraduzioneLabel('Generic','TKN_CONFERMA',this.LinguaUtente) }}</button>
  </template>
</VUEModal>
<VUEColorPicker :Popup="PopupColorPicker" Programma="DMSEW" :Colore="ColoreInModifica" @OnClickConfermaPopup="ConfermaColore()" @OnClickChiudiPopup="AnnullaColore()"></VUEColorPicker>
<VUEModal v-if="PopupAdattamentoAssePiezometri" :Titolo="this.GetTraduzioneLabel('Generic','TKN_IMP_ASSE_PIEZOMETRI',this.LinguaUtente)" Altezza="150px" Larghezza="500px" :PathLogo="require('@/assets/images/LogoDMS.png')" :Programma="'DMSEW'"
            @onClickChiudiModal="PopupAdattamentoAssePiezometri = false">
  <template v-slot:Body>      
    <div style="display: flex; flex-flow: column wrap; padding-left: 50px; padding-right: 50px">
      <div style="font-size:14px; display: flex; flex-flow: row wrap; align-content: center; justify-content: center; align-items: center; margin-bottom: 5px;">
        <p style="width: 40%; margin: 0px; font-weight: bold">{{ this.GetTraduzioneLabel('Generic','TKN_MINIMO',this.LinguaUtente) }}</p>
        <input class="form-control" style="width:30%; text-align: right;" type="number" step="1" v-model="Allineamento.AxisYPress.Min">
        <p style="width: 20%; margin: 0px; margin-left: 10px; font-weight: bold">{{ UdmAdattamento ? UdmAdattamento : '' }}</p>
      </div>
      <div style="font-size:14px; display: flex; flex-flow: row wrap; align-content: center; justify-content: center; align-items: center; margin-bottom: 5px;">
        <p style="width: 40%; margin: 0px; font-weight: bold">{{ this.GetTraduzioneLabel('Generic','TKN_MASSIMO',this.LinguaUtente) }}</p>
        <input class="form-control" style="width:30%; text-align: right;" type="number" step="1" v-model="Allineamento.AxisYPress.Max">
        <p style="width: 20%; margin: 0px; margin-left: 10px; font-weight: bold">{{ UdmAdattamento ? UdmAdattamento : ''  }}</p>
      </div>
      <div style="font-size:14px; display: flex; flex-flow: row wrap; align-content: center; justify-content: center; align-items: center;">
        <p style="width: 40%; margin: 0px; font-weight: bold">{{ this.GetTraduzioneLabel('Generic','TKN_UNITA_PRINCIPALE',this.LinguaUtente) }}</p>
        <input class="form-control" style="width:30%; text-align: right;" type="number" step="1" v-model="Allineamento.AxisYPress.Udm">
        <p style="width: 20%; margin: 0px; margin-left: 10px; font-weight: bold">{{ UdmAdattamento ? UdmAdattamento : ''  }}</p>
      </div>
    </div>
  </template>
  <template v-slot:Footer>
    <button type="button" class="btn btn-danger" style="float:right;margin-left:10px;font-weight:bold;width:25%" @click="PopupAdattamentoAssePiezometri = false" data-dismiss="modal">{{ this.GetTraduzioneLabel('Generic','TKN_ANNULLA',this.LinguaUtente) }}</button>
    <button type="button" class="btn btn-success" style="float:right;font-weight:bold;width:25%" @click="ChangeAdattamentoPiezometri()" data-dismiss="modal">{{ this.GetTraduzioneLabel('Generic','TKN_CONFERMA',this.LinguaUtente) }}</button>
  </template>
</VUEModal>
<VUEModal v-if="PopupAdattamentoAsseDeformazioni" :Titolo="this.GetTraduzioneLabel('Generic','TKN_IMP_ASSE_DEFORMAZIONI',this.LinguaUtente)" Altezza="150px" Larghezza="500px" :PathLogo="require('@/assets/images/LogoDMS.png')" :Programma="'DMSEW'"
            @onClickChiudiModal="PopupAdattamentoAsseDeformazioni = false">
  <template v-slot:Body>      
    <div style="display: flex; flex-flow: column wrap; padding-left: 50px; padding-right: 50px">
      <div style="font-size:14px; display: flex; flex-flow: row wrap; align-content: center; justify-content: center; align-items: center; margin-bottom: 5px;">
        <p style="width: 40%; margin: 0px; font-weight: bold">{{ this.GetTraduzioneLabel('Generic','TKN_MINIMO',this.LinguaUtente) }}</p>
        <input class="form-control" style="width:30%; text-align: right;" type="number" step="1" v-model="Allineamento.AxisYDef.Min">
        <p style="width: 20%; margin: 0px; margin-left: 10px; font-weight: bold">{{ UdmAdattamento ? UdmAdattamento : '' }}</p>
      </div>
      <div style="font-size:14px; display: flex; flex-flow: row wrap; align-content: center; justify-content: center; align-items: center; margin-bottom: 5px;">
        <p style="width: 40%; margin: 0px; font-weight: bold">{{ this.GetTraduzioneLabel('Generic','TKN_MASSIMO',this.LinguaUtente) }}</p>
        <input class="form-control" style="width:30%; text-align: right;" type="number" step="1" v-model="Allineamento.AxisYDef.Max">
        <p style="width: 20%; margin: 0px; margin-left: 10px; font-weight: bold">{{ UdmAdattamento ? UdmAdattamento : ''  }}</p>
      </div>
      <div style="font-size:14px; display: flex; flex-flow: row wrap; align-content: center; justify-content: center; align-items: center;">
        <p style="width: 40%; margin: 0px; font-weight: bold">{{ this.GetTraduzioneLabel('Generic','TKN_UNITA_PRINCIPALE',this.LinguaUtente) }}</p>
        <input class="form-control" style="width:30%; text-align: right;" type="number" step="1" v-model="Allineamento.AxisYDef.Udm">
        <p style="width: 20%; margin: 0px; margin-left: 10px; font-weight: bold">{{ UdmAdattamento ? UdmAdattamento : ''  }}</p>
      </div>
    </div>
  </template>
  <template v-slot:Footer>
    <button type="button" class="btn btn-danger" style="float:right;margin-left:10px;font-weight:bold;width:25%" @click="PopupAdattamentoAsseDeformazioni = false" data-dismiss="modal">{{ this.GetTraduzioneLabel('Generic','TKN_ANNULLA',this.LinguaUtente) }}</button>
    <button type="button" class="btn btn-success" style="float:right;font-weight:bold;width:25%" @click="ChangeAdattamentoDeformazioni()" data-dismiss="modal">{{ this.GetTraduzioneLabel('Generic','TKN_CONFERMA',this.LinguaUtente) }}</button>
  </template>
</VUEModal>
<VUEModal v-if="PopupAdattamentoAsseTemp" :Titolo="this.GetTraduzioneLabel('Generic','TKN_IMP_TEMPERATURA',this.LinguaUtente)" Altezza="150px" Larghezza="500px" :PathLogo="require('@/assets/images/LogoDMS.png')" :Programma="'DMSEW'"
            @onClickChiudiModal="PopupAdattamentoAsseTemp = false">
  <template v-slot:Body>      
    <div style="display: flex; flex-flow: column wrap; padding-left: 50px; padding-right: 50px">
      <div style="font-size:14px; display: flex; flex-flow: row wrap; align-content: center; justify-content: center; align-items: center; margin-bottom: 5px;">
        <p style="width: 40%; margin: 0px; font-weight: bold">{{ this.GetTraduzioneLabel('Generic','TKN_MINIMO',this.LinguaUtente) }}</p>
        <input class="form-control" style="width:30%; text-align: right;" type="number" step="1" v-model="Allineamento.AxisTemp.Min">
        <p style="width: 20%; margin: 0px; margin-left: 10px; font-weight: bold">{{ '[' + this.GetTraduzioneLabel('UdmGenerali','TKN_CENTIGRADI',this.LinguaUtente) + ']' }}</p>
      </div>
      <div style="font-size:14px; display: flex; flex-flow: row wrap; align-content: center; justify-content: center; align-items: center; margin-bottom: 5px;">
        <p style="width: 40%; margin: 0px; font-weight: bold">{{ this.GetTraduzioneLabel('Generic','TKN_MASSIMO',this.LinguaUtente) }}</p>
        <input class="form-control" style="width:30%; text-align: right;" type="number" step="1" v-model="Allineamento.AxisTemp.Max">
        <p style="width: 20%; margin: 0px; margin-left: 10px; font-weight: bold">{{ '[' + this.GetTraduzioneLabel('UdmGenerali','TKN_CENTIGRADI',this.LinguaUtente) + ']'  }}</p>
      </div>
      <div style="font-size:14px; display: flex; flex-flow: row wrap; align-content: center; justify-content: center; align-items: center;">
        <p style="width: 40%; margin: 0px; font-weight: bold">{{ this.GetTraduzioneLabel('Generic','TKN_UNITA_PRINCIPALE',this.LinguaUtente) }}</p>
        <input class="form-control" style="width:30%; text-align: right;" type="number" step="1" v-model="Allineamento.AxisTemp.Udm">
        <p style="width: 20%; margin: 0px; margin-left: 10px; font-weight: bold">{{ '[' + this.GetTraduzioneLabel('UdmGenerali','TKN_CENTIGRADI',this.LinguaUtente) + ']'  }}</p>
      </div>
    </div>
  </template>
  <template v-slot:Footer>
    <button type="button" class="btn btn-danger" style="float:right;margin-left:10px;font-weight:bold;width:25%" @click="PopupAdattamentoAsseTemp = false" data-dismiss="modal">{{ this.GetTraduzioneLabel('Generic','TKN_ANNULLA',this.LinguaUtente) }}</button>
    <button type="button" class="btn btn-success" style="float:right;font-weight:bold;width:25%" @click="ChangeAdattamentoAsseTemp()" data-dismiss="modal">{{ this.GetTraduzioneLabel('Generic','TKN_CONFERMA',this.LinguaUtente) }}</button>
  </template>
</VUEModal>

<VUEModal v-if="PopupImpostaAllarmi" :Titolo="this.GetTraduzioneLabel('Generic','TKN_IMP_ALLARMI',this.LinguaUtente)" Altezza="230px" Larghezza="420px" :PathLogo="require('@/assets/images/LogoDMS.png')" :Programma="'DMSEW'"
            @onClickChiudiModal="PopupImpostaAllarmi = false">
  <template v-slot:Body>
    <div style="display: flex; flex-flow: column wrap;margin-left: 6%;">
      <div style="font-size:14px; display: flex; flex-flow: row wrap; align-content: center; justify-content: center; align-items: center; margin-bottom: 5px;">
        <p style="width: 31%; margin: 0px; ">{{ this.GetTraduzioneLabel('Generic','TKN_LVL_BLU',this.LinguaUtente) }}</p>
        <input class="form-control" style="width:30%; text-align: right;" type="number" step="0.1" v-model="LivelloBlu">
        <p style="width: 30%; margin: 0px; margin-left: 4%; ">{{ '[' + this.GetTraduzioneLabel('UdmGenerali','TKN_MM_GIORNO',this.LinguaUtente) + ']' }}</p>
      </div>
      <div style="font-size:14px; display: flex; flex-flow: row wrap; align-content: center; justify-content: center; align-items: center; margin-bottom: 5px;">
        <p style="width: 31%; margin: 0px; ">{{ this.GetTraduzioneLabel('Generic','TKN_LVL_GIALLO',this.LinguaUtente) }}</p>
        <input class="form-control" style="width:30%; text-align: right;" type="number" step="0.1" v-model="LivelloGiallo">
        <p style="width: 30%; margin: 0px; margin-left: 4%; ">{{ '[' + this.GetTraduzioneLabel('UdmGenerali','TKN_MM_GIORNO',this.LinguaUtente) + ']' }}</p>
      </div>
      <div style="font-size:14px; display: flex; flex-flow: row wrap; align-content: center; justify-content: center; align-items: center; margin-bottom: 5px;">
        <p style="width: 31%; margin: 0px; ">{{ this.GetTraduzioneLabel('Generic','TKN_LVL_ARANCIO',this.LinguaUtente) }}</p>
        <input class="form-control" style="width:30%; text-align: right;" type="number" step="0.1" v-model="LivelloArancio">
        <p style="width: 30%; margin: 0px; margin-left: 4%; ">{{ '[' + this.GetTraduzioneLabel('UdmGenerali','TKN_MM_GIORNO',this.LinguaUtente) + ']' }}</p>
      </div>
      <div style="font-size:14px; display: flex; flex-flow: row wrap; align-content: center; justify-content: center; align-items: center; margin-bottom: 5px;">
        <p style="width: 31%; margin: 0px; ">{{ this.GetTraduzioneLabel('Generic','TKN_LVL_ROSSO',this.LinguaUtente) }}</p>
        <input class="form-control" style="width:30%; text-align: right;" type="number" step="0.1" v-model="LivelloRosso">
        <p style="width: 30%; margin: 0px; margin-left: 4%; ">{{ '[' + this.GetTraduzioneLabel('UdmGenerali','TKN_MM_GIORNO',this.LinguaUtente) + ']' }}</p>
      </div>
    </div>
    <div style="display: flex; justify-content: center; margin-top: 3%;">
      <button type="button" class="btn btn-info" style="float:center;width:25%" @click="SoglieAllarmiDefault">
        Default
      </button>
    </div>
  </template>
  <template v-slot:Footer>
    <button type="button" class="btn btn-danger" style="float:right;margin-left:10px;font-weight:bold;width:25%" @click="OnClickCancelImpostaAllarmi" data-dismiss="modal">{{ this.GetTraduzioneLabel('Generic','TKN_ANNULLA',this.LinguaUtente) }}</button>
    <button type="button" class="btn btn-success" style="float:right;font-weight:bold;width:25%" data-dismiss="modal" @click="ConfermaSoglieAllarmi">{{ this.GetTraduzioneLabel('Generic','TKN_CONFERMA',this.LinguaUtente) }}</button>
  </template> 
</VUEModal>

<div style="position: absolute; top: -40px; left : 25%; width: 50%; display: flex; flex-flow: column wrap; justify-content: center">
  <label style="font-weight: bold; color: white;font-size: 25px; display: block; text-align: center">{{ ObjDati.Descrizione }}</label>
</div>

<!-- <label style="font-weight: bold; color: white; position: absolute; top: -40px; font-size: 25px;" :style="{'left' : LarghezzaPagina * 0.4 + 'px'}">{{ ObjDati.Descrizione }}</label> -->

<div v-if="ArrayGrafica1.includes(TipoGrafico)" style="width: calc(100%);" :style="{'height': ((AltezzaPagina - 50) + 'px')}" @scroll="OnWindowScroll">
  <div style="clear:both;height: 10px">&nbsp;</div>

  <div v-if="(ObjDati != null && ObjDati.AllineamentoIncl != null) || 
             (ObjDati != null && ObjDati.AllineamentoDef  != null) ||
             (ObjDati != null && ObjDati.AllineamentoTemp != null)">
      <div style="float:right;width:30%;">
        <div v-if="ObjDati != null && ObjDati.AllineamentoIncl != null" style="font-weight:bold;float:left;">{{ this.GetTraduzioneLabel('VUEAppContentGraficiStorici','TKN_APP_CON_GRAF_STO_DATA_ALL_INCL',this.LinguaUtente) }}: {{ FormattaDataGrafica(ObjDati.AllineamentoIncl.DataAllineamento) + ' ' + ObjDati.AllineamentoIncl.OrarioAllineamento }}</div>
        <div v-if="ObjDati != null && ObjDati.AllineamentoDef  != null" style="font-weight:bold;float:left;">{{ this.GetTraduzioneLabel('VUEAppContentGraficiStorici','TKN_APP_CON_GRAF_STO_DATA_ALL_DEF',this.LinguaUtente) }}: {{ FormattaDataGrafica(ObjDati.AllineamentoDef.DataAllineamento)  + ' ' + ObjDati.AllineamentoDef.OrarioAllineamento  }}</div>
        <div v-if="ObjDati != null && ObjDati.AllineamentoTemp != null" style="font-weight:bold;float:left;">{{ this.GetTraduzioneLabel('VUEAppContentGraficiStorici','TKN_APP_CON_GRAF_STO_DATA_ALL_TEMP',this.LinguaUtente) }}:  {{ FormattaDataGrafica(ObjDati.AllineamentoTemp.DataAllineamento) + ' ' + ObjDati.AllineamentoTemp.OrarioAllineamento }}</div>
      </div>
  </div>

 
  <div style="clear:both;height: 10px">&nbsp;</div>


  <div>
    <!-- GRAFICA FILTRO -->
    <!-- <div class="col-md-1">&nbsp;</div> -->
    <div class="col-md-12">

      <!-- GRAFICA BOTTONI -->
      <div v-if="TipoGrafico != TipiStorici.SPOSTAMENTI_GRAFICI_SOVR && TipoGrafico != TipiStorici.STAZIONE_METEO && SceltaRangeGrafici">
        <select class="form-control" style="float:left;font-weight: bold; width: 10%;min-width:150px;" @change="MixInsOnClickBottoniIndici(this.Catena, CurrentBottone)" v-model="CurrentBottone">
          <option v-for="OggettoBottone in VettoreBottoni" :value="OggettoBottone" :key="OggettoBottone.Id">{{ this.GetTraduzioneLabel('Generic','TKN_DAL',this.LinguaUtente) }} {{OggettoBottone.Dal}} {{ this.GetTraduzioneLabel('Generic','TKN_AL',this.LinguaUtente) }} {{OggettoBottone.Al}}</option>
        </select>
      </div>

      <img v-if="TipoGrafico != TipiStorici.STAZIONE_METEO" src="@/assets/images/LogoPDF.png" :title="this.GetTraduzioneLabel('Generic','TKN_EXP_TUTTI_PDF',this.LinguaUtente)" @click="EsportaComePDF(-1)" 
                                    style="width: 2.2%;float: right;font-size:14px;cursor: pointer;margin-top: -3px;"/>

      <div style="float:right;width:1%;">&nbsp;</div>

      <button type="button" class="btn btn-info" style="float:right;font-weight: bold; width: 10%;min-width:150px" @click="OnClickRicaricaDati">{{ this.GetTraduzioneLabel('Generic','TKN_RICARICA',this.LinguaUtente) }}</button>
     
      <div style="float:right;width:1%;">&nbsp;</div>

      <button v-if="TipoGrafico == TipiStorici.STAZIONE_METEO" type="button" class="btn btn-info" style="float:right;font-weight: bold; width: 7%;min-width:150px" @click="OnClick24Ore">{{ this.GetTraduzioneLabel('UdmGenerali','TKN_24H',this.LinguaUtente) }}</button>

      <div style="float:right;width:1%;">&nbsp;</div>

      <div style="float:right;width:4%">
        <select class="form-control" v-model="ObjAl.Ora">
          <option v-for="Ora in 24" :Key="Ora">{{ Ora - 1 }}</option>  
        </select>
      </div> 
      <div style="float: right;font-size:14px;padding-top: 5px;width:4%;text-align: right; padding-right: 15px;min-width:73px">
        <label>{{ this.GetTraduzioneLabel('UdmGenerali','TKN_ORE_M',this.LinguaUtente) }}</label>
      </div>

      <div style="float:right;width:9%">        
        <input type="date" class="form-control" style="min-width:132px" v-model="ObjAl.Data"/>
      </div>
      <div style="float: right;font-size:14px;padding-top: 5px;width:4%;text-align: right; padding-right: 15px;">
        <label style="float:left;min-width:20px;width:100%">{{ this.GetTraduzioneLabel('Generic','TKN_AL',this.LinguaUtente) }}</label>
      </div>
      <div style="float:right;width:4%">
        <select class="form-control" v-model="ObjDal.Ora">
          <option v-for="Ora in 24" :Key="Ora">{{ Ora - 1 }}</option>  
        </select>
      </div> 
      <div style="float: right;font-size:14px;padding-top: 5px;width:4%;text-align: right; padding-right: 15px;min-width:73px">
        <label>{{ this.GetTraduzioneLabel('UdmGenerali','TKN_ORE_M',this.LinguaUtente) }}</label>
      </div>

      <div style="float:right;width:9%">
        <input type="date" class="form-control" style="min-width:132px" v-model="ObjDal.Data"/>
      </div>
      <div style="float: right;font-size:14px;padding-top: 5px;width:8%;text-align: right; padding-right: 15px;min-width:30px">
        <label>{{ this.GetTraduzioneLabel('Generic','TKN_STORICO_DAL',this.LinguaUtente) }}</label>
      </div>
      
      <!-- <div v-if="TipoGrafico != TipiStorici.STAZIONE_METEO" style="float: right;font-size:14px;width:8%;text-align: right; margin-right: 15px;min-width:170px">
        <button type="button" class="btn btn-info" style="float:right;font-weight: bold; width: 100%" @click="EsportaComePDF(-1)">Esporta tutti i PDF</button>
      </div> -->

      <!-- <img v-if="TipoGrafico != TipiStorici.STAZIONE_METEO" src="@/assets/images/LogoPDF.png" title="Stampa tutti i pdf" @click="EsportaComePDF(-1)" 
                                    style="width:2%;float: right;font-size:14px;cursor: pointer;"/> -->



    </div>
    <!-- <div class="col-md-1">&nbsp;</div> -->
  </div>


  <div style="clear:both;height: 10px">&nbsp;</div>


  <div>
    <!-- ELENCO TABELLE -->
    <!-- <div class="col-md-1">&nbsp;</div> -->
    <div class="col-md-12" 
         v-if="TipoGrafico != TipiStorici.SPOSTAMENTI_GRAFICI_SOVR &&
               TipoGrafico != TipiStorici.TENSIONE_ALIMENTAZIONE &&
               TipoGrafico != TipiStorici.STAZIONE_METEO &&
               TipoGrafico != TipiStorici.ASSORBIMENTO"
         ref="ContainerSensori">

      <VUEFrameComponenteGraficoSpostamenti
        v-if="TipoGrafico == TipiStorici.SPOSTAMENTI_GRAFICI_SEPARATI && Catena.OggettoTotaleSpostamento != null"
        @EsportaPDFGrafico="EsportaSingoloGrafico"
        :GetDatiPDF="PDFExport"
        :ParametriPDF="ObjParametriPDF"
        :Modulo="null" 
        :ObjDal="ObjDal" 
        :ObjAl="ObjAl" 
        :TipoGrafico="TipoGrafico" 
        :GraficiChange="GraficiChange"
        :IsVelocita="false"
        :IsAccelerazione="false"
        :ListaFalde="Falde.Sensori"
        :OggettoTotaleSpostamento="Catena.OggettoTotaleSpostamento"
      />

      <VUEFrameComponenteGraficoSpostamenti
        v-if="TipoGrafico == TipiStorici.ACCELERAZIONE_MEDIA_ORARIA && Catena.OggettoTotaleSpostamento != null"
        @EsportaPDFGrafico="EsportaSingoloGrafico"
        :GetDatiPDF="PDFExport"
        :ParametriPDF="ObjParametriPDF"
        :Modulo="null" 
        :ObjDal="ObjDal" 
        :ObjAl="ObjAl" 
        :TipoGrafico="TipoGrafico" 
        :GraficiChange="GraficiChange"
        :IsVelocita="false"
        :IsAccelerazione="true"
        :ListaFalde="Falde.Sensori"
        :OggettoTotaleSpostamento="Catena.OggettoTotaleSpostamento"
      />

      <VUEFrameComponenteGraficoSpostamenti
        v-if="TipoGrafico == TipiStorici.ACCELERAZIONE_MEDIA_GIORNALIERA && Catena.OggettoTotaleSpostamento != null"
        @EsportaPDFGrafico="EsportaSingoloGrafico"
        :GetDatiPDF="PDFExport"
        :ParametriPDF="ObjParametriPDF"
        :Modulo="null" 
        :ObjDal="ObjDal" 
        :ObjAl="ObjAl" 
        :TipoGrafico="TipoGrafico" 
        :GraficiChange="GraficiChange"
        :IsVelocita="false"
        :IsAccelerazione="false"
        :IsVelocitaGiornaliera="false"
        :IsAccelerazioneGiornaliera="true"
        :ListaFalde="Falde.Sensori"
        :OggettoTotaleSpostamento="Catena.OggettoTotaleSpostamento"
      />

      <VUEFrameComponenteGraficoSpostamenti
        v-if="TipoGrafico == TipiStorici.VELOCITA_MEDIA_GIORNALIERA && Catena.OggettoTotaleSpostamento != null"
        @EsportaPDFGrafico="EsportaSingoloGrafico"
        :GetDatiPDF="PDFExport"
        :ParametriPDF="ObjParametriPDF"
        :Modulo="null" 
        :ObjDal="ObjDal" 
        :ObjAl="ObjAl" 
        :TipoGrafico="TipoGrafico" 
        :GraficiChange="GraficiChange"
        :IsVelocita="false"
        :IsAccelerazione="false"
        :IsVelocitaGiornaliera="true"
        :IsAccelerazioneGiornaliera="false"
        :ListaFalde="Falde.Sensori"
        :OggettoTotaleSpostamento="Catena.OggettoTotaleSpostamento"
        :SoglieAllarmi="PopupImpostaAllarmiSoglie.Soglie"
      />
                                            
      <VUEFrameComponenteGraficoSpostamenti
        v-if="TipoGrafico == TipiStorici.VELOCITA_MEDIA_ORARIA && Catena.OggettoTotaleSpostamento != null"
        @EsportaPDFGrafico="EsportaSingoloGrafico"
        :GetDatiPDF="PDFExport"
        :ParametriPDF="ObjParametriPDF"
        :Modulo="null" 
        :ObjDal="ObjDal" 
        :ObjAl="ObjAl" 
        :TipoGrafico="TipoGrafico" 
        :GraficiChange="GraficiChange"
        :IsVelocita="true"
        :IsAccelerazione="false"
        :ListaFalde="Falde.Sensori"
        :OggettoTotaleSpostamento="Catena.OggettoTotaleSpostamento"
      />

      <template v-for="Sensore in ModuliMostrati" :key="Sensore.Id">
        <VUEFrameComponenteGraficoStorico
          v-if="TipoGrafico == TipiStorici.CAMPIONI_RILEVATI && Sensore.Piezometro" 
          @EsportaPDFGrafico="EsportaSingoloGrafico"
          :GetDatiPDF="PDFExport"
          :Modulo="Sensore" 
          :ObjDal="ObjDal" 
          :ObjAl="ObjAl" 
          :TipoGrafico="TipoGrafico" 
          :GraficiChange="GraficiChange"
          :IsPiezometro="true"
          :IsEstensimetro="false"
          :VisualizzaMarkup="ObjDati.VisualizzaMarkup"
          :ParametriPDF="ObjParametriPDF"
        />

        <VUEFrameComponenteGraficoStorico
          v-if="TipoGrafico == TipiStorici.CAMPIONI_RILEVATI && Sensore.Estensimetro" 
          @EsportaPDFGrafico="EsportaSingoloGrafico"
          :Modulo="Sensore" 
          :GetDatiPDF="PDFExport"
          :ObjDal="ObjDal" 
          :ObjAl="ObjAl" 
          :TipoGrafico="TipoGrafico" 
          :GraficiChange="GraficiChange"
          :IsPiezometro="false"
          :IsEstensimetro="true"
          :VisualizzaMarkup="ObjDati.VisualizzaMarkup"
          :ParametriPDF="ObjParametriPDF"
        />

        <VUEFrameComponenteGraficoStorico
          v-if="TipoGrafico == TipiStorici.CAMPIONI_RILEVATI && !GraficSoloPiezometri && !GraficSoloEstensimetri"
          @EsportaPDFGrafico="EsportaSingoloGrafico"
          :GetDatiPDF="PDFExport"
          :Modulo="Sensore" 
          :ObjDal="ObjDal" 
          :ObjAl="ObjAl" 
          :TipoGrafico="TipoGrafico" 
          :GraficiChange="GraficiChange"
          :IsPiezometro="false"
          :IsEstensimetro="false"
          :VisualizzaMarkup="ObjDati.VisualizzaMarkup"
          :ParametriPDF="ObjParametriPDF"
        />

        <VUEFrameComponenteGraficoEvAcc
          v-if="TipoGrafico == TipiStorici.EV_ACCELEROMETRICI_SINTETICI_A ||
                TipoGrafico == TipiStorici.EV_ACCELEROMETRICI_SINTETICI_F"
          @EsportaPDFGrafico="EsportaSingoloGrafico"
          @ModificaSoglie = "SoglieModificate" 
          :GetDatiPDF="PDFExport"
          :MostraRilevamentoSoglia="ShowRilevamentoSoglia"
          :NascondiRilevamentoSoglia="HideRilevamentoSoglia"
          :Sensore="Sensore" 
          :ObjDal="ObjDal" 
          :ObjAl="ObjAl" 
          :TipoGrafico="TipoGrafico" 
          :GraficiChange="GraficiChange"
          :ParametriPDF="ObjParametriPDF"
        />
        
        <VUEFrameComponenteGraficoSpostamenti
          v-if="TipoGrafico == TipiStorici.SPOSTAMENTI_GRAFICI_SEPARATI"
          @EsportaPDFGrafico="EsportaSingoloGrafico"
          :GetDatiPDF="PDFExport"
          :ParametriPDF="ObjParametriPDF"
          :Modulo="Sensore" 
          :ObjDal="ObjDal" 
          :ObjAl="ObjAl" 
          :TipoGrafico="TipoGrafico" 
          :GraficiChange="GraficiChange"
          :IsVelocita="false"
          :IsAccelerazione="false"
          :ListaFalde="Falde.Sensori"
        />

        <VUEFrameComponenteGraficoSpostamenti
          v-if="TipoGrafico == TipiStorici.VELOCITA_MEDIA_ORARIA"
          @EsportaPDFGrafico="EsportaSingoloGrafico"
          :GetDatiPDF="PDFExport"
          :ParametriPDF="ObjParametriPDF"
          :Modulo="Sensore" 
          :ObjDal="ObjDal" 
          :ObjAl="ObjAl" 
          :TipoGrafico="TipoGrafico" 
          :GraficiChange="GraficiChange"
          :IsVelocita="true"
          :IsAccelerazione="false"
          :ListaFalde="Falde.Sensori"
        />

        <VUEFrameComponenteGraficoSpostamenti
          v-if="TipoGrafico == TipiStorici.ACCELERAZIONE_MEDIA_ORARIA"
          @EsportaPDFGrafico="EsportaSingoloGrafico"
          :GetDatiPDF="PDFExport"
          :ParametriPDF="ObjParametriPDF"
          :Modulo="Sensore" 
          :ObjDal="ObjDal" 
          :ObjAl="ObjAl" 
          :TipoGrafico="TipoGrafico" 
          :GraficiChange="GraficiChange"
          :IsVelocita="false"
          :IsAccelerazione="true"
          :ListaFalde="Falde.Sensori"
        />

        <VUEFrameComponenteGraficoSpostamenti
          v-if="TipoGrafico == TipiStorici.VELOCITA_MEDIA_GIORNALIERA"
          @EsportaPDFGrafico="EsportaSingoloGrafico"
          :GetDatiPDF="PDFExport"
          :ParametriPDF="ObjParametriPDF"
          :Modulo="Sensore" 
          :ObjDal="ObjDal" 
          :ObjAl="ObjAl" 
          :TipoGrafico="TipoGrafico" 
          :GraficiChange="GraficiChange"
          :IsVelocita="false"
          :IsAccelerazione="false"
          :IsVelocitaGiornaliera="true"
          :IsAccelerazioneGiornaliera="false"
          :ListaFalde="Falde.Sensori"
          :SoglieAllarmi="PopupImpostaAllarmiSoglie.Soglie"
        />

        <VUEFrameComponenteGraficoSpostamenti
          v-if="TipoGrafico == TipiStorici.ACCELERAZIONE_MEDIA_GIORNALIERA"
          @EsportaPDFGrafico="EsportaSingoloGrafico"
          :GetDatiPDF="PDFExport"
          :ParametriPDF="ObjParametriPDF"
          :Modulo="Sensore" 
          :ObjDal="ObjDal" 
          :ObjAl="ObjAl" 
          :TipoGrafico="TipoGrafico" 
          :GraficiChange="GraficiChange"
          :IsVelocita="false"
          :IsAccelerazione="false"
          :IsVelocitaGiornaliera="false"
          :IsAccelerazioneGiornaliera="true"
          :ListaFalde="Falde.Sensori"
        />
      </template>

      <template v-for="Sensore in ModuliNascosti" :key="Sensore.Id">
        <div v-show="!ModuliInvisibili" >
          <VUEFrameComponenteGraficoStorico
            v-if="TipoGrafico == TipiStorici.CAMPIONI_RILEVATI && Sensore.Piezometro" 
            @EsportaPDFGrafico="EsportaSingoloGrafico"
            :GetDatiPDF="PDFExport"
            :Modulo="Sensore" 
            :ObjDal="ObjDal" 
            :ObjAl="ObjAl" 
            :TipoGrafico="TipoGrafico" 
            :GraficiChange="GraficiChange"
            :IsPiezometro="true"
            :IsEstensimetro="false"
            :VisualizzaMarkup="ObjDati.VisualizzaMarkup"
            :ParametriPDF="ObjParametriPDF"
          />
  
          <VUEFrameComponenteGraficoStorico
            v-if="TipoGrafico == TipiStorici.CAMPIONI_RILEVATI && Sensore.Estensimetro" 
            @EsportaPDFGrafico="EsportaSingoloGrafico"
            :Modulo="Sensore" 
            :GetDatiPDF="PDFExport"
            :ObjDal="ObjDal" 
            :ObjAl="ObjAl" 
            :TipoGrafico="TipoGrafico" 
            :GraficiChange="GraficiChange"
            :IsPiezometro="false"
            :IsEstensimetro="true"
            :VisualizzaMarkup="ObjDati.VisualizzaMarkup"
            :ParametriPDF="ObjParametriPDF"
          />
  
          <VUEFrameComponenteGraficoStorico
            v-if="TipoGrafico == TipiStorici.CAMPIONI_RILEVATI && !GraficSoloPiezometri && !GraficSoloEstensimetri"
            @EsportaPDFGrafico="EsportaSingoloGrafico"
            :GetDatiPDF="PDFExport"
            :Modulo="Sensore" 
            :ObjDal="ObjDal" 
            :ObjAl="ObjAl" 
            :TipoGrafico="TipoGrafico" 
            :GraficiChange="GraficiChange"
            :IsPiezometro="false"
            :IsEstensimetro="false"
            :VisualizzaMarkup="ObjDati.VisualizzaMarkup"
            :ParametriPDF="ObjParametriPDF"
          />
  
          <VUEFrameComponenteGraficoEvAcc
            v-if="TipoGrafico == TipiStorici.EV_ACCELEROMETRICI_SINTETICI_A ||
                  TipoGrafico == TipiStorici.EV_ACCELEROMETRICI_SINTETICI_F"
            @EsportaPDFGrafico="EsportaSingoloGrafico"
            @ModificaSoglie = "SoglieModificate" 
            :GetDatiPDF="PDFExport"
            :MostraRilevamentoSoglia="ShowRilevamentoSoglia"
            :NascondiRilevamentoSoglia="HideRilevamentoSoglia"
            :Sensore="Sensore" 
            :ObjDal="ObjDal" 
            :ObjAl="ObjAl" 
            :TipoGrafico="TipoGrafico" 
            :GraficiChange="GraficiChange"
            :ParametriPDF="ObjParametriPDF"
          />
          
          <VUEFrameComponenteGraficoSpostamenti
            v-if="TipoGrafico == TipiStorici.SPOSTAMENTI_GRAFICI_SEPARATI"
            @EsportaPDFGrafico="EsportaSingoloGrafico"
            :GetDatiPDF="PDFExport"
            :ParametriPDF="ObjParametriPDF"
            :Modulo="Sensore" 
            :ObjDal="ObjDal" 
            :ObjAl="ObjAl" 
            :TipoGrafico="TipoGrafico" 
            :GraficiChange="GraficiChange"
            :IsVelocita="false"
            :IsAccelerazione="false"
            :ListaFalde="Falde.Sensori"
          />
  
          <VUEFrameComponenteGraficoSpostamenti
            v-if="TipoGrafico == TipiStorici.VELOCITA_MEDIA_ORARIA"
            @EsportaPDFGrafico="EsportaSingoloGrafico"
            :GetDatiPDF="PDFExport"
            :ParametriPDF="ObjParametriPDF"
            :Modulo="Sensore" 
            :ObjDal="ObjDal" 
            :ObjAl="ObjAl" 
            :TipoGrafico="TipoGrafico" 
            :GraficiChange="GraficiChange"
            :IsVelocita="true"
            :IsAccelerazione="false"
            :ListaFalde="Falde.Sensori"
          />
  
          <VUEFrameComponenteGraficoSpostamenti
            v-if="TipoGrafico == TipiStorici.ACCELERAZIONE_MEDIA_ORARIA"
            @EsportaPDFGrafico="EsportaSingoloGrafico"
            :GetDatiPDF="PDFExport"
            :ParametriPDF="ObjParametriPDF"
            :Modulo="Sensore" 
            :ObjDal="ObjDal" 
            :ObjAl="ObjAl" 
            :TipoGrafico="TipoGrafico" 
            :GraficiChange="GraficiChange"
            :IsVelocita="false"
            :IsAccelerazione="true"
            :ListaFalde="Falde.Sensori"
          />
  
          <VUEFrameComponenteGraficoSpostamenti
            v-if="TipoGrafico == TipiStorici.VELOCITA_MEDIA_GIORNALIERA"
            @EsportaPDFGrafico="EsportaSingoloGrafico"
            :GetDatiPDF="PDFExport"
            :ParametriPDF="ObjParametriPDF"
            :Modulo="Sensore" 
            :ObjDal="ObjDal" 
            :ObjAl="ObjAl" 
            :TipoGrafico="TipoGrafico" 
            :GraficiChange="GraficiChange"
            :IsVelocita="false"
            :IsAccelerazione="false"
            :IsVelocitaGiornaliera="true"
            :IsAccelerazioneGiornaliera="false"
            :ListaFalde="Falde.Sensori"
            :SoglieAllarmi="PopupImpostaAllarmiSoglie.Soglie"
          />
  
          <VUEFrameComponenteGraficoSpostamenti
            v-if="TipoGrafico == TipiStorici.ACCELERAZIONE_MEDIA_GIORNALIERA"
            @EsportaPDFGrafico="EsportaSingoloGrafico"
            :GetDatiPDF="PDFExport"
            :ParametriPDF="ObjParametriPDF"
            :Modulo="Sensore" 
            :ObjDal="ObjDal" 
            :ObjAl="ObjAl" 
            :TipoGrafico="TipoGrafico" 
            :GraficiChange="GraficiChange"
            :IsVelocita="false"
            :IsAccelerazione="false"
            :IsVelocitaGiornaliera="false"
            :IsAccelerazioneGiornaliera="true"
            :ListaFalde="Falde.Sensori"
          />
        </div>
      </template>

    </div>

    <div v-else class="col-md-12" ref="ContainerSensori">
      <VUEFrameComponenteGraficoSpostamentiSovrapposti v-if="TipoGrafico == TipiStorici.SPOSTAMENTI_GRAFICI_SOVR && ModuliMostrati.length != 0"
                                                       @EsportaPDFGrafico="EsportaSingoloGrafico"
                                                       :GetDatiPDF="PDFExport"
                                                       :ParametriPDF="ObjParametriPDF"
                                                       :ListaModuli="ModuliMostrati" 
                                                       :ObjDal="ObjDal" 
                                                       :ObjAl="ObjAl" 
                                                       :TipoGrafico="TipoGrafico" 
                                                       :GraficiChange="GraficiChange"/>
      
      <VUEFrameComponenteGraficoTensioneAssorbimento v-if="TipoGrafico == TipiStorici.TENSIONE_ALIMENTAZIONE && ModuliMostrati.length != 0"
                                                     @EsportaPDFGrafico="EsportaSingoloGrafico"
                                                     :GetDatiPDF="PDFExport"
                                                     :ParametriPDF="ObjParametriPDF"
                                                     :ListaModuli="ModuliMostrati" 
                                                     :ObjDal="ObjDal" 
                                                     :ObjAl="ObjAl" 
                                                     :TipoGrafico="TipoGrafico" 
                                                     :GraficiChange="GraficiChange"/>
      
      <VUEFrameComponenteGraficoTensioneAssorbimento v-if="TipoGrafico == TipiStorici.ASSORBIMENTO && ModuliMostrati.length != 0"
                                                    @EsportaPDFGrafico="EsportaSingoloGrafico"
                                                    :GetDatiPDF="PDFExport"
                                                    :ParametriPDF="ObjParametriPDF"
                                                    :ListaModuli="ModuliMostrati" 
                                                    :ObjDal="ObjDal" 
                                                    :ObjAl="ObjAl" 
                                                    :TipoGrafico="TipoGrafico" 
                                                    :GraficiChange="GraficiChange"/>

      <VUEFrameComponenteGraficoStazioneMeteo v-if="TipoGrafico == TipiStorici.STAZIONE_METEO && ModuliMostrati.length != 0"
                                              @EsportaPDFGrafico="EsportaSingoloGrafico"
                                              :GetDatiPDF="PDFExport"
                                              :ParametriPDF="ObjParametriPDF"
                                              :ListaModuli="ModuliMostrati" 
                                              :ObjDal="ObjDal" 
                                              :ObjAl="ObjAl" 
                                              :DalRicerca="DalRicerca" 
                                              :AlRicerca="AlRicerca" 
                                              :TipoGrafico="TipoGrafico" 
                                              :GraficiChange="GraficiChange"
                                              :ListaFalde="Falde.Sensori"
                                              :DatiMeteo="Catena.DatiMeteo"
                                              :TempSuolo="Catena.ListaTempSuolo"
                                              :OggettoTotaleSpostamento="Catena.OggettoTotaleSpostamento"/>
    </div>
    <!-- <div class="col-md-1">&nbsp;</div> -->
  </div>

  <div style="clear:both;height: 30px">&nbsp;</div>
</div>

<div ref="ContainerSensori" style="min-width:1200px; width:100%; display:flex" v-if="TipoGrafico == TipiStorici.EV_ACCELEROMETRICI_SUP_SOGLIE" :style="{'height': ((AltezzaPagina - 51) + 'px'), 'overflow-y' : 'auto'}" @scroll="OnWindowScroll">
  <div style="width: 34%; display: flex; flex-flow: column nowrap; min-height:600px">
    <div style="width:100%; display:flex; justify-content: center; color: white; font-weight: bold" :style="{'background-color': ColoriPantone.Marrone}">{{ this.GetTraduzioneLabel('Generic','TKN_FILTRO',this.LinguaUtente) }}</div>
    <div class="col-md-12" style="padding: 5px">    
      <div style="width:100%">
        <div style="display:flex; justify-content: space-between; align-items: center">
          <label style="margin: 0px;">{{ this.GetTraduzioneLabel('Generic','TKN_DAL',this.LinguaUtente) }}</label>
          <input type="date" class="form-control" style="width:132px" v-model="ObjDal.Data"/>
          <input type="time" class="form-control" style="width:95px" v-model="ObjDal.Ora"/>
          
          <label style="margin: 0px;">{{ this.GetTraduzioneLabel('Generic','TKN_AL',this.LinguaUtente) }}</label>
          <input type="date" class="form-control" style="width:132px" v-model="ObjAl.Data"/>
          <input type="time" class="form-control" style="width:95px" v-model="ObjAl.Ora"/>
        </div>
        
        <div style="display:flex; justify-content: space-between; align-items: center; padding-top: 10px; padding-bottom: 20px">
          <div style="display:flex; justify-content: space-between; align-items: center;width: 190px">
            <label style="margin: 0px;">{{ this.GetTraduzioneLabel('VUEAppContentGraficiStorici','TKN_APP_CON_GRAF_STO_STACKING',this.LinguaUtente) }} [s]</label>
            <input type="number" class="form-control" style="width:100px; text-align: right" v-model="Stacking"/>
          </div>
          <button type="button" class="btn btn-info" style="font-weight: bold; width: 10%;min-width:150px" @click="OnClickRicaricaDati">{{ this.GetTraduzioneLabel('Generic','TKN_AGGIORNA',this.LinguaUtente) }}</button>        
        </div>

        <div style="display: flex; justify-content: space-between;">
          <div style="display:flex; justify-content: start; align-items: center">
            <label style="margin: 0px; margin-right: 10px">{{ this.GetTraduzioneLabel('VUEAppContentGraficiStorici','TKN_APP_CON_GRAF_STO_EV_SOVR',this.LinguaUtente) }}</label>
            <input type="checkbox" class="form-control" style="width:20px; margin: 0px;" v-model="EventiSovrapposti"/>
          </div>
          <div>
            <select class="form-control" v-model="Relativo">
              <option :value="true">{{ this.GetTraduzioneLabel('VUEAppContentGraficiStorici','TKN_APP_CON_GRAF_STO_RELATIVI',this.LinguaUtente) }}</option>
              <option :value="false">{{ this.GetTraduzioneLabel('VUEAppContentGraficiStorici','TKN_APP_CON_GRAF_STO_ASSOLUTI',this.LinguaUtente) }}</option>
            </select>
          </div>
        </div>
      </div>
    </div>
    
    <div style="width:100%; display:flex; justify-content: center; color: white; font-weight: bold" :style="{'background-color': ColoriPantone.Marrone}">{{ this.GetTraduzioneLabel('Generic','TKN_MODULI',this.LinguaUtente) }}</div>
    
    <div style="width: 100%; margin-bottom: 5px">
      <div class="col-md-8" style="height: 160px; overflow-y: auto; padding-left: 5px; padding-right: 5px">
        <div v-for="Modulo in Catena.Sensori" :key="Modulo.Id" style="display:flex; justify-content: start; align-items: center">
          <input type="checkbox" class="form-control" style="width:20px; margin: 0px; margin-right: 10px" v-model="Modulo.Selezionato" />
          <label style="margin: 0px;">{{ this.GetTraduzioneLabel('Generic','TKN_MOD_NR',this.LinguaUtente) }} {{ Modulo.Id }}</label>
        </div>
      </div>
      <div class="col-md-4" style="display:flex; flex-flow: column nowrap; justify-content: space-around; align-items: center; height: 160px; padding-right: 5px">      
        <button type="button" class="btn btn-info" style="font-weight: bold; width: 100%" @click="OnClickSelezionaTutti()">{{ this.GetTraduzioneLabel('Generic','TKN_TUTTI',this.LinguaUtente) }}</button>        
        <button type="button" class="btn btn-info" style="font-weight: bold; width: 100%" @click="OnClickSelezionaNessuno()">{{ this.GetTraduzioneLabel('Generic','TKN_NESSUNO',this.LinguaUtente) }}</button>        
        <button type="button" class="btn btn-info" style="font-weight: bold; width: 100%" @click="OnClickInvertiSelezione()">{{ this.GetTraduzioneLabel('Generic','TKN_INVERTI',this.LinguaUtente) }}</button>        
        <button type="button" class="btn btn-info" style="font-weight: bold; width: 100%" @click="OnClickFiltraProfondita()">{{ this.GetTraduzioneLabel('Generic','TKN_PROFONDITA',this.LinguaUtente) }}</button>        
      </div>
    </div>

    <div style="width:100%; display:flex; justify-content: center; color: white; font-weight: bold" :style="{'background-color': ColoriPantone.Marrone}">{{ this.GetTraduzioneLabel('VUEAppContentGraficiStorici','TKN_APP_CON_GRAF_STO_SUP_SOGLIA',this.LinguaUtente) }}</div>
    <div style="width: 100%;">
      <div class="col-md-8" style="padding-left: 5px; padding-right: 0px">
        <div style="width: 100%; display:flex; font-size: 14px; font-weight: bold">
          <div style="width: 50%">{{ this.GetTraduzioneLabel('Generic','TKN_DATA',this.LinguaUtente) }}</div>
          <div style="width: 50%">{{ this.GetTraduzioneLabel('VUEAppContentGraficiStorici','TKN_APP_CON_GRAF_STO_MOD_COINV',this.LinguaUtente) }}</div>
        </div>
        <div :style="{'height': (AltezzaPagina - 410 - 22) + 'px'}" style="overflow-y: auto">
          <div v-for="Evento in EventiMostrati" :key="Evento.Id" style="display:flex; justify-content: start; align-items: center" :style="GetStyleEvento(Evento)" @click="EvidenziaEvento(Evento)">
            <div style="width: 50%">{{ FormattaData(Evento.Id) }}</div>
            <div style="width: 50%">{{ Evento.StringModuli }}</div>
          </div>
        </div>
      </div>
      <div class="col-md-4" style="display:flex; flex-flow: column nowrap; justify-content: space-between; align-items: center; padding-right: 5px" :style="{'height': (AltezzaPagina - 410) + 'px'}">
        <div>
          <button type="button" class="btn btn-info" style="font-weight: bold; width: 100%; margin-bottom: 5px; margin-top: 5px;" @click="SegnaComeNonLetto(EventoSelezionato)">{{ this.GetTraduzioneLabel('VUEAppContentGraficiStorici','TKN_APP_CON_GRAF_STO_NO_LETTO',this.LinguaUtente) }}</button>        
          <button type="button" class="btn btn-info" style="font-weight: bold; width: 100%; margin-bottom: 5px" @click="MixInsSegnaComeLetto()">{{ this.GetTraduzioneLabel('VUEAppContentGraficiStorici','TKN_APP_CON_GRAF_STO_TT_LETTI',this.LinguaUtente) }}</button>        
          <button type="button" class="btn btn-info" style="font-weight: bold; width: 100%; margin-bottom: 5px" @click="SegnaComeNonLetto()">{{ this.GetTraduzioneLabel('VUEAppContentGraficiStorici','TKN_APP_CON_GRAF_STO_TT_NO_LETTI',this.LinguaUtente) }}</button>        
          <button type="button" class="btn btn-info" style="font-weight: bold; width: 100%; margin-bottom: 5px" @click="EsportaExcelModuli()">{{ this.GetTraduzioneLabel('VUEAppContentGraficiStorici','TKN_APP_CON_GRAF_STO_EXP_FILE',this.LinguaUtente) }}</button>
        </div>
        <div>          
          <button type="button" class="btn btn-info" style="font-weight: bold; width: 100%; margin-bottom: 5px" @click="EsportaExcel()">{{ this.GetTraduzioneLabel('VUEAppContentGraficiStorici','TKN_APP_CON_GRAF_STO_EXP_SIN',this.LinguaUtente) }}</button>        
          <button type="button" class="btn btn-info" :disabled="EventiMostrati.length == 0" style="font-weight: bold; width: 100%; margin-bottom: 5px" @click="ApriSinottico()">{{ this.GetTraduzioneLabel('VUEAppContentGraficiStorici','TKN_APP_CON_GRAF_STO_SINOTTICO',this.LinguaUtente) }}</button>
        </div>
      </div>
    </div>
  </div>

  <div v-if="!EventiSovrapposti" style="width: 66%; display: flex; flex-flow: column nowrap; min-height:600px;" :style="{'height': ((AltezzaPagina - 80) + 'px'), 'overflow-y' : 'auto'}">
    <div v-for="Campione in GraficiEventoSelezionato" :key="Campione">
      <VUEFrameComponenteGraficoAccSupSoglie v-if="Mostra"
                                             @EsportaPDFGrafico="EsportaSingoloGrafico"
                                             :GetDatiPDF="PDFExport"
                                             :ParametriPDF="ObjParametriPDF"
                                             :DataPartenza="EventoSelezionato.Id"
                                             :MinData="EventoSelezionato.MinData"
                                             :MinDataMs="EventoSelezionato.MinDataMs"
                                             :UltimaData="EventoSelezionato.MsEnd"
                                             :Evento="Campione"
                                             :Stacking="Stacking"
                                             :GraficiChange="GraficiChange"
                                             :Relativo="Relativo"
                                             :EventiSovrapposti="EventiSovrapposti"
                                             :GraphProps="ObjAllineamentoAsseY"
                                             :GraficiChangeAllSupSoglie="GraficiChangeAllSupSoglie"
                                             :GraficiAdatta="GraficiAdatta"
                                             :ListaRighelli="ListaRighelliAccelerometri"/>
    </div>
  </div>
  <div v-else style="width: 66%; display: flex; flex-flow: column nowrap; min-height:600px;" :style="{'height': ((AltezzaPagina - 80) + 'px'), 'overflow-y' : 'auto'}">
      <VUEFrameComponenteGraficoAccSupSoglie v-if="Mostra"
                                             @EsportaPDFGrafico="EsportaSingoloGrafico"
                                             :GetDatiPDF="PDFExport"
                                             :ParametriPDF="ObjParametriPDF"
                                             :DataPartenza="EventoSelezionato.Id"
                                             :MinData="EventoSelezionato.MinData"
                                             :MinDataMs="EventoSelezionato.MinDataMs"
                                             :UltimaData="EventoSelezionato.MsEnd"
                                             :Evento="GraficiEventoSelezionato"
                                             :Stacking="Stacking"
                                             :GraficiChange="GraficiChange"
                                             :Relativo="Relativo"
                                             :EventiSovrapposti="EventiSovrapposti"
                                             :GraphProps="ObjAllineamentoAsseY"
                                             :GraficiChangeAllSupSoglie="GraficiChangeAllSupSoglie"
                                             :GraficiAdatta="GraficiAdatta"
                                             :ListaRighelli="ListaRighelliAccelerometri"/>
  </div>
</div>

<div ref="ContainerSensori" style="min-width:1200px; width:calc(100%);display:flex; flex-flow: row wrap; padding: 10px;" v-if="TipoGrafico == TipiStorici.EV_ACCELEROMETRICI_CRONOLOGIA" :style="{'height': ((AltezzaPagina - 51) + 'px'), 'overflow-y' : 'auto'}" @scroll="OnWindowScroll">
  <div style="width: 100%; display: flex; flex-flow: row wrap">
    <div style="width: 65%; display: flex; flex-flow: column wrap">
      <div style="width: 100%; display: flex; flex-flow: row wrap; margin-bottom: 8px;">
        <div style="font-size:14px;padding-top: 5px;width:8%;text-align: right; padding-right: 15px">
          <label>{{ this.GetTraduzioneLabel('VUEAppContentGraficiStorici','TKN_APP_CON_GRAF_STO_EV_DAL',this.LinguaUtente) }}</label>
        </div>    
        <div>
          <input type="date" class="form-control" style="min-width:132px" v-model="ObjDal.Data"/>
        </div>    
        <div style="font-size:14px;padding-top: 5px;width:4%;text-align: right; padding-right: 15px;">
          <label style="min-width:20px;width:100%">{{ this.GetTraduzioneLabel('Generic','TKN_AL',this.LinguaUtente) }}</label>
        </div>
        <div>        
          <input type="date" class="form-control" style="min-width:132px" v-model="ObjAl.Data"/>
        </div>
        <button type="button" class="btn btn-info" style="font-weight: bold; width: 150px; height: 34px; margin-left: 20px" @click="OnClickRicaricaDati">{{ this.GetTraduzioneLabel('Generic','TKN_CAMBIA',this.LinguaUtente) }}</button>
      </div>
      <div style="width: 100%; display: flex; flex-flow: row wrap; justify-content: space-between">
        <div style="display: flex; ">
          <div style="font-size:14px; text-align: right; min-width:84px; padding-right: 15px; display: flex; align-items: center">
            <label style="margin: 0px">{{ this.GetTraduzioneLabel('VUEAppContentGraficiStorici','TKN_APP_CON_GRAF_STO_STACKING',this.LinguaUtente) }}</label>
          </div>    
          <div>
            <input type="number" class="form-control" style="width:100px; text-align: right" v-model="Stacking"/>
          </div>    
          <div style="font-size:14px; text-align: right; min-width:84px; padding-right: 15px; display: flex; align-items: center">
            <label style="width:30px; margin: 0px">{{ this.GetTraduzioneLabel('UdmGenerali','TKN_ORE_M',this.LinguaUtente) }}</label>
          </div>
        </div>
        <div style="width: 480px; display: flex; justify-content: space-between">
          <button type="button" class="btn btn-info" style="float:right;font-weight: bold; width: 10%;min-width:150px" @click="ChangeDate(1)">{{ this.GetTraduzioneLabel('VUEAppContentGraficiStorici','TKN_APP_CON_GRAF_STO_ULT_GG',this.LinguaUtente) }}</button>
          <button type="button" class="btn btn-info" style="float:right;font-weight: bold; width: 10%;min-width:150px" @click="ChangeDate(7)">{{ this.GetTraduzioneLabel('VUEAppContentGraficiStorici','TKN_APP_CON_GRAF_STO_ULT_SETT',this.LinguaUtente) }}</button>
          <button type="button" class="btn btn-info" style="float:right;font-weight: bold; width: 10%;min-width:150px" @click="ChangeDate(30)">{{ this.GetTraduzioneLabel('VUEAppContentGraficiStorici','TKN_APP_CON_GRAF_STO_ULT_MESE',this.LinguaUtente) }}</button>
        </div>        
      </div>
    </div>
    <div style="width: 35%; display: flex; flex-flow: column wrap; align-items: flex-end">
      <div style="">
        <label style="margin: 0px; font-weight: bold;">{{ this.GetTraduzioneLabel('VUEAppContentGraficiStorici','TKN_APP_CON_GRAF_STO_MAX_AMPIEZZA',this.LinguaUtente) }}</label>
        <input type="radio" id="RadioAmpiezza" name="RadioTipoGrafico" style="margin: 0px; margin-left: 10px" :value="true" v-model="GraficiAmpiezza"/>
      </div>
      <div style="">
        <label style="margin: 0px; font-weight: bold">{{ this.GetTraduzioneLabel('Generic','TKN_FREQUENZA',this.LinguaUtente) }}</label>
        <input type="radio" id="RadioFrequenza" name="RadioTipoGrafico" style="margin: 0px; margin-left: 10px" :value="false" v-model="GraficiAmpiezza"/>
      </div>
    </div>
  </div>
  <div style="width: 100%; display: flex; flex-flow: row wrap; min-height:600px;">     
    <VUEFrameComponenteGraficoCronologiaAcc v-if="TipoGrafico == TipiStorici.EV_ACCELEROMETRICI_CRONOLOGIA"
                                                  @EsportaPDFGrafico="EsportaSingoloGrafico"
                                                  :GetDatiPDF="PDFExport"
                                                  :ParametriPDF="ObjParametriPDF"
                                                  :ListaEventi="ListaEventiAccorpati" 
                                                  :ObjDal="ObjDal"
                                                  :ObjAl="ObjAl"
                                                  :UdmX="UdmX"
                                                  :Stacking="Stacking"
                                                  :GraficiChange="GraficiChange"
                                                  :LivelliAllarme="LivelliAllarme"
                                                  :Ampiezza="GraficiAmpiezza"
                                                  :Catena="Catena"
                                                  :Altezza="AltezzaFrameCronologia"
                                                  :AsseY="ObjPopupAsseY"/>
  </div>
  <div style="width: 100%; display: flex; flex-flow: row wrap;">    
    <button type="button" class="btn btn-info" style="font-weight: bold; width: 10%;min-width:150px" @click="ApriPopupConfigurazione()">{{ this.GetTraduzioneLabel('Generic','TKN_CONFIGURA',this.LinguaUtente) }}</button>
    <button type="button" class="btn btn-info" style="font-weight: bold; width: 10%;min-width:150px; margin-left: 10px" @click="ApriPopupAsseY()">{{ this.GetTraduzioneLabel('Generic','TKN_MODIFICA_ASSE_Y',this.LinguaUtente) }}</button>
    <button type="button" class="btn btn-info" style="font-weight: bold; width: 10%;min-width:150px; margin-left: 10px" @click="ApriPopupAsseX()">{{ this.GetTraduzioneLabel('Generic','TKN_MODIFICA_ASSE_X',this.LinguaUtente) }}</button>
    <button type="button" class="btn btn-info" style="font-weight: bold; width: 10%;min-width:150px; margin-left: 10px" @click="EsportaComePDF()">{{ this.GetTraduzioneLabel('Generic','TKN_EXP_PDF',this.LinguaUtente) }}</button>
  </div>
</div>
</template>

<script>
// import { saveAs } from 'file-saver'
import { SystemInformation, TIPI_UDM_X, TInfoGraficiStorici, COLORI_PANTONE, TIPOLOGIA_GRAFICI_STORICI, LOCALSTORAGE, COLORI_ALLARME_CRONOLOGIA_ACC, SFONDO } from '@/SystemInformation'
import VUEFrameComponenteGraficoStorico from '../../components/Slots/VUEFrameComponenteGraficoStorico.vue'
import VUEFrameComponenteGraficoEvAcc from '../../components/Slots/VUEFrameComponenteGraficoEvAcc.vue'
import VUEFrameComponenteGraficoAccSupSoglie from '../../components/Slots/VUEFrameComponenteGraficoAccSupSoglie.vue'
import VUEFrameComponenteGraficoCronologiaAcc from '../../components/Slots/VUEFrameComponenteGraficoCronologiaAcc.vue'
import VUEFrameComponenteGraficoSpostamenti from '../../components/Slots/VUEFrameComponenteGraficoSpostamenti.vue'
import VUEColorPicker from '@/utils/VUEColorPicker.vue'
import VUEFrameComponenteGraficoSpostamentiSovrapposti from '../../components/Slots/VUEFrameComponenteGraficoSpostamentiSovrapposti.vue'
import VUEFrameComponenteGraficoStazioneMeteo from '../../components/Slots/VUEFrameComponenteGraficoStazioneMeteo.vue'
import VUEFrameComponenteGraficoTensioneAssorbimento from '../../components/Slots/VUEFrameComponenteGraficoTensioneAssorbimento.vue'
import XLSX from 'xlsx-js-style/dist/xlsx.min.js'
import MixInsGestioneTraduzioni from '@/utils/MixInsGestioneTraduzioni.js'
import VUEModal from '@/utils/VUEModal.vue'
import VUEModalCaricamentoDati, { TOggettoModalCaricamentoDati } from '@/utils/VUEModalCaricamentoDati.vue'
import { TZDateFunct } from '@/utils/ZDateFunct'
import { TZGenericFunct } from '@/utils/ZGenericFunct'
// import { TZStringConvFunct } from '@/utils/ZStringConvFunct'
import MixInsDoubleClickHandler from './MixInsDoubleClickHandler'
import MixInsGraficiStorici from './MixInsGraficiStorici'

export default 
{
  components: { 
                  VUEFrameComponenteGraficoAccSupSoglie,
                  VUEFrameComponenteGraficoStorico,
                  VUEFrameComponenteGraficoEvAcc,
                  VUEFrameComponenteGraficoCronologiaAcc,
                  VUEModalCaricamentoDati,
                  VUEModal,
                  VUEFrameComponenteGraficoSpostamenti,
                  VUEFrameComponenteGraficoSpostamentiSovrapposti,
                  VUEFrameComponenteGraficoTensioneAssorbimento,
                  VUEFrameComponenteGraficoStazioneMeteo,
                  VUEColorPicker,
              },
  props: ['AltezzaPagina', 'LarghezzaPagina'],
  mixins: [MixInsDoubleClickHandler, MixInsGestioneTraduzioni, MixInsGraficiStorici],

  data()
  {
      return {
                Catena                      : null,
                Selezionato                 : false,
                SceltaRangeGrafici          : false,
                AllineamentoAperto          : false,
                ModuliInvisibili            : true,
                ColoriPantone               : COLORI_PANTONE,
                ColoriSfondo                : SFONDO,
                VettoreBottoni              : [],
                CurrentBottone              : [],
                CaricamentoDatiModuli       : false,
                ObjDal                      : {},
                ObjAl                       : {},   
                DalRicerca                  : {},   
                AlRicerca                   : {},   
                TipoGrafico                 : SystemInformation.TipoPopupAperto,
                TipiStorici                 : TIPOLOGIA_GRAFICI_STORICI,
                ModuliMostrati              : [],
                ModuliNascosti              : [],
                ObjModuliMostrati           : null,
                ObjDati                     : null,
                GraficiChange               : 0,
                GraficiAdatta               : 0,
                GraficiChangeAllSupSoglie   : 0,
                OggettoModalCaricamentoDati : new TOggettoModalCaricamentoDati(),
                VettorePorzioniDiDate       : [], 
                InDownloadDatiAcquisiti     : false,
                OperazioneAnnullata         : false,
                ArrayGrafica1               : [],
                Stacking                    : 10,
                EventiSovrapposti           : false,
                EventoSelezionato           : null,
                ListaSuperamentiSoglia      : [],
                VettoreAllSuperamenti       : [],
                MenuTrigger                 : SystemInformation.MenuTrigger,
                ListaEventiAccorpati        : [],
                SuperamentiMostrati         : [],
                Relativo                    : true,
                Mostra                      : false,
                LivelliAllarme              : {},
                PopupConfigurazione         : false,
                ColoriAllarme               : COLORI_ALLARME_CRONOLOGIA_ACC,
                GraficiAmpiezza             : true,
                ShowTabAmpiezza             : true,
                UdmX                        : 24,
                Falde                       : null,
                AltezzaFrameCronologia      : 0,
                PopupAsseX                  : false,
                PopupAsseY                  : false,
                ObjPopupAsseY               : {},
                IndexCalcolatiSpostamenti   : 0,
                UltimoSetDatiTotaliSpost    : 0,
                AsseSelezionata             : -1,
                VettoreStartValue           : [],
                ListaRighelliAccelerometri  : [],
                PopupAdattamentoAsseX       : false,
                PopupAdattamentoAsseY       : false,
                PopupChangeScalaXAccelerometri   : false,
                PopupChangeScalaYAccelerometri   : false,
                PopupChangeColoreAmpiezzaX       : false,
                PopupChangeColoreAmpiezzaY       : false,
                PopupChangeColoreAmpiezzaZ       : false,
                PopupChangeColoreFrequenza       : false,
                PopupAggiungiRighelloAccelerometri : false,
                PopupEliminaRighelloAccelerometri  : false,
                PopupColorPicker                   : false,
                RighelloToRemove                   : '',
                ColoreInModifica                   : {Colore: '#000000'},
                ObjNewRighello                     : {Data: '', Ora : '', DateTime : '',  PrettyDateTime: '', Colore: '#000000'},
                ObjNewRighelloSupSoglie            : {Millisecondi: null, Colore: '#000000'},
                NewColorAmpiezzaX                  : {Colore: '#0000ff'},
                NewColorAmpiezzaY                  : {Colore: '#ff0000'},
                NewColorAmpiezzaZ                  : {Colore: '#008000'},
                NewColorFrequenza                  : {Colore: COLORI_PANTONE.Arancione},
                ColoreAsseXInModifica              : false,
                ColoreAsseYInModifica              : false,
                ColoreAsseZInModifica              : false,
                ColoreFrequenzaInModifica          : false,
                PopupAdattamentoAsseInclinazioni : false,
                PopupAdattamentoAssePiezometri   : false,
                PopupAdattamentoAsseDeformazioni : false,
                GraficSoloPiezometri        : false,
                GraficSoloEstensimetri      : false,
                TipiUdmX                    : TIPI_UDM_X,
                PopupAdattamentoAsseTemp    : false,
                Allineamento                : {},
                SommaSpostamenti            : 0,
                SommaVelocita               : 0,
                LastData                    : '1900-01-01 00:00',
                ObjParametriPDF             : {},
                PDFExport                   : 0,
                ShowRilevamentoSoglia       : 0,
                HideRilevamentoSoglia       : 0,
                LinguaUtente                : SystemInformation.UserInformation.Lingua,
                ColoreBottoni               : COLORI_PANTONE.Marrone,
                ObjMeteo                    : {PrimoValore : true, BasePioggia : null, LastPioggia : 0},
                PopupImpostaAllarmi         : false,
                PopupImpostaAllarmiSoglie  : {
                                                SoglieDefault : {
                                                                   Blu     : 0.50,
                                                                   Giallo  : 2.00,
                                                                   Arancio : 5.00,
                                                                   Rosso   : 10.00
                                                                 },
                                                Soglie        : {
                                                                   Blu     : 0,
                                                                   Giallo  : 0,
                                                                   Arancio : 0,
                                                                   Rosso   : 0
                                                                 },
                                                EditSoglie    : null
                                              },
                BackupSoglieAllarmi        : null,
                PopupChangeScalaXGraphSupSoglie : false,
                PopupChangeScalaYGraphSupSoglie : false,
                PopupChangeScalaZGraphSupSoglie : false,
                ObjAllineamentoAsseY       : {
                                               GraphX : {
                                                          Min: 0,
                                                          Max: 10,
                                                          Udm: 1,
                                                          Changed :false
                                                        },                                               
                                               GraphY : {
                                                          Min: 0,
                                                          Max: 10,
                                                          Udm: 1,
                                                          Changed :false
                                                        },                                               
                                               GraphZ : {
                                                          Min: 0,
                                                          Max: 10,
                                                          Udm: 1,
                                                          Changed :false
                                                        }
                                             },
                PopupIntervalloProfondita  : false,
                ObjIntervalloProfondita    : {Start: null, End: null, TmpStart: null, TmpEnd: null}
             }
  },
  methods :
  {
    EsportaComePDF(Modulo = -1, IsPiezo = false, IsEst = false)
    {

      this.PDFExport++
      setTimeout(()=>{
                        this.ObjParametriPDF.PDFModulo.sort((a, b) => a.Id - b.Id);
                        this.MixInsEsportaComePDF(this.ObjParametriPDF.PDFModulo, false, this.ObjParametriPDF.PDFObjDatiGrafici, Modulo, IsPiezo, IsEst, Modulo != -1)
                      }, 300)
    },

    EsportaSingoloGrafico(Modulo, IsPiezo = false, IsEst = false)
    {
      this.EsportaComePDF(Modulo, IsPiezo, IsEst)
    },

    SoglieModificate()
    {
      this.GraficiChange++
    },

    ApriPopupAsseY()
    {
      this.PopupAsseY = true
    },

    AnnullaPopupAsseY()
    {
      this.PopupAsseY = false
    },

    ConfermaPopupAsseY()
    {
      this.PopupAsseY = false
      this.GraficiChange++
    },

    ApriPopupAsseX()
    {
      this.PopupAsseX = true
    },

    AnnullaPopupAsseX()
    {
      this.PopupAsseX = false
    },

    ConfermaPopupAsseX()
    {
      this.PopupAsseX = false
      this.GraficiChange++
      this.OnClickRicaricaDati()
    },

    ApriSinottico()
    {
      let TimeStamp = new Date(this.EventoSelezionato.Id).valueOf()
      let UrlDaAprire = '/#/appMainWindow/Sinottico?Sito=' + this.ObjDati.IdSito + '&Catena=' + this.ObjDati.IdCatena + '&Data=' + TimeStamp + '&Stacking=' + this.Stacking
      window.open(UrlDaAprire, "_blank")
    },

    ChangeDate(Valore)
    {
      this.ObjAl.Data = TZDateFunct.FormatDateTime('yyyy-mm-dd', new Date())
      this.ObjDal.Data = TZDateFunct.FormatDateTime('yyyy-mm-dd', TZDateFunct.ChangeDate(new Date(), 'day', (-1 * Valore)))
      this.OnClickRicaricaDati()
    },

    AnnullaPopupConfigurazione()
    {
      this.PopupConfigurazione = false
      this.LivelliAllarme.TempAmpiezza = TZGenericFunct.GetCopyOfObject(this.LivelliAllarme.Ampiezza)
      this.LivelliAllarme.TempFrequenza = TZGenericFunct.GetCopyOfObject(this.LivelliAllarme.Frequenza)
      this.ShowTabAmpiezza     = true 
    },

    ConfermaPopupConfigurazione()
    {
      this.LivelliAllarme.Ampiezza = TZGenericFunct.GetCopyOfObject(this.LivelliAllarme.TempAmpiezza)
      this.LivelliAllarme.Frequenza = TZGenericFunct.GetCopyOfObject(this.LivelliAllarme.TempFrequenza)
      this.PopupConfigurazione = false
      this.ShowTabAmpiezza     = true
      this.GraficiChange++ 
    },

    EsportaExcelModuli()
    {
      const wb = XLSX.utils.book_new();
      let ArrayContenitore = []
      let Row = 
      [
        { v: this.GetTraduzioneLabel('Generic','TKN_DATA',this.LinguaUtente), t: "s", s: { font: { bold: true, name: 'Calibri', sz: 13, Width: 10, color: {rgb: 'ffffff'} }, alignment:{ horizontal : 'center' }, fill: {fgColor: {rgb: 'F18B53'}}}},
        { v: this.GetTraduzioneLabel('Generic','TKN_MODULI',this.LinguaUtente), t: "s", s: { font: { bold: true, name: 'Calibri', sz: 13, Width: 10, color: {rgb: 'ffffff'} }, alignment:{ horizontal : 'center' }, fill: {fgColor: {rgb: 'F18B53'}}}},
        { v: this.GetTraduzioneLabel('VUEAppContentGraficiStorici','TKN_APP_CON_GRAF_STO_NR_SUPERAMENTI',this.LinguaUtente), t: "s", s: { font: { bold: true, name: 'Calibri', sz: 13, Width: 10, color: {rgb: 'ffffff'} }, alignment:{ horizontal : 'center' }, fill: {fgColor: {rgb: 'F18B53'}}}},
        { v: this.GetTraduzioneLabel('VUEAppContentGraficiStorici','TKN_APP_CON_GRAF_STO_MAX_X',this.LinguaUtente), t: "s", s: { font: { bold: true, name: 'Calibri', sz: 13, Width: 10, color: {rgb: 'ffffff'} }, alignment:{ horizontal : 'center' }, fill: {fgColor: {rgb: 'F18B53'}}}},
        { v: this.GetTraduzioneLabel('VUEAppContentGraficiStorici','TKN_APP_CON_GRAF_STO_MAX_Y',this.LinguaUtente), t: "s", s: { font: { bold: true, name: 'Calibri', sz: 13, Width: 10, color: {rgb: 'ffffff'} }, alignment:{ horizontal : 'center' }, fill: {fgColor: {rgb: 'F18B53'}}}},
        { v: this.GetTraduzioneLabel('VUEAppContentGraficiStorici','TKN_APP_CON_GRAF_STO_MAX_Z',this.LinguaUtente), t: "s", s: { font: { bold: true, name: 'Calibri', sz: 13, Width: 10, color: {rgb: 'ffffff'} }, alignment:{ horizontal : 'center' }, fill: {fgColor: {rgb: 'F18B53'}}}},
      ];
      ArrayContenitore.push(Row)

      this.ListaSuperamentiSoglia.forEach(function(elemento)
      {
        let StringaModuli = ''
        let ArrayModuli = []
        let MaxX = 0
        let MaxY = 0
        let MaxZ = 0
        elemento.Moduli.forEach((SingleElemento) =>
        {
          if (Math.round(Math.abs(SingleElemento.MaxAccX - SingleElemento.MinAccX)) > MaxX)
            MaxX = Math.round(Math.abs(SingleElemento.MaxAccX - SingleElemento.MinAccX))
          if (Math.round(Math.abs(SingleElemento.MaxAccY - SingleElemento.MinAccY)) > MaxY)
            MaxY = Math.round(Math.abs(SingleElemento.MaxAccY - SingleElemento.MinAccY))
          if (Math.round(Math.abs(SingleElemento.MaxAccZ - SingleElemento.MinAccZ)) > MaxZ)
            MaxZ = Math.round(Math.abs(SingleElemento.MaxAccZ - SingleElemento.MinAccZ))
          if (!ArrayModuli.includes(SingleElemento.Modulo))
          {
            if (StringaModuli != '')
              StringaModuli += ', '
            StringaModuli += SingleElemento.Modulo
            ArrayModuli.push(SingleElemento.Modulo)
          }
        })
        let RowElemento = 
        [
          { v: elemento.Id, t: "s", s: {font: {bold: false,name: 'Calibri', sz: 10  }, alignment: { horizontal : 'center' }}},
          { v: StringaModuli, t: "s", s: {font: {bold: false,name: 'Calibri', sz: 10  }, alignment: { horizontal : 'right' },}},
          { v: (elemento.Moduli.length + ''), t: "s", s: {font: {bold: false,name: 'Calibri', sz: 10  }, alignment: { horizontal : 'right' },}},
          { v: (MaxX + ''), t: "s", s: {font: {bold: false,name: 'Calibri', sz: 10  }, alignment: { horizontal : 'right' },}},
          { v: (MaxY + ''), t: "s", s: {font: {bold: false,name: 'Calibri', sz: 10  }, alignment: { horizontal : 'right' },}},
          { v: (MaxZ + ''), t: "s", s: {font: {bold: false,name: 'Calibri', sz: 10  }, alignment: { horizontal : 'right' },}},
        ];
        ArrayContenitore.push(RowElemento)
      })

      const ws = XLSX.utils.aoa_to_sheet(ArrayContenitore);
      XLSX.utils.book_append_sheet(wb, ws, 'Dati');

      var wscols = [
                      {wch:20},
                      {wch:20},
                      {wch:20},
                      {wch:30},
                      {wch:30},
                      {wch:10}
                   ];
                    
      ws['!cols'] = wscols;

      XLSX.writeFile(wb, 'ListaEvSinteticiAccel_' + this.ObjDal.Data + this.ObjDal.Ora + '_' + this.ObjAl.Data + this.ObjAl.Ora + ".xlsx");
    },

    FormattaData(DataDaFormattare)
    { 
      let [Data, Orario] = DataDaFormattare.split(' ')
      let [Anno, Mese, Giorno] = Data.split('-')
      
      let DataFormattata = `${Giorno.padStart(2, '0')}/${Mese.padStart(2, '0')}/${Anno} ${Orario}`
      return DataFormattata
    },

    EsportaExcel()
    {
      const wb = XLSX.utils.book_new();
      let ArrayContenitore = []
      let Row = 
      [
        { v: this.GetTraduzioneLabel('Generic','TKN_DATA',this.LinguaUtente), t: "s", s: { font: { bold: true, name: 'Calibri', sz: 13, Width: 10, color: {rgb: 'ffffff'} }, alignment:{ horizontal : 'center' }, fill: {fgColor: {rgb: 'F18B53'}}}},
        { v: this.GetTraduzioneLabel('Generic','TKN_MODULO',this.LinguaUtente), t: "s", s: { font: { bold: true, name: 'Calibri', sz: 13, Width: 10, color: {rgb: 'ffffff'} }, alignment:{ horizontal : 'center' }, fill: {fgColor: {rgb: 'F18B53'}}}},
        { v: this.GetTraduzioneLabel('VUEAppContentGraficiStorici','TKN_APP_CON_GRAF_STO_NR_CAMPIONI',this.LinguaUtente), t: "s", s: { font: { bold: true, name: 'Calibri', sz: 13, Width: 10, color: {rgb: 'ffffff'} }, alignment:{ horizontal : 'center' }, fill: {fgColor: {rgb: 'F18B53'}}}},
        { v: this.GetTraduzioneLabel('VUEAppContentGraficiStorici','TKN_APP_CON_GRAF_STO_PERIODO_CAMP',this.LinguaUtente), t: "s", s: { font: { bold: true, name: 'Calibri', sz: 13, Width: 10, color: {rgb: 'ffffff'} }, alignment:{ horizontal : 'center' }, fill: {fgColor: {rgb: 'F18B53'}}}},
        { v: this.GetTraduzioneLabel('VUEAppContentGraficiStorici','TKN_APP_CON_GRAF_STO_CAMP_PRE_ROLL',this.LinguaUtente), t: "s", s: { font: { bold: true, name: 'Calibri', sz: 13, Width: 10, color: {rgb: 'ffffff'} }, alignment:{ horizontal : 'center' }, fill: {fgColor: {rgb: 'F18B53'}}}},
        { v: this.GetTraduzioneLabel('VUEAppContentGraficiStorici','TKN_APP_CON_GRAF_STO_MIN_X',this.LinguaUtente), t: "s", s: { font: { bold: true, name: 'Calibri', sz: 13, Width: 10, color: {rgb: 'ffffff'} }, alignment:{ horizontal : 'center' }, fill: {fgColor: {rgb: 'F18B53'}}}},
        { v: this.GetTraduzioneLabel('VUEAppContentGraficiStorici','TKN_APP_CON_GRAF_STO_MAX_X',this.LinguaUtente), t: "s", s: { font: { bold: true, name: 'Calibri', sz: 13, Width: 10, color: {rgb: 'ffffff'} }, alignment:{ horizontal : 'center' }, fill: {fgColor: {rgb: 'F18B53'}}}},
        { v: this.GetTraduzioneLabel('VUEAppContentGraficiStorici','TKN_APP_CON_GRAF_STO_MIN_Y',this.LinguaUtente), t: "s", s: { font: { bold: true, name: 'Calibri', sz: 13, Width: 10, color: {rgb: 'ffffff'} }, alignment:{ horizontal : 'center' }, fill: {fgColor: {rgb: 'F18B53'}}}},
        { v: this.GetTraduzioneLabel('VUEAppContentGraficiStorici','TKN_APP_CON_GRAF_STO_MAX_Y',this.LinguaUtente), t: "s", s: { font: { bold: true, name: 'Calibri', sz: 13, Width: 10, color: {rgb: 'ffffff'} }, alignment:{ horizontal : 'center' }, fill: {fgColor: {rgb: 'F18B53'}}}},
        { v: this.GetTraduzioneLabel('VUEAppContentGraficiStorici','TKN_APP_CON_GRAF_STO_MIN_Z',this.LinguaUtente), t: "s", s: { font: { bold: true, name: 'Calibri', sz: 13, Width: 10, color: {rgb: 'ffffff'} }, alignment:{ horizontal : 'center' }, fill: {fgColor: {rgb: 'F18B53'}}}},
        { v: this.GetTraduzioneLabel('VUEAppContentGraficiStorici','TKN_APP_CON_GRAF_STO_MAX_Z',this.LinguaUtente), t: "s", s: { font: { bold: true, name: 'Calibri', sz: 13, Width: 10, color: {rgb: 'ffffff'} }, alignment:{ horizontal : 'center' }, fill: {fgColor: {rgb: 'F18B53'}}}},
      ];
      ArrayContenitore.push(Row)

      let ListaSuperamenti = []
      this.ListaSuperamentiSoglia.forEach((element)=>
      {
        element.Moduli.forEach((voce) =>
        {
          ListaSuperamenti.push(voce)
        })
      })

      ListaSuperamenti.sort((a,b) => 
      {
        if (a.Modulo == b.Modulo)
          return a.DataEffettiva < b.DataEffettiva ? -1 : 1
        else
          return a.Modulo < b.Modulo ? -1 : 1
      })

      ListaSuperamenti.forEach((elemento) =>
      {
        let RowElemento = 
        [
          { v: TZDateFunct.FormatDateTime('dd/mm/yyyy hh:nn:ss', new Date(elemento.DataEffettiva)), t: "s", s: {font: {bold: false,name: 'Calibri', sz: 10  }, alignment: { horizontal : 'center' }}},
          { v: (elemento.Modulo + ''), t: "s", s: {font: {bold: false,name: 'Calibri', sz: 10  }, alignment: { horizontal : 'right' },}},
          { v: (elemento.Campioni.length + ''), t: "s", s: {font: {bold: false,name: 'Calibri', sz: 10  }, alignment: { horizontal : 'right' },}},
          { v: (elemento.PeriodoCampionamento + ''), t: "s", s: {font: {bold: false,name: 'Calibri', sz: 10  }, alignment: { horizontal : 'right' },}},
          { v: (elemento.NrCampioniPreRoll + ''), t: "s", s: {font: {bold: false,name: 'Calibri', sz: 10  }, alignment: { horizontal : 'right' },}},
          { v: (Math.trunc(elemento.MinAccX) + ''), t: "s", s: {font: {bold: false,name: 'Calibri', sz: 10  }, alignment: { horizontal : 'right' },}},
          { v: (Math.trunc(elemento.MaxAccX) + ''), t: "s", s: {font: {bold: false,name: 'Calibri', sz: 10  }, alignment: { horizontal : 'right' },}},
          { v: (Math.trunc(elemento.MinAccY) + ''), t: "s", s: {font: {bold: false,name: 'Calibri', sz: 10  }, alignment: { horizontal : 'right' },}},
          { v: (Math.trunc(elemento.MaxAccY) + ''), t: "s", s: {font: {bold: false,name: 'Calibri', sz: 10  }, alignment: { horizontal : 'right' },}},
          { v: (Math.trunc(elemento.MinAccZ) + ''), t: "s", s: {font: {bold: false,name: 'Calibri', sz: 10  }, alignment: { horizontal : 'right' },}},
          { v: (Math.trunc(elemento.MaxAccZ) + ''), t: "s", s: {font: {bold: false,name: 'Calibri', sz: 10  }, alignment: { horizontal : 'right' },}},
        ];
        ArrayContenitore.push(RowElemento)
      })

      // this.ListaSuperamentiSogllia.forEach(function(Evento)
      // {
      //   Evento.Moduli.forEach((elemento) =>
      //   {
      //     let RowElemento = 
      //     [
      //       { v: TZDateFunct.FormatDateTime('dd/mm/yyyy hh:nn', new Date(elemento.DataEffettiva)), t: "s", s: {font: {bold: false,name: 'Calibri', sz: 10  }, alignment: { horizontal : 'center' }}},
      //       { v: (elemento.Modulo + ''), t: "s", s: {font: {bold: false,name: 'Calibri', sz: 10  }, alignment: { horizontal : 'right' },}},
      //       { v: (elemento.Campioni.length + ''), t: "s", s: {font: {bold: false,name: 'Calibri', sz: 10  }, alignment: { horizontal : 'right' },}},
      //       { v: (elemento.PeriodoCampionamento + ''), t: "s", s: {font: {bold: false,name: 'Calibri', sz: 10  }, alignment: { horizontal : 'right' },}},
      //       { v: (elemento.NrCampioniPreRoll + ''), t: "s", s: {font: {bold: false,name: 'Calibri', sz: 10  }, alignment: { horizontal : 'right' },}},
      //       { v: (Math.trunc(elemento.MinAccX) + ''), t: "s", s: {font: {bold: false,name: 'Calibri', sz: 10  }, alignment: { horizontal : 'right' },}},
      //       { v: (Math.trunc(elemento.MaxAccX) + ''), t: "s", s: {font: {bold: false,name: 'Calibri', sz: 10  }, alignment: { horizontal : 'right' },}},
      //       { v: (Math.trunc(elemento.MinAccY) + ''), t: "s", s: {font: {bold: false,name: 'Calibri', sz: 10  }, alignment: { horizontal : 'right' },}},
      //       { v: (Math.trunc(elemento.MaxAccY) + ''), t: "s", s: {font: {bold: false,name: 'Calibri', sz: 10  }, alignment: { horizontal : 'right' },}},
      //       { v: (Math.trunc(elemento.MinAccZ) + ''), t: "s", s: {font: {bold: false,name: 'Calibri', sz: 10  }, alignment: { horizontal : 'right' },}},
      //       { v: (Math.trunc(elemento.MaxAccZ) + ''), t: "s", s: {font: {bold: false,name: 'Calibri', sz: 10  }, alignment: { horizontal : 'right' },}},
      //     ];
      //     ArrayContenitore.push(RowElemento)
      //   })
      // })

      const ws = XLSX.utils.aoa_to_sheet(ArrayContenitore);
      XLSX.utils.book_append_sheet(wb, ws, 'Dati');

      var wscols = [
                      {wch:20},
                      {wch:20},
                      {wch:20},
                      {wch:30},
                      {wch:30},
                      {wch:10},
                      {wch:10},
                      {wch:10},
                      {wch:10},
                      {wch:10},
                      {wch:10},
                   ];
                    
      ws['!cols'] = wscols;

      XLSX.writeFile(wb, 'ListaEvSinteticiAccel_' + this.ObjDal.Data + this.ObjDal.Ora + '_' + this.ObjAl.Data + this.ObjAl.Ora + ".xlsx");
    },

    EsportaXLSXAllSupSoglie()
    {      
      const wb = XLSX.utils.book_new();
      let DataNomeFile = ''
      let ArrayContenitore = []
      this.GraficiEventoSelezionato.forEach((SingleEvento) =>
      {
        if (DataNomeFile != '')
          DataNomeFile += '_'
        DataNomeFile += SingleEvento.DataEffettiva
        let DataStart = Date.parse(SingleEvento.DataEffettiva) + SingleEvento.Millisecondi

        let RigaIntestazione  = [
                                  {v: this.GetTraduzioneLabel('Generic','TKN_MOD_NR',this.LinguaUtente), t: "s", s: { font: { bold: true, name: 'Calibri', sz: 13, Width: 10, }, alignment:{ horizontal : 'center' }}},
                                  {v: SingleEvento.Modulo, t: "s", s: { font: { bold: true, name: 'Calibri', sz: 13, Width: 10, }, alignment:{ horizontal : 'center' }}},
                                  {v: this.GetTraduzioneLabel('Generic','TKN_PROFONDITA',this.LinguaUtente), t: "s", s: { font: { bold: true, name: 'Calibri', sz: 13, Width: 10, }, alignment:{ horizontal : 'center' }}},
                                  {v: SingleEvento.Profondita, t: "s", s: { font: { bold: true, name: 'Calibri', sz: 13, Width: 10, }, alignment:{ horizontal : 'center' }}},
                                  // {v: this.GetTraduzioneLabel('Generic','TKN_DATA',this.LinguaUtente), t: "s", s: { font: { bold: true, name: 'Calibri', sz: 13, Width: 10, }, alignment:{ horizontal : 'center' }}},
                                  // {v: SingleEvento.DataEffettiva, t: "s", s: { font: { bold: true, name: 'Calibri', sz: 13, Width: 10, }, alignment:{ horizontal : 'center' }}},
                                ]
        ArrayContenitore.push(RigaIntestazione)
        let Row = 
        [
          { v: this.GetTraduzioneLabel('Generic','TKN_DATA',this.LinguaUtente), t: "s", s: { font: { bold: true, name: 'Calibri', sz: 13, Width: 10, color: {rgb: 'ffffff'} }, alignment:{ horizontal : 'center' }, fill: {fgColor: {rgb: 'F18B53'}}}},
          { v: this.GetTraduzioneLabel('Generic','TKN_ASSE_X',this.LinguaUtente), t: "s", s: { font: { bold: true, name: 'Calibri', sz: 13, Width: 10, color: {rgb: 'ffffff'} }, alignment:{ horizontal : 'center' }, fill: {fgColor: {rgb: 'F18B53'}}}},
          { v: this.GetTraduzioneLabel('Generic','TKN_ASSE_Y',this.LinguaUtente), t: "s", s: { font: { bold: true, name: 'Calibri', sz: 13, Width: 10, color: {rgb: 'ffffff'} }, alignment:{ horizontal : 'center' }, fill: {fgColor: {rgb: 'F18B53'}}}},
          { v: this.GetTraduzioneLabel('Generic','TKN_ASSE_Z',this.LinguaUtente), t: "s", s: { font: { bold: true, name: 'Calibri', sz: 13, Width: 10, color: {rgb: 'ffffff'} }, alignment:{ horizontal : 'center' }, fill: {fgColor: {rgb: 'F18B53'}}}},
        ];
        ArrayContenitore.push(Row)

        SingleEvento.Campioni.forEach(function(elemento)
        {
          let RowElemento = 
          [
            { v: TZDateFunct.FormatDateTime("dd/mm/yyyy hh:nn:ss:lll", new Date(DataStart)), t: "s", s: {font: {bold: false,name: 'Calibri', sz: 10  }, alignment: { horizontal : 'center' },}},
            { v: (elemento.X).toFixed(1), t: "s", s: {font: {bold: false,name: 'Calibri', sz: 10  }, alignment: { horizontal : 'right' },}},
            { v: (elemento.Y).toFixed(1), t: "s", s: {font: {bold: false,name: 'Calibri', sz: 10  }, alignment: { horizontal : 'right' },}},
            { v: (elemento.Z).toFixed(1), t: "s", s: {font: {bold: false,name: 'Calibri', sz: 10  }, alignment: { horizontal : 'right' },}},
          ];
          ArrayContenitore.push(RowElemento)
          DataStart += SingleEvento.PeriodoCampionamento
        })
        ArrayContenitore.push([])
      })
      const ws = XLSX.utils.aoa_to_sheet(ArrayContenitore);
      XLSX.utils.book_append_sheet(wb, ws, 'Dati');

      var wscols  = [
                      {wch:20},
                      {wch:20},
                      {wch:20},
                      {wch:20},
                      {wch:20},
                      {wch:30},
                    ];
                    
      ws['!cols'] = wscols;

      XLSX.writeFile(wb, 'ListaEvSinteticiAccel_' + DataNomeFile + ".xlsx");
    },

    GetStyleEvento(Evento)
    {
      let Style = {}
      if (Evento.Evidenziato)
        Style['background-color'] = this.ColoriPantone.Arancione
      if (!Evento.Letto)
        Style['font-weight'] = 'bold'
      return Style
    },

    EvidenziaEvento(Evento)
    {
      this.ListaSuperamentiSoglia.forEach((element) => {element.Evidenziato = false})
      Evento.Evidenziato = true
      this.EventoSelezionato = Evento
      this.ListaRighelliAccelerometri = []
      this.MixInsGetUltimaData()
      this.MixInsSegnaComeLetto(Evento)
      if(this.TipoGrafico != this.TipiStorici.EV_ACCELEROMETRICI_CRONOLOGIA)
        this.MixInsCaricaCampioniSingleEvento(Evento)
    },

    OnClickRicaricaDati()
    {
      this.ModuliMostrati = []
      this.VettoreStartValue = []
      this.SommaSpostamenti  = 0
      if(this.Catena.OggettoTotaleSpostamento != null)
        this.Catena.OggettoTotaleSpostamento = null      
      this.ObjMeteo = {PrimoValore : true, BasePioggia : null, LastPioggia : 0}
      this.GetPorzioniDiDate()
      this.MaxYCampioniRilevati(this.Catena)
      this.MixInsDownloadDatiAcquisitiModuli(this.Catena)
    },

    OnClickSelezionaTutti()
    {
      this.Catena.Sensori.forEach(element => 
      {
        element.Selezionato = true
      });
    },    

    OnClickSelezionaNessuno()
    {
      this.Catena.Sensori.forEach(element => 
      {
        element.Selezionato = false
      });
    },    

    OnClickInvertiSelezione()
    {
      this.Catena.Sensori.forEach(element => 
      {
        element.Selezionato = !element.Selezionato
      });
    },

    IsInRangeFiltroProfondita(Profondita)
    {
      if (this.ObjIntervalloProfondita.Start != null && this.ObjIntervalloProfondita.End != null)
        return Profondita <= this.ObjIntervalloProfondita.End && Profondita >= this.ObjIntervalloProfondita.Start
      return true 
    },

    OnClickFiltraProfondita()
    {
      this.ObjIntervalloProfondita.TmpStart = this.ObjIntervalloProfondita.Start
      this.ObjIntervalloProfondita.TmpEnd   = this.ObjIntervalloProfondita.End
      this.PopupIntervalloProfondita = true
    },

    ConfermaIntervalloProfondita()
    {
      this.ObjIntervalloProfondita.Start = this.ObjIntervalloProfondita.TmpStart
      this.ObjIntervalloProfondita.End   = this.ObjIntervalloProfondita.TmpEnd
      this.Catena.Sensori.forEach((element) => {element.Selezionato = this.IsInRangeFiltroProfondita(element.Profondita)})
      this.PopupIntervalloProfondita = false
    },

    AnnullaIntervalloProfondita()
    {
      this.PopupIntervalloProfondita = false
      this.ObjIntervalloProfondita.TmpStart = null
      this.ObjIntervalloProfondita.TmpEnd   = null
    },
    
    ApriPopupConfigurazione()
    {
      this.PopupConfigurazione = true
    },

    OnClickAdattaAssi()
    {
      switch(this.AsseSelezionata)
      {
        case 0 : this.PopupAdattamentoAsseX    = true;break
        case 1 : this.PopupAdattamentoAsseY    = true;break
        case 2 : this.PopupAdattamentoAsseTemp = true;break
        default : break
      }
    },
    
    OnClickAdattaAsseX()
    {
      this.PopupAdattamentoAsseX = true
      this.AllineamentoAperto    = false
    },

    OnClickAdattaAsseY()
    {
      this.PopupAdattamentoAsseY = true
      this.AllineamentoAperto    = false
    },

    OnClickChangeScalaXAccelerometri()
    {
      this.Allineamento.AxisX.UdmX        = 1
      this.Allineamento.AxisX.TipoUdmX    = 0
      this.PopupChangeScalaXAccelerometri = true
      this.AllineamentoAperto             = false
    },

    OnClickChangeScalaYAccelerometri()
    {
      this.Allineamento.AxisY.Max         = 10
      this.Allineamento.AxisY.Min         = 0
      this.Allineamento.AxisY.Udm         = 1
      this.PopupChangeScalaYAccelerometri = true
      this.AllineamentoAperto             = false
    },

    OnClickChangeScalaGraphXSupSoglie()
    {
      this.ResetUpdated()
      this.ObjAllineamentoAsseY.GraphX.Max = 10
      this.ObjAllineamentoAsseY.GraphX.Min = 0
      this.ObjAllineamentoAsseY.GraphX.Udm = 1
      this.PopupChangeScalaXGraphSupSoglie = true
      this.AllineamentoAperto              = false
    },

    OnClickChangeScalaGraphYSupSoglie()
    {
      this.ResetUpdated()
      this.ObjAllineamentoAsseY.GraphY.Max = 10
      this.ObjAllineamentoAsseY.GraphY.Min = 0
      this.ObjAllineamentoAsseY.GraphY.Udm = 1
      this.PopupChangeScalaYGraphSupSoglie = true
      this.AllineamentoAperto              = false
    },

    OnClickChangeScalaGraphZSupSoglie()
    {
      this.ResetUpdated()
      this.ObjAllineamentoAsseY.GraphZ.Max = 10
      this.ObjAllineamentoAsseY.GraphZ.Min = 0
      this.ObjAllineamentoAsseY.GraphZ.Udm = 1
      this.PopupChangeScalaZGraphSupSoglie = true
      this.AllineamentoAperto              = false
    },

    ResetUpdated()
    {      
      this.ObjAllineamentoAsseY.GraphX.Updated = false
      this.ObjAllineamentoAsseY.GraphY.Updated = false
      this.ObjAllineamentoAsseY.GraphZ.Updated = false
    },

    AnnullaPopupGraphSupSoglie()
    {
      this.PopupChangeScalaXGraphSupSoglie = false
      this.PopupChangeScalaYGraphSupSoglie = false
      this.PopupChangeScalaZGraphSupSoglie = false
    },

    OnClickChangeColoreAmpiezzaX()
    {
      this.ColoreAsseXInModifica      = true
      this.PopupChangeColoreAmpiezzaX = true
      this.AllineamentoAperto         = false
    },

    OnClickChangeColoreAmpiezzaY()
    {
      this.ColoreAsseYInModifica      = true
      this.PopupChangeColoreAmpiezzaY = true
      this.AllineamentoAperto         = false
    },

    OnClickChangeColoreAmpiezzaZ()
    {
      this.ColoreAsseZInModifica      = true
      this.PopupChangeColoreAmpiezzaZ = true
      this.AllineamentoAperto         = false
    },

    OnClickChangeColoreFrequenza()
    {
      this.ColoreFrequenzaInModifica  = true
      this.PopupChangeColoreFrequenza = true
      this.AllineamentoAperto         = false
    },

    OnClickAggiungiRighelloAccelerometri()
    {
      this.PopupAggiungiRighelloAccelerometri = true
      this.AllineamentoAperto                 = false
    },

    OnClickEliminaRighelloAccelerometri()
    {
      this.PopupEliminaRighelloAccelerometri = true
      this.AllineamentoAperto                = false
    },

    MostraAllSoglieRilevamento()
    {
      this.ShowRilevamentoSoglia++
      this.AllineamentoAperto = false
    },

    NascondiAllSoglieRilevamento()
    {
      this.HideRilevamentoSoglia++
      this.AllineamentoAperto = false
    },

    OnClickAdattaAsseInclinazioni()
    {
      this.PopupAdattamentoAsseInclinazioni = true
      this.AllineamentoAperto    = false
    },

    OnClickAdattaAssePiezometri()
    {
      this.PopupAdattamentoAssePiezometri = true
      this.AllineamentoAperto    = false
    },

    OnClickAdattaAsseDeformazioni()
    {
      this.PopupAdattamentoAsseDeformazioni = true
      this.AllineamentoAperto    = false
    },

    OnClickAdattaAsseTemp()
    {
      this.PopupAdattamentoAsseTemp = true
      this.AllineamentoAperto       = false
    },
    
    ChangeScalaXAccelerometri()
    {
      if(this.Catena.OggettoTotaleSpostamento)
      {
        this.Catena.OggettoTotaleSpostamento.AdattaUdmX      = this.Allineamento.AxisX.UdmX
        this.Catena.OggettoTotaleSpostamento.AdattaTipoUdmX  = this.Allineamento.AxisX.TipoUdmX
        this.Catena.OggettoTotaleSpostamento.ModificatoAsseX = true
      }
      
      this.Catena.Sensori.forEach(Modulo => 
                                  {
                                    Modulo.GlobalAdattaUdmX      = this.Allineamento.AxisX.UdmX
                                    Modulo.GlobalAdattaTipoUdmX  = this.Allineamento.AxisX.TipoUdmX
                                    Modulo.GlobalModificatoAsseX = true
                                  });
                                  
      this.GraficiChange++
      this.PopupChangeScalaXAccelerometri = false
    },
    
    ChangeScalaYAccelerometri()
    {
      this.Catena.Sensori.forEach(Modulo => 
                                 {
                                    Modulo.GlobalMaxAdattamentoAsseY = this.Allineamento.AxisY.Max
                                    Modulo.GlobalMinAdattamentoAsseY = this.Allineamento.AxisY.Min
                                    Modulo.GlobalUdmY                = this.Allineamento.AxisY.Udm
                                 });

      this.GraficiChange++
      this.PopupChangeScalaYAccelerometri = false 
    },
    
    ChangeScalaAccelerometriSupSoglie()
    {
      this.ObjAllineamentoAsseY.GraphX.Updated = this.PopupChangeScalaXGraphSupSoglie
      this.ObjAllineamentoAsseY.GraphY.Updated = this.PopupChangeScalaYGraphSupSoglie
      this.ObjAllineamentoAsseY.GraphZ.Updated = this.PopupChangeScalaZGraphSupSoglie
      this.GraficiChangeAllSupSoglie++
      this.PopupChangeScalaXGraphSupSoglie = false
      this.PopupChangeScalaYGraphSupSoglie = false
      this.PopupChangeScalaZGraphSupSoglie = false
    },
    
    ChangeColoreAmpiezzaX()
    {
      this.Catena.Sensori.forEach(Modulo => 
                                 {
                                    Modulo.NewColorAmpiezzaX = this.NewColorAmpiezzaX.Colore
                                 });

      this.GraficiChange++
      this.PopupChangeColoreAmpiezzaX = false 
    },
    
    ChangeColoreAmpiezzaY()
    {
      this.Catena.Sensori.forEach(Modulo => 
                                 {
                                    Modulo.NewColorAmpiezzaY = this.NewColorAmpiezzaY.Colore
                                 });

      this.GraficiChange++
      this.PopupChangeColoreAmpiezzaY = false 
    },
    
    ChangeColoreAmpiezzaZ()
    {
      this.Catena.Sensori.forEach(Modulo => 
                                 {
                                    Modulo.NewColorAmpiezzaZ = this.NewColorAmpiezzaZ.Colore
                                 });

      this.GraficiChange++
      this.PopupChangeColoreAmpiezzaZ = false 
    },
    
    ChangeColoreFrequenza()
    {
      this.Catena.Sensori.forEach(Modulo => 
                                 {
                                    Modulo.NewColorFrequenza = this.NewColorFrequenza.Colore
                                 });

      this.GraficiChange++
      this.PopupChangeColoreFrequenza = false 
    },
    
    AggiungiRighelloAccelerometri()
    {     
      this.ObjNewRighello.DateTime = this.ObjNewRighello.Data + ' ' + this.ObjNewRighello.Ora
      this.ObjNewRighello.PrettyDateTime = TZDateFunct.FormatDateTime('dd/mm/yyyy hh:nn', new Date(this.ObjNewRighello.DateTime))
      this.Catena.Sensori.forEach(Modulo => 
                                 {
                                    Modulo.RighelloGlobale = this.ObjNewRighello
                                 });
      this.GraficiChange++
      this.ListaRighelliAccelerometri.push(this.ObjNewRighello)
      this.ResetRighello()
      this.PopupAggiungiRighelloAccelerometri = false
    },
    
    AggiungiRighelloAccelerometriSupSoglie()
    {     
      // this.Catena.Sensori.forEach(Modulo => 
      //                            {
      //                               Modulo.RighelloGlobale = this.ObjNewRighelloSupSoglie
      //                            });
      this.ListaRighelliAccelerometri.push(this.ObjNewRighelloSupSoglie)
      this.GraficiChange++
      this.ObjNewRighelloSupSoglie = {Millisecondi: null, Colore: "#000000"}
      this.PopupAggiungiRighelloAccelerometri = false
    },

    ResetRighello()
    {
      let NewRighello            = {}
      NewRighello.Data           = ''
      NewRighello.Ora            = ''
      NewRighello.Colore         = 'black'
      NewRighello.DateTime       = ''
      NewRighello.PrettyDateTime = ''
      this.ObjNewRighello        = NewRighello
    },

    EliminaRighelloAccelerometri()
    {     
      this.Catena.Sensori.forEach(Modulo => 
                                 {
                                    Modulo.RighelloGlobaleDaRimuovere = this.RighelloToRemove
                                 });
                                 
      let index = this.ListaRighelliAccelerometri.findIndex((element) => {return element.PrettyDateTime == this.RighelloToRemove})
      this.ListaRighelliAccelerometri.splice(index, 1)
      this.GraficiChange++
      this.PopupEliminaRighelloAccelerometri = false
    },

    EliminaRighelloAccelerometriSupSoglie()
    {     
      this.Catena.Sensori.forEach(Modulo => 
                                 {
                                    Modulo.RighelloGlobaleDaRimuovere = this.RighelloToRemove
                                 });
                                 
      let index = this.ListaRighelliAccelerometri.findIndex((element) => {return element.PrettyDateTime == this.RighelloToRemove || element.Millisecondi == this.RighelloToRemove})
      this.ListaRighelliAccelerometri.splice(index, 1)
      this.GraficiChange++
      this.PopupEliminaRighelloAccelerometri = false
    },

    ApriPopupColorPicker(Colore)
    {
      this.ColoreInModifica.Colore = Colore
      this.PopupColorPicker = true
    },

    ConfermaColore()
    {
      if(this.ColoreAsseXInModifica)
      {
        this.NewColorAmpiezzaX.Colore = this.ColoreInModifica.Colore
        this.ColoreAsseXInModifica = false
      }
      else if(this.ColoreAsseYInModifica)
      {
        this.NewColorAmpiezzaY.Colore = this.ColoreInModifica.Colore
        this.ColoreAsseYInModifica = false
      }
      else if(this.ColoreAsseZInModifica)
      {
        this.NewColorAmpiezzaZ.Colore = this.ColoreInModifica.Colore
        this.ColoreAsseZInModifica = false
      }
      else if(this.ColoreFrequenzaInModifica)
      {
        this.NewColorFrequenza.Colore = this.ColoreInModifica.Colore
        this.ColoreFrequenzaInModifica = false
      }
      else 
      {
        this.ObjNewRighello.Colore = this.ColoreInModifica.Colore
        this.ObjNewRighelloSupSoglie.Colore = this.ColoreInModifica.Colore
      }
      this.AnnullaColore()
    },

    AnnullaColore()
    {
      this.ColoreInModifica = {}
      this.PopupColorPicker = false
    },

    ChangeAdattamentoAsseX()
    {
      if(this.Catena.OggettoTotaleSpostamento)
      {
        this.Catena.OggettoTotaleSpostamento.AdattaUdmX      = this.Allineamento.AxisX.UdmX
        this.Catena.OggettoTotaleSpostamento.AdattaTipoUdmX  = this.Allineamento.AxisX.TipoUdmX
        this.Catena.OggettoTotaleSpostamento.ModificatoAsseX = true
      }
      
      this.Catena.Sensori.forEach(Modulo => 
                                  {
                                    Modulo.AdattaUdmX      = this.Allineamento.AxisX.UdmX
                                    Modulo.AdattaTipoUdmX  = this.Allineamento.AxisX.TipoUdmX
                                    Modulo.ModificatoAsseX = true
                                  });
      this.GraficiChange++
      this.PopupAdattamentoAsseX = false
    },

    OnClickAllineamento()
    {
      this.AllineamentoAperto = !this.AllineamentoAperto
    },

    ChangeAdattamentoAsseY()
    {      
      if(this.Catena.OggettoTotaleSpostamento)
      {
        this.Catena.OggettoTotaleSpostamento.MaxAdattamentoAsseYSpost = this.Allineamento.AxisY.Max
        this.Catena.OggettoTotaleSpostamento.MinAdattamentoAsseYSpost = this.Allineamento.AxisY.Min
        this.Catena.OggettoTotaleSpostamento.UdmYSpost                = this.Allineamento.AxisY.Udm
        this.Catena.OggettoTotaleSpostamento.ModificatoAsseY          = true
      }

      this.Catena.Sensori.forEach(Modulo => 
                                 {
                                   if(Modulo.Estensimetro != undefined && Modulo.Estensimetro)
                                   {
                                     Modulo.MaxAdattamentoAsseYDef = this.Allineamento.AxisY.Max
                                     Modulo.MinAdattamentoAsseYDef = this.Allineamento.AxisY.Min
                                     Modulo.UdmYDef                = this.Allineamento.AxisY.Udm
                                   }
                                   else if(Modulo.Piezometro != undefined && Modulo.Piezometro)
                                   {
                                     Modulo.MaxAdattamentoAsseYPress = this.Allineamento.AxisY.Max
                                     Modulo.MinAdattamentoAsseYPress = this.Allineamento.AxisY.Min
                                     Modulo.UdmYPress                = this.Allineamento.AxisY.Udm
                                   }
                                   else
                                   {
                                    Modulo.MaxAdattamentoAsseY = this.Allineamento.AxisY.Max
                                    Modulo.MinAdattamentoAsseY = this.Allineamento.AxisY.Min
                                    Modulo.UdmY                = this.Allineamento.AxisY.Udm
                                   }
                                    if(Modulo.MaxAdattamentoAsseYAccel != undefined)
                                      Modulo.MaxAdattamentoAsseYAccel = this.Allineamento.AxisY.Max
                                    if(Modulo.MinAdattamentoAsseYAccel != undefined)
                                      Modulo.MinAdattamentoAsseYAccel = this.Allineamento.AxisY.Min
                                    if(Modulo.UdmYAccel != undefined)
                                      Modulo.UdmYAccel = this.Allineamento.AxisY.Udm

                                    if(Modulo.MaxAdattamentoAsseYSpost != undefined)
                                      Modulo.MaxAdattamentoAsseYSpost = this.Allineamento.AxisY.Max
                                    if(Modulo.MinAdattamentoAsseYSpost != undefined)
                                      Modulo.MinAdattamentoAsseYSpost = this.Allineamento.AxisY.Min
                                    if(Modulo.UdmYSpost != undefined)
                                      Modulo.UdmYSpost = this.Allineamento.AxisY.Udm

                                    if(Modulo.MaxAdattamentoAsseYVel != undefined)
                                      Modulo.MaxAdattamentoAsseYVel = this.Allineamento.AxisY.Max
                                    if(Modulo.MinAdattamentoAsseYVel != undefined)
                                      Modulo.MinAdattamentoAsseYVel = this.Allineamento.AxisY.Min
                                    if(Modulo.UdmYVel != undefined)
                                      Modulo.UdmYVel = this.Allineamento.AxisY.Udm
                                 });

      this.GraficiChange++
      this.PopupAdattamentoAsseY = false
    },

    ChangeAdattamentoDeformazioni()
    {     
      this.Catena.Sensori.forEach(Modulo => 
                                 {
                                   if(Modulo.Estensimetro != undefined && Modulo.Estensimetro)
                                   {
                                     Modulo.MaxAdattamentoAsseYDef = this.Allineamento.AxisYDef.Max
                                     Modulo.MinAdattamentoAsseYDef = this.Allineamento.AxisYDef.Min
                                     Modulo.UdmYDef                = this.Allineamento.AxisYDef.Udm
                                   }
                                 });

      this.GraficiChange++      
      this.PopupAdattamentoAsseDeformazioni = false
    },

    ChangeAdattamentoPiezometri()
    {     
      this.Catena.Sensori.forEach(Modulo => 
                                 {
                                   if(Modulo.Piezometro != undefined && Modulo.Piezometro)
                                   {
                                     Modulo.MaxAdattamentoAsseYPress = this.Allineamento.AxisYPress.Max
                                     Modulo.MinAdattamentoAsseYPress = this.Allineamento.AxisYPress.Min
                                     Modulo.UdmYPress                = this.Allineamento.AxisYPress.Udm
                                   }
                                 });

      this.GraficiChange++
      this.PopupAdattamentoAssePiezometri = false
    },

    ChangeAdattamentoInclinometri()
    {     
      this.Catena.Sensori.forEach(Modulo => 
                                 {
                                    Modulo.MaxAdattamentoAsseY = this.Allineamento.AxisY.Max
                                    Modulo.MinAdattamentoAsseY = this.Allineamento.AxisY.Min
                                    Modulo.UdmY                = this.Allineamento.AxisY.Udm
                                 });

      this.GraficiChange++
      this.PopupAdattamentoAsseInclinazioni = false
    },

    ChangeAdattamentoAsseTemp()
    {
      this.Catena.Sensori.forEach(Modulo => 
                                {
                                  Modulo.MaxAdattamentoAsseTemp = this.Allineamento.AxisTemp.Max
                                  Modulo.MinAdattamentoAsseTemp = this.Allineamento.AxisTemp.Min
                                  Modulo.UdmTemp                = this.Allineamento.AxisTemp.Udm
                                });
      this.GraficiChange++
      this.PopupAdattamentoAsseTemp = false
    },

    GetCumulativoPioggia()
    {
      if(this.Catena.DatiMeteo.Dati.length != 0)
      {
        this.Catena.DatiMeteo.Dati.sort(function(a,b)
        {
          if(a.Data < b.Data)
            return -1
          if(a.Data > b.Data)
            return 1
          return 0
        })

        // var PrimoValore = true
        // var BasePioggia = null;
        // var LastPioggia = 0;

        for(let i = 0; i < this.Catena.DatiMeteo.Dati.length; i++)
        { 
          let Dato = this.Catena.DatiMeteo.Dati[i]

          if(Dato.Pioggia != null)
          {
            if(this.ObjMeteo.PrimoValore)
            {
              this.ObjMeteo.PrimoValore = false;
              this.ObjMeteo.BasePioggia = (-1) * Dato.Pioggia;
            }
            if(this.ObjMeteo.LastPioggia > Dato.Pioggia)
            {
              if((Dato.Pioggia = 0) || Math.abs((this.ObjMeteo.LastPioggia - Dato.Pioggia) > 0.5))
              {
                this.ObjMeteo.BasePioggia = this.ObjMeteo.BasePioggia + this.ObjMeteo.LastPioggia;
                Dato.PioggiaCumulata      = Dato.Pioggia + this.ObjMeteo.BasePioggia;
                this.ObjMeteo.LastPioggia = Dato.Pioggia;
              }
              else Dato.PioggiaCumulata = this.ObjMeteo.LastPioggia + this.ObjMeteo.BasePioggia;
            }
            else 
            {
              Dato.PioggiaCumulata      = Dato.Pioggia + this.ObjMeteo.BasePioggia;
              this.ObjMeteo.LastPioggia = Dato.Pioggia;
            }
          }
        }
      }
    },

    SegnaComeNonLetto(Evento = null)
    {
      let ObjQuery = {Operazioni : []}
      if (Evento != null)
      {
        if (Evento.Letto)
        {
          Evento.Letto = false
          for (let  i = 0; i < Evento.Moduli.length; i++)
          {
            if (Evento.Moduli[i].Letto)
            {
              let Modulo = Evento.Moduli[i]
              Modulo.Letto = false            
              let ObjCatena = {Query : 'SegnaComeNonLetto', Parametri: {}}
              ObjCatena.Parametri = {
                                      Data   : Modulo.DataEffettiva,
                                      Modulo : Modulo.Modulo,
                                      Catena : this.ObjDati.IdCatena
                                    }
              ObjQuery.Operazioni.push(ObjCatena)
            }
          }
        }
      }
      else
      {
        this.EventiMostrati.forEach((element) =>
        {
          if (element.Letto)
          {
            element.Letto = false
            for (let  i = 0; i < element.Moduli.length; i++)
            {
              if (element.Moduli[i].Letto)
              {
                let Modulo = element.Moduli[i]
                Modulo.Letto = false            
                let ObjCatena = {Query : 'SegnaComeNonLetto', Parametri: {}}
                ObjCatena.Parametri = {
                                        Data   : Modulo.DataEffettiva,
                                        Modulo : Modulo.Modulo,
                                        Catena : this.ObjDati.IdCatena
                                      }
                ObjQuery.Operazioni.push(ObjCatena)
              }
            }
          }
        })        
      }
      if (ObjQuery.Operazioni.length > 0)
      {
        SystemInformation.AdvQuerySiti.SessionId = SystemInformation.AdvQuery.SessionId          
        SystemInformation.AdvQuerySiti.PostSQL('EventiStoriciAcc', ObjQuery, 
                                                          function()
                                                          {
                                                          },
                                                          function(HTTPError,SubHTTPError,Response)
                                                          {
                                                            SystemInformation.HandleError(HTTPError,SubHTTPError,Response);
                                                          },
                                                          false, {DMSEWSito: this.ObjDati.IdSito})
      }
    },

    OnClickAnnullaCaricamentoDati()
    {
      this.OperazioneAnnullata = true
    },

    GetPorzioniDiDate()
    {
      if(this.ObjDal.Ora == undefined)
        this.ObjDal.Ora = 0
      if(this.ObjAl.Ora == undefined)
        this.ObjAl.Ora = 0

      if (!isNaN(parseInt(this.ObjDal.Ora)))
        this.ObjDal.Ora = parseInt(this.ObjDal.Ora)
      if (!isNaN(parseInt(this.ObjAl.Ora)))
        this.ObjAl.Ora = parseInt(this.ObjAl.Ora)

      let DallaOra = typeof this.ObjDal.Ora == 'number' ? (this.ObjDal.Ora < 10? '0' + this.ObjDal.Ora + ':00:00' : this.ObjDal.Ora + ':00:00') : this.ObjDal.Ora
      let AllaOra = typeof this.ObjAl.Ora == 'number' ? (this.ObjAl.Ora < 10? '0' + this.ObjAl.Ora + ':00:00' : this.ObjAl.Ora + ':00:00') : this.ObjAl.Ora

      let DataAl = this.ObjAl.Data + ' ' + AllaOra

      if (this.TipoGrafico == this.TipiStorici.EV_ACCELEROMETRICI_CRONOLOGIA)
      {
        DataAl = TZDateFunct.FormatDateTime('yyyy-mm-dd', TZDateFunct.ChangeDate(this.ObjAl.Data, 'day', 1)) + ' 00:00:00'
      }

      let DataDal = this.ObjDal.Data + ' ' + DallaOra

      // let ArrayVelocitaAccelerazione = [
      //                                    TIPOLOGIA_GRAFICI_STORICI.VELOCITA_MEDIA_GIORNALIERA,
      //                                    TIPOLOGIA_GRAFICI_STORICI.ACCELERAZIONE_MEDIA_GIORNALIERA,
      //                                    TIPOLOGIA_GRAFICI_STORICI.VELOCITA_MEDIA_ORARIA,
      //                                    TIPOLOGIA_GRAFICI_STORICI.ACCELERAZIONE_MEDIA_ORARIA
      //                                  ]
                          
      // if (ArrayVelocitaAccelerazione.includes(this.TipoGrafico))
      // {
      //   DataDal = TZDateFunct.FormatDateTime('yyyy-mm-dd hh:nn', TZDateFunct.ChangeDate(DataDal, 'hour', -1))
      // }
      
      this.VettorePorzioniDiDate = SystemInformation.GetPorzioniDiGiorni(DataDal, 
                                                                         DataAl)

      this.DalRicerca = TZGenericFunct.GetCopyOfObject(this.ObjDal)
      this.AlRicerca  = TZGenericFunct.GetCopyOfObject(this.ObjAl)
    },

    GetFiltroData()
    {
      if(this.ObjDati != null)
      {
        this.ObjDal = {
                        Data : TZDateFunct.DateInHTMLInputFormat(this.ObjDati.FiltroDallaData), //this.ObjDate.Dal.Data,
                        Ora  : this.ObjDati.FiltroDallaOra, //this.ObjDate.Dal.Orario
                      }
        this.ObjAl  = {
                        Data : TZDateFunct.DateInHTMLInputFormat(this.ObjDati.FiltroAllaData), //this.ObjDate.Al.Data,
                        Ora  : this.ObjDati.FiltroAllaOra, //this.ObjDate.Al.Orario
                      }
        this.GetPorzioniDiDate()
      }
    },

    FormattaDataGrafica(Data)
    {
      let DataFormattata = new Date(Data)
      return TZDateFunct.FormatDateTime('dd/mm/yyyy', DataFormattata)
    },

    // OnWindowScroll()
    // {
    //   let CurrentHeight        = this.$refs.ContainerSensori.getBoundingClientRect().y - 115
    //   let SingleElementoHeight = this.$refs.ContainerSensori.offsetHeight / this.ModuliMostrati.length
    //   for (let i = 0; i < this.ModuliMostrati.length; i++)
    //   {
    //     if ((i * SingleElementoHeight > -CurrentHeight && i * SingleElementoHeight < -CurrentHeight + this.AltezzaPagina - 50) ||
    //         ((i + 1) * SingleElementoHeight > -CurrentHeight && (i + 1) * SingleElementoHeight < -CurrentHeight + this.AltezzaPagina - 50))
    //     {
    //       this.ModuliMostrati[i].Disegna = true
    //     } 
    //   }
    // },

    OnClick24Ore()
    {
      let Today         = new Date()

      this.ObjAl.Data   = TZDateFunct.DateInHTMLInputFormat(Today)
      this.ObjAl.Ora    = 12
      
      this.ObjDal.Data  = TZDateFunct.DateInHTMLInputFormat(new Date(Today.setDate(Today.getDate() - 1)))
      this.ObjDal.Ora   = 12

      this.OnClickRicaricaDati()
    },

    OnClickApriImpostaAllarmi()
    {
      this.BackupSoglieAllarmi = { ...this.PopupImpostaAllarmiSoglie.Soglie };
      this.PopupImpostaAllarmiSoglie.EditSoglie = { 
                                                    Blu     : Number(this.PopupImpostaAllarmiSoglie.Soglie.Blu).toFixed(2),
                                                    Giallo  : Number(this.PopupImpostaAllarmiSoglie.Soglie.Giallo).toFixed(2),
                                                    Arancio : Number(this.PopupImpostaAllarmiSoglie.Soglie.Arancio).toFixed(2),
                                                    Rosso   : Number(this.PopupImpostaAllarmiSoglie.Soglie.Rosso).toFixed(2)
                                                  };
      this.PopupImpostaAllarmi = true
    },

    OnClickCancelImpostaAllarmi()
    {
      this.PopupImpostaAllarmiSoglie.Soglie = { ...this.BackupSoglieAllarmi };
      this.PopupImpostaAllarmiSoglie.EditSoglie = null;
      this.PopupImpostaAllarmi = false;
    },

    SoglieAllarmiDefault()
    {
      this.PopupImpostaAllarmiSoglie.EditSoglie = { ...this.PopupImpostaAllarmiSoglie.SoglieDefault };
    },

    AggiornaModuliNascosti()
    {
      this.ModuliNascosti = []

      if(this.Catena != undefined && this.Catena.Sensori != undefined && this.ModuliMostrati != undefined)
        this.ModuliNascosti = this.Catena.Sensori.filter(Sensore => !this.ModuliMostrati.includes(Sensore))
    },

    ConfermaSoglieAllarmi()
    { 
      const Edit = this.PopupImpostaAllarmiSoglie.EditSoglie;

      let ObjQuery = {Operazioni : []}
      let ObjCatena = {Query : 'UpdateSoglieAllarmi', Parametri: {}}
      ObjCatena.Parametri = {
                              CHIAVE              : this.ObjDati.IdCatena,
                              ALLARME_LVL_BLU     : Edit.Blu * 100,
                              ALLARME_LVL_GIALLO  : Edit.Giallo * 100,
                              ALLARME_LVL_ARANCIO : Edit.Arancio * 100,
                              ALLARME_LVL_ROSSO   : Edit.Rosso * 100
                            }
      ObjQuery.Operazioni.push(ObjCatena)
      if (ObjQuery.Operazioni.length > 0)
      {
        SystemInformation.AdvQuerySiti.SessionId = SystemInformation.AdvQuery.SessionId          
        SystemInformation.AdvQuerySiti.PostSQL('Catene', ObjQuery, 
                                                          () =>
                                                          {
                                                            this.PopupImpostaAllarmiSoglie.Soglie = { ...Edit };
                                                            this.PopupImpostaAllarmiSoglie.EditSoglie = null;
                                                            this.PopupImpostaAllarmi = false;
                                                          },
                                                          function(HTTPError,SubHTTPError,Response)
                                                          {
                                                            SystemInformation.HandleError(HTTPError,SubHTTPError,Response);
                                                          },
                                                          false, {DMSEWSito: this.ObjDati.IdSito})
      }
    }
  },

  computed:
  {
    EventiMostrati:
    {
      get()
      {
        this.ListaSuperamentiSoglia.forEach((Evento) =>
        {
          let StringModuli = ''
          let ArrayModuli = []
          Evento.Moduli.forEach((element) => 
          {
            let ObjModulo = this.Catena.Sensori.find((Modulo) => {return Modulo.Id == element.Modulo})
            if (ObjModulo.Selezionato && !ArrayModuli.includes(ObjModulo.Id))
            {
              ArrayModuli.push(ObjModulo.Id)
              if (StringModuli != '')
                StringModuli += ', '
              StringModuli += ObjModulo.Id
            }
          })
          Evento.StringModuli = StringModuli
        })
        let Result = this.ListaSuperamentiSoglia.filter((element) =>
        {
          return element.StringModuli != ''
        })
        return Result
      }
    },

    CheckValoreSoglie:
    {
      get()
      {
        return this.LivelliAllarme.TempAmpiezza.Primo < this.LivelliAllarme.TempAmpiezza.Secondo &&
               this.LivelliAllarme.TempAmpiezza.Secondo < this.LivelliAllarme.TempAmpiezza.Terzo &&
               this.LivelliAllarme.TempFrequenza.Primo < this.LivelliAllarme.TempFrequenza.Secondo &&
               this.LivelliAllarme.TempFrequenza.Secondo < this.LivelliAllarme.TempFrequenza.Terzo   
      }
    },
    
    ApriPopupAllineamentoAsseX:
    {
      get()
      {
        return this.MenuTrigger.ApriPopupAllineamentoAsseX 
      }
    },

    ApriPopupAllineamentoAsseInclinazioni:
    {
      get()
      {
        return this.MenuTrigger.ApriPopupAllineamentoAsseInclinometri
      }
    },

    ApriPopupAllineamentoAssePiezometri:
    {
      get()
      {
        return this.MenuTrigger.ApriPopupAllineamentoAssePiezometri
      }
    },

    ApriPopupAllineamentoAsseDeformazioni:
    {
      get()
      {
        return this.MenuTrigger.ApriPopupAllineamentoAsseDeformazioni
      }
    },
    
    ApriPopupAllineamentoAsseY:
    {
      get()
      {
        return this.MenuTrigger.ApriPopupAllineamentoAsseY 
      }
    },
    
    ApriPopupAllineamentoAsseTemp:
    {
      get()
      {
        return this.MenuTrigger.ApriPopupAllineamentoAsseTemp 
      }
    },

    ApriPopupImpostaAllarmi:
    {
      get()
      {
        return this.MenuTrigger.ApriPopupImpostaAllarmi
      }
    },

    ApriPopupScalaX:
    {
      get()
      {
        return this.MenuTrigger.ApriPopupScalaX
      }
    },

    ApriPopupScalaY:
    {
      get()
      {
        return this.MenuTrigger.ApriPopupScalaY
      }
    },

    ApriPopupScalaGraphX:
    {
      get()
      {
        return this.MenuTrigger.ApriPopupScalaGraphX
      }
    },

    ApriPopupScalaGraphY:
    {
      get()
      {
        return this.MenuTrigger.ApriPopupScalaGraphY
      }
    },

    ApriPopupScalaGraphZ:
    {
      get()
      {
        return this.MenuTrigger.ApriPopupScalaGraphZ
      }
    },

    ApriPopupColoreAmpiezzaX:
    {
      get()
      {
        return this.MenuTrigger.ApriPopupColoreAmpiezzaX
      }
    },

    TriggerMostraSoglieRilevamento:
    {
      get()
      {
        return this.MenuTrigger.TriggerMostraSoglieRilevamento
      }
    },

    TriggerNascondiSoglieRilevamento:
    {
      get()
      {
        return this.MenuTrigger.TriggerNascondiSoglieRilevamento
      }
    },

    ApriPopupColoreAmpiezzaY:
    {
      get()
      {
        return this.MenuTrigger.ApriPopupColoreAmpiezzaY
      }
    },

    ApriPopupColoreAmpiezzaZ:
    {
      get()
      {
        return this.MenuTrigger.ApriPopupColoreAmpiezzaZ
      }
    },

    ApriPopupColoreFrequenza:
    {
      get()
      {
        return this.MenuTrigger.ApriPopupColoreFrequenza
      }
    },

    ApriPopupAggiungiRighello:
    {
      get()
      {
        return this.MenuTrigger.ApriPopupAggiungiRighello
      }
    },

    ApriPopupEliminaRighello:
    {
      get()
      {
        return this.MenuTrigger.ApriPopupEliminaRighello
      }
    },
    
    TriggerEsportaPDF:
    {
      get()
      {
        return this.MenuTrigger.TriggerEsportaPDF 
      }
    },
    
    TriggerAdattaGrafici:
    {
      get()
      {
        return this.MenuTrigger.TriggerAdattaGrafici 
      }
    },

    EsportaXLSX:
    {
      get()
      {
        return this.MenuTrigger.StampaXLSX 
      }
    },

    LivelloBlu:
    {
      get()
      {
        return this.PopupImpostaAllarmiSoglie.EditSoglie.Blu == null ? this.PopupImpostaAllarmiSoglie.SoglieDefault.Blu : this.PopupImpostaAllarmiSoglie.EditSoglie.Blu;
      },
      set(Value)
      {
        this.PopupImpostaAllarmiSoglie.EditSoglie.Blu = parseFloat(Value);
      }
    },

    LivelloGiallo:
    {
      get()
      {
        return this.PopupImpostaAllarmiSoglie.EditSoglie.Giallo == null ? this.PopupImpostaAllarmiSoglie.SoglieDefault.Giallo : this.PopupImpostaAllarmiSoglie.EditSoglie.Giallo;
      },
      set(Value)
      {
        this.PopupImpostaAllarmiSoglie.EditSoglie.Giallo = parseFloat(Value);
      }
    },

    LivelloArancio:
    {
      get()
      {
        return this.PopupImpostaAllarmiSoglie.EditSoglie.Arancio == null ? this.PopupImpostaAllarmiSoglie.SoglieDefault.Arancio : this.PopupImpostaAllarmiSoglie.EditSoglie.Arancio;
      },
      set(Value)
      {
        this.PopupImpostaAllarmiSoglie.EditSoglie.Arancio = parseFloat(Value);
      }
    },

    LivelloRosso:
    {
      get()
      {
        return this.PopupImpostaAllarmiSoglie.EditSoglie.Rosso == null ? this.PopupImpostaAllarmiSoglie.SoglieDefault.Rosso : this.PopupImpostaAllarmiSoglie.EditSoglie.Rosso;
      },
      set(Value)
      {
        this.PopupImpostaAllarmiSoglie.EditSoglie.Rosso = parseFloat(Value);
      }
    },

    GraficiEventoSelezionato:
    {
      get()
      {
        if (this.EventoSelezionato != null && this.EventoSelezionato.Moduli != null)
        {
          let LsModuli = this.EventoSelezionato.Moduli
          LsModuli.sort(
                                              (ModuloA,ModuloB) => 
                                              {
                                                if(ModuloA.Modulo !== ModuloB.Modulo)
                                                {
                                                  return ModuloA.Modulo - ModuloB.Modulo;
                                                }

                                                const DataModuloA = new Date(ModuloA.DataEffettiva);
                                                const DataModuloB = new Date(ModuloB.DataEffettiva);
                                                
                                                if (DataModuloA.getTime() !== DataModuloB.getTime()) 
                                                {
                                                  return DataModuloA - DataModuloB;
                                                }

                                                return ModuloA.Profondita - ModuloB.Profondita;
                                              }
                                            )

          return  LsModuli.filter((element) =>
                  {
                    let ObjModulo = this.Catena.Sensori.find((Modulo) => {return Modulo.Id == element.Modulo})
                    return ObjModulo
                  })
        }
          
        return []
      }
    }
  },

  watch:
  {
    AltezzaPagina:
    {
      handler(NewValue)
      {
        this.AltezzaFrameCronologia = NewValue - 50 - 80 - 50
      }
    },
    
    ApriPopupAllineamentoAsseX:
    {
      handler()
      {
        this.OnClickAdattaAsseX()
      },
      deep : true
    },
    
    ApriPopupAllineamentoAsseInclinazioni:
    {
      handler()
      {
        this.OnClickAdattaAsseInclinazioni()
      },
      deep : true
    },
    
    ApriPopupAllineamentoAssePiezometri:
    {
      handler()
      {
        this.OnClickAdattaAssePiezometri()
      },
      deep : true
    },
    
    ApriPopupAllineamentoAsseDeformazioni:
    {
      handler()
      {
        this.OnClickAdattaAsseDeformazioni()
      },
      deep : true
    },
    
    ModuliMostrati:
    {
      handler()
      {
        this.AggiornaModuliNascosti()
      },
      deep : true
    },
    
    ApriPopupAllineamentoAsseY:
    {
      handler()
      {
        this.OnClickAdattaAsseY()
      },
      deep : true
    },
    
    ApriPopupAllineamentoAsseTemp:
    {
      handler()
      {
        this.OnClickAdattaAsseTemp()
      },
      deep : true
    },

    ApriPopupImpostaAllarmi:
    {
      handler()
      {
        this.OnClickApriImpostaAllarmi()
      },
      deep : true
    },

    ApriPopupScalaX:
    {
      handler()
      {
        this.OnClickChangeScalaXAccelerometri()
      },
      deep : true
    },

    ApriPopupScalaY:
    {
      handler()
      {
        this.OnClickChangeScalaYAccelerometri()
      },
      deep : true
    },

    ApriPopupScalaGraphX:
    {
      handler()
      {
        this.OnClickChangeScalaGraphXSupSoglie()
      },
      deep : true
    },

    ApriPopupScalaGraphY:
    {
      handler()
      {
        this.OnClickChangeScalaGraphYSupSoglie()
      },
      deep : true
    },

    ApriPopupScalaGraphZ:
    {
      handler()
      {
        this.OnClickChangeScalaGraphZSupSoglie()
      },
      deep : true
    },

    ApriPopupColoreAmpiezzaX:
    {
      handler()
      {
        this.OnClickChangeColoreAmpiezzaX()
      },
      deep : true
    },

    TriggerMostraSoglieRilevamento:
    {
      handler()
      {
        this.MostraAllSoglieRilevamento()
      },
      deep : true
    },

    TriggerNascondiSoglieRilevamento:
    {
      handler()
      {
        this.NascondiAllSoglieRilevamento()
      },
      deep : true
    },

    ApriPopupColoreAmpiezzaY:
    {
      handler()
      {
        this.OnClickChangeColoreAmpiezzaY()
      },
      deep : true
    },

    ApriPopupColoreAmpiezzaZ:
    {
      handler()
      {
        this.OnClickChangeColoreAmpiezzaZ()
      },
      deep : true
    },

    ApriPopupColoreFrequenza:
    {
      handler()
      {
        this.OnClickChangeColoreFrequenza()
      },
      deep : true
    },

    ApriPopupAggiungiRighello:
    {
      handler()
      {
        this.OnClickAggiungiRighelloAccelerometri()
      },
      deep : true
    },
    
    ApriPopupEliminaRighello:
    {
      handler()
      {
        this.OnClickEliminaRighelloAccelerometri()
      },
      deep : true
    },

    TriggerEsportaPDF:
    {
      handler()
      {
        this.EsportaComePDF()
      },
      deep : true
    },

    TriggerAdattaGrafici:
    {
      handler()
      {
        this.GraficiAdatta++
      },
      deep : true
    },

    EsportaXLSX:
    {
      handler()
      {
        if (this.TipoGrafico == this.TipiStorici.EV_ACCELEROMETRICI_SUP_SOGLIE)
          this.EsportaXLSXAllSupSoglie()
      },
      deep : true
    },
    
    // EventiMostrati:
    // {
    //   handler(NewValue)
    //   {
    //     if (NewValue.length === 0)
    //       this.Mostra = false
    //     else this.EvidenziaEvento(NewValue[0])
    //   }
    // }
  },

  beforeMount()
  {
    this.ObjPopupAsseY          = {
                                    Min : 999,
                                    Max : -999,
                                    Udm : 10
                                  }
    this.AltezzaFrameCronologia = this.AltezzaPagina - 50 - 80 - 50
    this.LivelliAllarme         = {
                                    Ampiezza      : {
                                                      Primo   : 200,
                                                      Secondo : 500,
                                                      Terzo   : 1_200
                                                    },
                                    Frequenza     : {
                                                      Primo   : 5,
                                                      Secondo : 10,
                                                      Terzo   : 100
                                                    },
                                    TempAmpiezza  : { 
                                                      Primo   : 200,
                                                      Secondo : 500,
                                                      Terzo   : 1_200
                                                    },
                                    TempFrequenza : { Primo   : 5,
                                                      Secondo : 10,
                                                      Terzo   : 100
                                                    },
                                  }
    this.ArrayGrafica1          = [
                                    TIPOLOGIA_GRAFICI_STORICI.CAMPIONI_RILEVATI,              
                                    TIPOLOGIA_GRAFICI_STORICI.SPOSTAMENTI_GRAFICI_SEPARATI,   
                                    TIPOLOGIA_GRAFICI_STORICI.SPOSTAMENTI_GRAFICI_SOVR,       
                                    TIPOLOGIA_GRAFICI_STORICI.VELOCITA_MEDIA_ORARIA,          
                                    TIPOLOGIA_GRAFICI_STORICI.VELOCITA_MEDIA_GIORNALIERA,     
                                    TIPOLOGIA_GRAFICI_STORICI.ACCELERAZIONE_MEDIA_ORARIA,     
                                    TIPOLOGIA_GRAFICI_STORICI.ACCELERAZIONE_MEDIA_GIORNALIERA,
                                    TIPOLOGIA_GRAFICI_STORICI.EV_ACCELEROMETRICI_SINTETICI_A,
                                    TIPOLOGIA_GRAFICI_STORICI.EV_ACCELEROMETRICI_SINTETICI_F,
                                    TIPOLOGIA_GRAFICI_STORICI.ASSORBIMENTO, 
                                    TIPOLOGIA_GRAFICI_STORICI.TENSIONE_ALIMENTAZIONE, 
                                    TIPOLOGIA_GRAFICI_STORICI.STAZIONE_METEO, 
                                  ]
    
    SystemInformation.AdvQuerySiti.SessionId = SystemInformation.AdvQuery.SessionId

    if(SystemInformation.OggettoInfoGraficiStorici.IdSito)
    {
      this.ObjDati = SystemInformation.OggettoInfoGraficiStorici
      this.TipoGrafico = SystemInformation.OggettoInfoGraficiStorici.TipoGrafico      
    }
    else
    {
      if(localStorage.getItem(LOCALSTORAGE.OggettoInfoGraficiStorici) != null)
      {
        let JsonOggetto = JSON.parse(localStorage.getItem(LOCALSTORAGE.OggettoInfoGraficiStorici))

        this.ObjDati = new TInfoGraficiStorici(JsonOggetto.IdSito, 
                                               JsonOggetto.IdCatena,
                                               JsonOggetto.Descrizione,
                                               JsonOggetto.TipoGrafico,
                                               JsonOggetto.ListaModuli,
                                               JsonOggetto.FiltroDallaData instanceof Date ? JsonOggetto.FiltroDallaData : new Date(JsonOggetto.FiltroDallaData), 
                                               JsonOggetto.FiltroAllaData instanceof Date ? JsonOggetto.FiltroAllaData : new Date(JsonOggetto.FiltroAllaData),
                                               JsonOggetto.FiltroDallaOra,
                                               JsonOggetto.FiltroAllaOra, 
                                               JsonOggetto.VisualizzaMarkup, 
                                               JsonOggetto.InterpMinimiQuadrati, 
                                               JsonOggetto.OrientamentoAsse, 
                                               JsonOggetto.PeriodoMedia)

        this.ObjDati.AllineamentoIncl      = JsonOggetto.AllineamentoIncl
        this.ObjDati.AllineamentoTemp      = JsonOggetto.AllineamentoTemp
        this.ObjDati.AllineamentoDef       = JsonOggetto.AllineamentoDef
        this.ObjDati.VisualizzaPluviometro = JsonOggetto.VisualizzaPluviometro
        this.ObjDati.VisualizzaAnemometro  = JsonOggetto.VisualizzaAnemometro
        this.ObjDati.VisualizzaTermometro  = JsonOggetto.VisualizzaTermometro
        this.ObjDati.VisualizzaSpostamento = JsonOggetto.VisualizzaSpostamento
        this.ObjDati.UrlRitornoAllaCatena  = JsonOggetto.UrlRitornoAllaCatena
        this.ObjDati.ListaFalde            = JsonOggetto.ListaFalde
        this.ObjDati.ListaTuttiModuli      = JsonOggetto.ListaTuttiModuli
       
        this.TipoGrafico                  = JsonOggetto.TipoGrafico
        SystemInformation.OggettoInfoGraficiStorici = this.ObjDati
      }
    }

    this.MenuTrigger.AggiornaMenu++   
    SystemInformation.TipoPopupAperto = this.TipoGrafico

    this.GraficSoloPiezometri   = this.ObjDati.ListaModuli.every((El) => El.Piezometro)
    this.GraficSoloEstensimetri = this.ObjDati.ListaModuli.every((El) => El.Estensimetro)

    switch(this.TipoGrafico)
    {
      case TIPOLOGIA_GRAFICI_STORICI.CAMPIONI_RILEVATI               : this.UdmAdattamento = '[' + this.GetTraduzioneLabel('UdmGenerali', 'TKN_SIMBOLO_GRADI', this.LinguaUtente) + ']'; break
      case TIPOLOGIA_GRAFICI_STORICI.SPOSTAMENTI_GRAFICI_SEPARATI    : this.UdmAdattamento = '[' + this.GetTraduzioneLabel('UdmGenerali', 'TKN_MILLIMETRI', this.LinguaUtente) + ']'; break
      case TIPOLOGIA_GRAFICI_STORICI.VELOCITA_MEDIA_ORARIA           : 
      case TIPOLOGIA_GRAFICI_STORICI.VELOCITA_MEDIA_GIORNALIERA      : this.UdmAdattamento = '[' + this.GetTraduzioneLabel('UdmGenerali', 'TKN_MM_H', this.LinguaUtente) + ']'; break
      case TIPOLOGIA_GRAFICI_STORICI.ACCELERAZIONE_MEDIA_ORARIA      : 
      case TIPOLOGIA_GRAFICI_STORICI.ACCELERAZIONE_MEDIA_GIORNALIERA : this.UdmAdattamento = '[' + this.GetTraduzioneLabel('UdmGenerali', 'TKN_MM_2H', this.LinguaUtente) + ']'; break
      case TIPOLOGIA_GRAFICI_STORICI.EV_ACCELEROMETRICI_SUP_SOGLIE   : this.UdmAdattamento = '[' + this.GetTraduzioneLabel('UdmGenerali', 'TKN_MILLIGRAMMO', this.LinguaUtente) + ']'; break
      default                                                        : this.UdmAdattamento = null;                                                                                    break
    }

    let AxisY               = {}
    AxisY.Max               = 0
    AxisY.Min               = 0
    AxisY.Udm               = 0
    this.Allineamento.AxisY = AxisY

    let AxisYDef               = {}
    AxisYDef.Max               = 0
    AxisYDef.Min               = 0
    AxisYDef.Udm               = 0
    this.Allineamento.AxisYDef = AxisYDef

    let AxisYPress               = {}
    AxisYPress.Max               = 0
    AxisYPress.Min               = 0
    AxisYPress.Udm               = 0
    this.Allineamento.AxisYPress = AxisYPress

    let AxisX               = {}
    AxisX.TipoUdmX          = 0
    AxisX.UdmX              = 1
    this.Allineamento.AxisX = AxisX

    let AxisTemp               = {}
    AxisTemp.Max               = 0
    AxisTemp.Min               = 0
    AxisTemp.Udm               = 0
    this.Allineamento.AxisTemp = AxisTemp

    if(this.TipoGrafico == TIPOLOGIA_GRAFICI_STORICI.CAMPIONI_RILEVATI)
      this.TerzoAssePresente = true

    if (this.TipoGrafico == TIPOLOGIA_GRAFICI_STORICI.EV_ACCELEROMETRICI_CRONOLOGIA)
    {
      this.Stacking = 1
      this.ObjDati.FiltroAllaOra = "23:00"
    }
    
    if(this.ObjDati != null)
    {
      this.GetFiltroData()

      this.Catena = {}
      this.Catena.Sensori = this.ObjDati.ListaModuli
      this.Catena.Sensori.forEach(function(Elemento)
                                  {
                                    Elemento.Dati = []
                                    Elemento.Selezionato = true
                                  })

      if(this.ObjDati.AllineamentoIncl != null || this.ObjDati.AllineamentoDef != null || this.ObjDati.AllineamentoTemp != null)
      {
        let Self = this
        
        let ListaModuli = ''

        for(let i = 0; i < this.ObjDati.ListaModuli.length; i++)
          ListaModuli += this.ObjDati.ListaModuli[i].Id + ','

        if(ListaModuli != '')
          ListaModuli = ListaModuli.substring(0, ListaModuli.length - 1);
        
        SystemInformation.AdvQuerySiti.SessionId = SystemInformation.AdvQuery.SessionId

        let Parametri = {}
        Parametri.ChiaveCatena = this.ObjDati.IdCatena
        Parametri.DMSEWSito    = this.ObjDati.IdSito
        Parametri.ListaModuli  = ListaModuli

        Parametri.DallaDataIncl   = '1900-01-01 00:00:00'
        Parametri.AllaDataIncl    = '1900-01-01 00:00:01'

        if(this.ObjDati.AllineamentoIncl != null)
        {
          Parametri.DallaDataIncl = this.ObjDati.AllineamentoIncl.DataAllineamento + ' ' + this.ObjDati.AllineamentoIncl.OrarioAllineamento + ':00'
          Parametri.AllaDataIncl  = this.ObjDati.AllineamentoIncl.DataAllineamento + ' ' + this.ObjDati.AllineamentoIncl.OrarioAllineamento + ':59'
        }

        Parametri.DallaDataDef    = '1900-01-01 00:00:00'
        Parametri.AllaDataDef     = '1900-01-01 00:00:01'

        if(this.ObjDati.AllineamentoDef != null)
        {
          Parametri.DallaDataDef  = this.ObjDati.AllineamentoDef.DataAllineamento + ' ' + this.ObjDati.AllineamentoDef.OrarioAllineamento + ':00'
          Parametri.AllaDataDef   = this.ObjDati.AllineamentoDef.DataAllineamento + ' ' + this.ObjDati.AllineamentoDef.OrarioAllineamento + ':59'
        }

        Parametri.DallaDataTemp   = '1900-01-01 00:00:00'
        Parametri.AllaDataTemp    = '1900-01-01 00:00:01'

        if(this.ObjDati.AllineamentoTemp != null)
        {
          Parametri.DallaDataTemp = this.ObjDati.AllineamentoTemp.DataAllineamento + ' ' + this.ObjDati.AllineamentoTemp.OrarioAllineamento + ':00'
          Parametri.AllaDataTemp  = this.ObjDati.AllineamentoTemp.DataAllineamento + ' ' + this.ObjDati.AllineamentoTemp.OrarioAllineamento + ':59'
        }

        SystemInformation.AdvQuerySiti.GetSQL('Catene', 
                                              Parametri,
                                              function(Results)
                                              {
                                                let ArrayInfoIncl = SystemInformation.AdvQuery.FindResults(Results, 'Inclinazioni')
                                                let ArrayInfoDef  = SystemInformation.AdvQuery.FindResults(Results, 'Deformazioni')
                                                let ArrayInfoTemp = SystemInformation.AdvQuery.FindResults(Results, 'Temperatura')

                                                if(ArrayInfoIncl != undefined && Self.ObjDati.AllineamentoIncl != null)
                                                  Self.ObjDati.AllineamentoIncl.Dati = ArrayInfoIncl

                                                if(ArrayInfoDef != undefined && Self.ObjDati.AllineamentoDef != null)
                                                  Self.ObjDati.AllineamentoDef.Dati  = ArrayInfoDef

                                                if(ArrayInfoTemp != undefined && Self.ObjDati.AllineamentoTemp != null)
                                                  Self.ObjDati.AllineamentoTemp.Dati = ArrayInfoTemp

                                                Self.MixInsDownloadDatiAcquisitiModuli(Self.Catena) 
                                              },
                                              SystemInformation.HandleError, 
                                              'SelectDataAllineamento'); 
      }
      else this.MixInsDownloadDatiAcquisitiModuli(this.Catena) 

      let self = this;
      let Parametri = { 
                        CHIAVE    : this.ObjDati.IdCatena,
                        DMSEWSito : this.ObjDati.IdSito
                      };

      SystemInformation.AdvQuerySiti.SessionId = SystemInformation.AdvQuery.SessionId;
      SystemInformation.AdvQuerySiti.GetSQL('Catene',
                                            Parametri,
                                            function(Results) 
                                            {
                                              let ArrayLvlAllarmi = SystemInformation.AdvQuery.FindResults(Results, 'SoglieAllarmi');
                                              if (ArrayLvlAllarmi && ArrayLvlAllarmi.length > 0) 
                                              {
                                                let Soglie = ArrayLvlAllarmi[0];
                                                self.PopupImpostaAllarmiSoglie.Soglie = 
                                                {
                                                   Blu     : Soglie.ALLARME_LVL_BLU / 100,
                                                   Giallo  : Soglie.ALLARME_LVL_GIALLO / 100,
                                                   Arancio : Soglie.ALLARME_LVL_ARANCIO / 100,
                                                   Rosso   : Soglie.ALLARME_LVL_ROSSO / 100
                                                };
                                              }
                                            },
                                            SystemInformation.HandleError,
                                            'SelectSoglieAllarmi'
                                          );
    }
  },
}
</script>
